(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["Editable"] = factory(require("jQuery"));
	else
		root["Editable"] = factory(root["jQuery"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	var _error = __webpack_require__(32);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _block = __webpack_require__(46);
	
	var block = _interopRequireWildcard(_block);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _clipboard = __webpack_require__(47);
	
	var clipboard = _interopRequireWildcard(_clipboard);
	
	var _dispatcher = __webpack_require__(69);
	
	var _dispatcher2 = _interopRequireDefault(_dispatcher);
	
	var _cursor = __webpack_require__(25);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _highlightSupport = __webpack_require__(30);
	
	var _highlightSupport2 = _interopRequireDefault(_highlightSupport);
	
	var _highlighting = __webpack_require__(70);
	
	var _highlighting2 = _interopRequireDefault(_highlighting);
	
	var _createDefaultEvents = __webpack_require__(68);
	
	var _createDefaultEvents2 = _interopRequireDefault(_createDefaultEvents);
	
	var _bowser = __webpack_require__(54);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The Core module provides the Editable class that defines the Editable.JS
	 * API and is the main entry point for Editable.JS.
	 * It also provides the cursor module for cross-browser cursors, and the dom
	 * submodule.
	 *
	 * @module core
	 */
	
	/**
	 * Constructor for the Editable.JS API that is externally visible.
	 *
	 * @param {Object} configuration for this editable instance.
	 *   window: The window where to attach the editable events.
	 *   defaultBehavior: {Boolean} Load default-behavior.js.
	 *   mouseMoveSelectionChanges: {Boolean} Whether to get cursor and selection events on mousemove.
	 *   browserSpellcheck: {Boolean} Set the spellcheck attribute on editable elements
	 *
	 * @class Editable
	 */
	
	var Editable = module.exports = function () {
	  function Editable(instanceConfig) {
	    (0, _classCallCheck3.default)(this, Editable);
	
	    var defaultInstanceConfig = {
	      window: window,
	      defaultBehavior: true,
	      mouseMoveSelectionChanges: false,
	      browserSpellcheck: true
	    };
	
	    this.config = _jquery2.default.extend(defaultInstanceConfig, instanceConfig);
	    this.win = this.config.window;
	    this.editableSelector = '.' + config.editableClass;
	
	    if (!_rangy2.default.initialized) {
	      _rangy2.default.init();
	    }
	
	    this.dispatcher = new _dispatcher2.default(this);
	    if (this.config.defaultBehavior === true) {
	      this.dispatcher.on((0, _createDefaultEvents2.default)(this));
	    }
	  }
	
	  /**
	   * @returns the default Editable configs from config.js
	   */
	
	
	  (0, _createClass3.default)(Editable, [{
	    key: 'add',
	
	
	    /**
	     * Adds the Editable.JS API to the given target elements.
	     * Opposite of {{#crossLink "Editable/remove"}}{{/crossLink}}.
	     * Calls dispatcher.setup to setup all event listeners.
	     *
	     * @method add
	     * @param {HTMLElement|Array(HTMLElement)|String} target A HTMLElement, an
	     *    array of HTMLElement or a query selector representing the target where
	     *    the API should be added on.
	     * @chainable
	     */
	    value: function add(target) {
	      this.enable((0, _jquery2.default)(target));
	      // todo: check css whitespace settings
	      return this;
	    }
	
	    /**
	     * Removes the Editable.JS API from the given target elements.
	     * Opposite of {{#crossLink "Editable/add"}}{{/crossLink}}.
	     *
	     * @method remove
	     * @param {HTMLElement|Array(HTMLElement)|String} target A HTMLElement, an
	     *    array of HTMLElement or a query selector representing the target where
	     *    the API should be removed from.
	     * @chainable
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(target) {
	      var $target = (0, _jquery2.default)(target);
	      this.disable($target);
	      $target.removeClass(config.editableDisabledClass);
	      return this;
	    }
	
	    /**
	    * Removes the Editable.JS API from the given target elements.
	    * The target elements are marked as disabled.
	    *
	    * @method disable
	    * @param { jQuery element | undefined  } target editable root element(s)
	    *    If no param is specified all editables are disabled.
	    * @chainable
	    */
	
	  }, {
	    key: 'disable',
	    value: function disable($elem) {
	      var body = this.win.document.body;
	      $elem = $elem || (0, _jquery2.default)('.' + config.editableClass, body);
	      $elem.each(function (i, el) {
	        return block.disable(el);
	      });
	
	      return this;
	    }
	
	    /**
	    * Adds the Editable.JS API to the given target elements.
	    *
	    * @method enable
	    * @param { jQuery element | undefined } target editable root element(s)
	    *    If no param is specified all editables marked as disabled are enabled.
	    * @chainable
	    */
	
	  }, {
	    key: 'enable',
	    value: function enable($elem, normalize) {
	      var _this = this;
	
	      var body = this.win.document.body;
	      $elem = $elem || (0, _jquery2.default)('.' + config.editableDisabledClass, body);
	
	      var shouldSpellcheck = this.config.browserSpellcheck;
	      $elem.each(function (i, el) {
	        block.init(el, { normalize: normalize, shouldSpellcheck: shouldSpellcheck });
	        _this.dispatcher.notify('init', el);
	      });
	
	      return this;
	    }
	
	    /**
	    * Temporarily disable an editable.
	    * Can be used to prevent text selction while dragging an element
	    * for example.
	    *
	    * @method suspend
	    * @param jQuery object
	    */
	
	  }, {
	    key: 'suspend',
	    value: function suspend($elem) {
	      var body = this.win.document.body;
	      $elem = $elem || (0, _jquery2.default)('.' + config.editableClass, body);
	
	      $elem.removeAttr('contenteditable');
	      this.dispatcher.suspend();
	      return this;
	    }
	
	    /**
	    * Reverse the effects of suspend()
	    *
	    * @method continue
	    * @param jQuery object
	    */
	
	  }, {
	    key: 'continue',
	    value: function _continue($elem) {
	      var body = this.win.document.body;
	      $elem = $elem || (0, _jquery2.default)('.' + config.editableClass, body);
	
	      $elem.attr('contenteditable', true);
	      this.dispatcher.continue();
	      return this;
	    }
	    /**
	     * Set the cursor inside of an editable block.
	     *
	     * @method createCursor
	     * @param position 'beginning', 'end', 'before', 'after'
	     */
	
	  }, {
	    key: 'createCursor',
	    value: function createCursor(element) {
	      var position = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'beginning';
	
	      var $host = (0, _jquery2.default)(element).closest(this.editableSelector);
	
	      if (!$host.length) return undefined;
	
	      var range = _rangy2.default.createRange();
	
	      if (position === 'beginning' || position === 'end') {
	        range.selectNodeContents(element);
	        range.collapse(position === 'beginning');
	      } else if (element !== $host[0]) {
	        if (position === 'before') {
	          range.setStartBefore(element);
	          range.setEndBefore(element);
	        } else if (position === 'after') {
	          range.setStartAfter(element);
	          range.setEndAfter(element);
	        }
	      } else {
	        (0, _error2.default)('EditableJS: cannot create cursor outside of an editable block.');
	      }
	
	      return new _cursor2.default($host[0], range);
	    }
	  }, {
	    key: 'createCursorAtBeginning',
	    value: function createCursorAtBeginning(element) {
	      return this.createCursor(element, 'beginning');
	    }
	  }, {
	    key: 'createCursorAtEnd',
	    value: function createCursorAtEnd(element) {
	      return this.createCursor(element, 'end');
	    }
	  }, {
	    key: 'createCursorBefore',
	    value: function createCursorBefore(element) {
	      return this.createCursor(element, 'before');
	    }
	  }, {
	    key: 'createCursorAfter',
	    value: function createCursorAfter(element) {
	      return this.createCursor(element, 'after');
	    }
	
	    /**
	     * Extract the content from an editable host or document fragment.
	     * This method will remove all internal elements and ui-elements.
	     *
	     * @param {DOM node or Document Fragment} The innerHTML of this element or fragment will be extracted.
	     * @returns {String} The cleaned innerHTML.
	     */
	
	  }, {
	    key: 'getContent',
	    value: function getContent(element) {
	      return content.extractContent(element);
	    }
	
	    /**
	     * @param {String | DocumentFragment} content to append.
	     * @returns {Cursor} A new Cursor object just before the inserted content.
	     */
	
	  }, {
	    key: 'appendTo',
	    value: function appendTo(inputElement, contentToAppend) {
	      var element = content.adoptElement(inputElement, this.win.document);
	
	      var cursor = this.createCursor(element, 'end');
	      // todo: create content in the right window
	      cursor.insertAfter(typeof contentToAppend === 'string' ? content.createFragmentFromString(contentToAppend) : contentToAppend);
	      return cursor;
	    }
	
	    /**
	     * @param {String | DocumentFragment} content to prepend
	     * @returns {Cursor} A new Cursor object just after the inserted content.
	     */
	
	  }, {
	    key: 'prependTo',
	    value: function prependTo(inputElement, contentToPrepend) {
	      var element = content.adoptElement(inputElement, this.win.document);
	
	      var cursor = this.createCursor(element, 'beginning');
	      // todo: create content in the right window
	      cursor.insertBefore(typeof contentToPrepend === 'string' ? content.createFragmentFromString(contentToPrepend) : contentToPrepend);
	      return cursor;
	    }
	
	    /**
	     * Get the current selection.
	     * Only returns something if the selection is within an editable element.
	     * If you pass an editable host as param it only returns something if the selection is inside this
	     * very editable element.
	     *
	     * @param {DOMNode} Optional. An editable host where the selection needs to be contained.
	     * @returns A Cursor or Selection object or undefined.
	     */
	
	  }, {
	    key: 'getSelection',
	    value: function getSelection(editableHost) {
	      var selection = this.dispatcher.selectionWatcher.getFreshSelection();
	      if (!(editableHost && selection)) return selection;
	
	      var range = selection.range;
	      // Check if the selection is inside the editableHost
	      // The try...catch is required if the editableHost was removed from the DOM.
	      try {
	        if (range.compareNode(editableHost) !== range.NODE_BEFORE_AND_AFTER) {
	          selection = undefined;
	        }
	      } catch (e) {
	        selection = undefined;
	      }
	
	      return selection;
	    }
	
	    /**
	     * Enable spellchecking
	     *
	     * @chainable
	     */
	
	  }, {
	    key: 'setupHighlighting',
	    value: function setupHighlighting(hightlightingConfig) {
	      this.highlighting = new _highlighting2.default(this, hightlightingConfig);
	
	      return this;
	    }
	
	    // For backwards compatibility
	
	  }, {
	    key: 'setupSpellcheck',
	    value: function setupSpellcheck(config) {
	      var _this2 = this;
	
	      var marker = void 0;
	
	      if (config.markerNode) {
	        marker = config.markerNode.outerHTML;
	      }
	
	      this.setupHighlighting({
	        throttle: config.throttle,
	        spellcheck: {
	          marker: marker,
	          spellcheckService: config.spellcheckService
	        }
	      });
	
	      this.spellcheck = {
	        checkSpelling: function checkSpelling(elem) {
	          _this2.highlighting.highlight(elem);
	        }
	      };
	    }
	
	    /**
	     * Highlight text within an editable.
	     *
	     * By default highlights all occurences of `text`.
	     * Pass it a `textRange` object to highlight a
	     * specific text portion.
	     *
	     * The markup used for the highlighting will be removed
	     * from the final content.
	     *
	     *
	     * @param  {Object} options
	     * @param  {DOMNode} options.editableHost
	     * @param  {String} options.text
	     * @param  {String} options.highlightId Added to the highlight markups in the property `data-word-id`
	     * @param  {Object} [options.textRange] An optional range which gets used to set the markers.
	     * @param  {Number} options.textRange.start
	     * @param  {Number} options.textRange.end
	     * @param  {Boolean} options.raiseEvents do throw change events
	     * @return {Number} The text-based start offset of the newly applied highlight or `-1` if the range was considered invalid.
	     */
	
	  }, {
	    key: 'highlight',
	    value: function highlight(_ref) {
	      var editableHost = _ref.editableHost,
	          text = _ref.text,
	          highlightId = _ref.highlightId,
	          textRange = _ref.textRange,
	          raiseEvents = _ref.raiseEvents;
	
	      if (!textRange) {
	        return _highlightSupport2.default.highlightText(editableHost, text, highlightId);
	      }
	      if (typeof textRange.start !== 'number' || typeof textRange.end !== 'number') {
	        (0, _error2.default)('Error in Editable.highlight: You passed a textRange object with invalid keys. Expected shape: { start: Number, end: Number }');
	        return -1;
	      }
	      if (textRange.start === textRange.end) {
	        (0, _error2.default)('Error in Editable.highlight: You passed a textRange object with equal start and end offsets, which is considered a cursor and therefore unfit to create a highlight.');
	        return -1;
	      }
	      return _highlightSupport2.default.highlightRange(editableHost, highlightId, textRange.start, textRange.end, raiseEvents ? this.dispatcher : undefined);
	    }
	
	    /**
	     * Extracts positions of all DOMNodes that match `[data-word-id]`.
	     *
	     * Returns an object where the keys represent a highlight id and the value
	     * a text range object of shape:
	     * ```
	     * { start: number, end: number, text: string}
	     * ```
	     *
	     * @param  {Object} options
	     * @param  {DOMNode} options.editableHos
	     * @return {Object} ranges
	     */
	
	  }, {
	    key: 'getHighlightPositions',
	    value: function getHighlightPositions(_ref2) {
	      var editableHost = _ref2.editableHost;
	
	      return _highlightSupport2.default.extractHighlightedRanges(editableHost);
	    }
	  }, {
	    key: 'removeHighlight',
	    value: function removeHighlight(_ref3) {
	      var editableHost = _ref3.editableHost,
	          highlightId = _ref3.highlightId,
	          raiseEvents = _ref3.raiseEvents;
	
	      _highlightSupport2.default.removeHighlight(editableHost, highlightId, raiseEvents ? this.dispatcher : undefined);
	    }
	  }, {
	    key: 'decorateHighlight',
	    value: function decorateHighlight(_ref4) {
	      var editableHost = _ref4.editableHost,
	          highlightId = _ref4.highlightId,
	          addCssClass = _ref4.addCssClass,
	          removeCssClass = _ref4.removeCssClass;
	
	      _highlightSupport2.default.updateHighlight(editableHost, highlightId, addCssClass, removeCssClass);
	    }
	
	    /**
	     * Subscribe a callback function to a custom event fired by the API.
	     *
	     * @param {String} event The name of the event.
	     * @param {Function} handler The callback to execute in response to the
	     *     event.
	     *
	     * @chainable
	     */
	
	  }, {
	    key: 'on',
	    value: function on(event, handler) {
	      // TODO throw error if event is not one of EVENTS
	      // TODO throw error if handler is not a function
	      this.dispatcher.on(event, handler);
	      return this;
	    }
	
	    /**
	     * Unsubscribe a callback function from a custom event fired by the API.
	     * Opposite of {{#crossLink "Editable/on"}}{{/crossLink}}.
	     *
	     * @param {String} event The name of the event.
	     * @param {Function} handler The callback to remove from the
	     *     event or the special value false to remove all callbacks.
	     *
	     * @chainable
	     */
	
	  }, {
	    key: 'off',
	    value: function off() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      this.dispatcher.off.apply(this.dispatcher, args);
	      return this;
	    }
	
	    /**
	     * Unsubscribe all callbacks and event listeners.
	     *
	     * @chainable
	     */
	
	  }, {
	    key: 'unload',
	    value: function unload() {
	      this.dispatcher.unload();
	      return this;
	    }
	  }], [{
	    key: 'getGlobalConfig',
	    value: function getGlobalConfig() {
	      return config;
	    }
	
	    /**
	    * Set configuration options that affect all editable
	    * instances.
	    *
	    * @param {Object} global configuration options (defaults are defined in config.js)
	    *   log: {Boolean}
	    *   logErrors: {Boolean}
	    *   editableClass: {String} e.g. 'js-editable'
	    *   editableDisabledClass: {String} e.g. 'js-editable-disabled'
	    *   pastingAttribute: {String} default: e.g. 'data-editable-is-pasting'
	    *   boldTag: e.g. '<strong>'
	    *   italicTag: e.g. '<em>'
	    */
	
	  }, {
	    key: 'globalConfig',
	    value: function globalConfig(_globalConfig) {
	      _jquery2.default.extend(config, _globalConfig);
	      clipboard.updateConfig(config);
	    }
	  }]);
	  return Editable;
	}();
	
	// Expose modules and editable
	Editable.parser = parser;
	Editable.content = content;
	Editable.browser = _bowser2.default
	
	// Set up callback functions for several events.
	;['focus', 'blur', 'flow', 'selection', 'cursor', 'newline', 'insert', 'split', 'merge', 'empty', 'change', 'switch', 'move', 'clipboard', 'paste'].forEach(function (name) {
	  // Generate a callback function to subscribe to an event.
	  Editable.prototype[name] = function (handler) {
	    return this.on(name, handler);
	  };
	});

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(81);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(41)('wks');
	var uid = __webpack_require__(29);
	var Symbol = __webpack_require__(10).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// DOM node types
	// https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
	
	var elementNode = exports.elementNode = 1;
	var attributeNode = exports.attributeNode = 2;
	var textNode = exports.textNode = 3;
	var cdataSectionNode = exports.cdataSectionNode = 4;
	var entityReferenceNode = exports.entityReferenceNode = 5;
	var entityNode = exports.entityNode = 6;
	var processingInstructionNode = exports.processingInstructionNode = 7;
	var commentNode = exports.commentNode = 8;
	var documentNode = exports.documentNode = 9;
	var documentTypeNode = exports.documentTypeNode = 10;
	var documentFragmentNode = exports.documentFragmentNode = 11;
	var notationNode = exports.notationNode = 12;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory();
	    } else {
	        // No AMD or CommonJS support so we place Rangy in (probably) the global variable
	        root.rangy = factory();
	    }
	})(function() {
	
	    var OBJECT = "object", FUNCTION = "function", UNDEFINED = "undefined";
	
	    // Minimal set of properties required for DOM Level 2 Range compliance. Comparison constants such as START_TO_START
	    // are omitted because ranges in KHTML do not have them but otherwise work perfectly well. See issue 113.
	    var domRangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	        "commonAncestorContainer"];
	
	    // Minimal set of methods required for DOM Level 2 Range compliance
	    var domRangeMethods = ["setStart", "setStartBefore", "setStartAfter", "setEnd", "setEndBefore",
	        "setEndAfter", "collapse", "selectNode", "selectNodeContents", "compareBoundaryPoints", "deleteContents",
	        "extractContents", "cloneContents", "insertNode", "surroundContents", "cloneRange", "toString", "detach"];
	
	    var textRangeProperties = ["boundingHeight", "boundingLeft", "boundingTop", "boundingWidth", "htmlText", "text"];
	
	    // Subset of TextRange's full set of methods that we're interested in
	    var textRangeMethods = ["collapse", "compareEndPoints", "duplicate", "moveToElementText", "parentElement", "select",
	        "setEndPoint", "getBoundingClientRect"];
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Trio of functions taken from Peter Michaux's article:
	    // http://peter.michaux.ca/articles/feature-detection-state-of-the-art-browser-scripting
	    function isHostMethod(o, p) {
	        var t = typeof o[p];
	        return t == FUNCTION || (!!(t == OBJECT && o[p])) || t == "unknown";
	    }
	
	    function isHostObject(o, p) {
	        return !!(typeof o[p] == OBJECT && o[p]);
	    }
	
	    function isHostProperty(o, p) {
	        return typeof o[p] != UNDEFINED;
	    }
	
	    // Creates a convenience function to save verbose repeated calls to tests functions
	    function createMultiplePropertyTest(testFunc) {
	        return function(o, props) {
	            var i = props.length;
	            while (i--) {
	                if (!testFunc(o, props[i])) {
	                    return false;
	                }
	            }
	            return true;
	        };
	    }
	
	    // Next trio of functions are a convenience to save verbose repeated calls to previous two functions
	    var areHostMethods = createMultiplePropertyTest(isHostMethod);
	    var areHostObjects = createMultiplePropertyTest(isHostObject);
	    var areHostProperties = createMultiplePropertyTest(isHostProperty);
	
	    function isTextRange(range) {
	        return range && areHostMethods(range, textRangeMethods) && areHostProperties(range, textRangeProperties);
	    }
	
	    function getBody(doc) {
	        return isHostObject(doc, "body") ? doc.body : doc.getElementsByTagName("body")[0];
	    }
	
	    var forEach = [].forEach ?
	        function(arr, func) {
	            arr.forEach(func);
	        } :
	        function(arr, func) {
	            for (var i = 0, len = arr.length; i < len; ++i) {
	                func(arr[i], i);
	            }
	        };
	
	    var modules = {};
	
	    var isBrowser = (typeof window != UNDEFINED && typeof document != UNDEFINED);
	
	    var util = {
	        isHostMethod: isHostMethod,
	        isHostObject: isHostObject,
	        isHostProperty: isHostProperty,
	        areHostMethods: areHostMethods,
	        areHostObjects: areHostObjects,
	        areHostProperties: areHostProperties,
	        isTextRange: isTextRange,
	        getBody: getBody,
	        forEach: forEach
	    };
	
	    var api = {
	        version: "1.3.0",
	        initialized: false,
	        isBrowser: isBrowser,
	        supported: true,
	        util: util,
	        features: {},
	        modules: modules,
	        config: {
	            alertOnFail: false,
	            alertOnWarn: false,
	            preferTextRange: false,
	            autoInitialize: (typeof rangyAutoInitialize == UNDEFINED) ? true : rangyAutoInitialize
	        }
	    };
	
	    function consoleLog(msg) {
	        if (typeof console != UNDEFINED && isHostMethod(console, "log")) {
	            console.log(msg);
	        }
	    }
	
	    function alertOrLog(msg, shouldAlert) {
	        if (isBrowser && shouldAlert) {
	            alert(msg);
	        } else  {
	            consoleLog(msg);
	        }
	    }
	
	    function fail(reason) {
	        api.initialized = true;
	        api.supported = false;
	        alertOrLog("Rangy is not supported in this environment. Reason: " + reason, api.config.alertOnFail);
	    }
	
	    api.fail = fail;
	
	    function warn(msg) {
	        alertOrLog("Rangy warning: " + msg, api.config.alertOnWarn);
	    }
	
	    api.warn = warn;
	
	    // Add utility extend() method
	    var extend;
	    if ({}.hasOwnProperty) {
	        util.extend = extend = function(obj, props, deep) {
	            var o, p;
	            for (var i in props) {
	                if (props.hasOwnProperty(i)) {
	                    o = obj[i];
	                    p = props[i];
	                    if (deep && o !== null && typeof o == "object" && p !== null && typeof p == "object") {
	                        extend(o, p, true);
	                    }
	                    obj[i] = p;
	                }
	            }
	            // Special case for toString, which does not show up in for...in loops in IE <= 8
	            if (props.hasOwnProperty("toString")) {
	                obj.toString = props.toString;
	            }
	            return obj;
	        };
	
	        util.createOptions = function(optionsParam, defaults) {
	            var options = {};
	            extend(options, defaults);
	            if (optionsParam) {
	                extend(options, optionsParam);
	            }
	            return options;
	        };
	    } else {
	        fail("hasOwnProperty not supported");
	    }
	
	    // Test whether we're in a browser and bail out if not
	    if (!isBrowser) {
	        fail("Rangy can only run in a browser");
	    }
	
	    // Test whether Array.prototype.slice can be relied on for NodeLists and use an alternative toArray() if not
	    (function() {
	        var toArray;
	
	        if (isBrowser) {
	            var el = document.createElement("div");
	            el.appendChild(document.createElement("span"));
	            var slice = [].slice;
	            try {
	                if (slice.call(el.childNodes, 0)[0].nodeType == 1) {
	                    toArray = function(arrayLike) {
	                        return slice.call(arrayLike, 0);
	                    };
	                }
	            } catch (e) {}
	        }
	
	        if (!toArray) {
	            toArray = function(arrayLike) {
	                var arr = [];
	                for (var i = 0, len = arrayLike.length; i < len; ++i) {
	                    arr[i] = arrayLike[i];
	                }
	                return arr;
	            };
	        }
	
	        util.toArray = toArray;
	    })();
	
	    // Very simple event handler wrapper function that doesn't attempt to solve issues such as "this" handling or
	    // normalization of event properties
	    var addListener;
	    if (isBrowser) {
	        if (isHostMethod(document, "addEventListener")) {
	            addListener = function(obj, eventType, listener) {
	                obj.addEventListener(eventType, listener, false);
	            };
	        } else if (isHostMethod(document, "attachEvent")) {
	            addListener = function(obj, eventType, listener) {
	                obj.attachEvent("on" + eventType, listener);
	            };
	        } else {
	            fail("Document does not have required addEventListener or attachEvent method");
	        }
	
	        util.addListener = addListener;
	    }
	
	    var initListeners = [];
	
	    function getErrorDesc(ex) {
	        return ex.message || ex.description || String(ex);
	    }
	
	    // Initialization
	    function init() {
	        if (!isBrowser || api.initialized) {
	            return;
	        }
	        var testRange;
	        var implementsDomRange = false, implementsTextRange = false;
	
	        // First, perform basic feature tests
	
	        if (isHostMethod(document, "createRange")) {
	            testRange = document.createRange();
	            if (areHostMethods(testRange, domRangeMethods) && areHostProperties(testRange, domRangeProperties)) {
	                implementsDomRange = true;
	            }
	        }
	
	        var body = getBody(document);
	        if (!body || body.nodeName.toLowerCase() != "body") {
	            fail("No body element found");
	            return;
	        }
	
	        if (body && isHostMethod(body, "createTextRange")) {
	            testRange = body.createTextRange();
	            if (isTextRange(testRange)) {
	                implementsTextRange = true;
	            }
	        }
	
	        if (!implementsDomRange && !implementsTextRange) {
	            fail("Neither Range nor TextRange are available");
	            return;
	        }
	
	        api.initialized = true;
	        api.features = {
	            implementsDomRange: implementsDomRange,
	            implementsTextRange: implementsTextRange
	        };
	
	        // Initialize modules
	        var module, errorMessage;
	        for (var moduleName in modules) {
	            if ( (module = modules[moduleName]) instanceof Module ) {
	                module.init(module, api);
	            }
	        }
	
	        // Call init listeners
	        for (var i = 0, len = initListeners.length; i < len; ++i) {
	            try {
	                initListeners[i](api);
	            } catch (ex) {
	                errorMessage = "Rangy init listener threw an exception. Continuing. Detail: " + getErrorDesc(ex);
	                consoleLog(errorMessage);
	            }
	        }
	    }
	
	    function deprecationNotice(deprecated, replacement, module) {
	        if (module) {
	            deprecated += " in module " + module.name;
	        }
	        api.warn("DEPRECATED: " + deprecated + " is deprecated. Please use " +
	        replacement + " instead.");
	    }
	
	    function createAliasForDeprecatedMethod(owner, deprecated, replacement, module) {
	        owner[deprecated] = function() {
	            deprecationNotice(deprecated, replacement, module);
	            return owner[replacement].apply(owner, util.toArray(arguments));
	        };
	    }
	
	    util.deprecationNotice = deprecationNotice;
	    util.createAliasForDeprecatedMethod = createAliasForDeprecatedMethod;
	
	    // Allow external scripts to initialize this library in case it's loaded after the document has loaded
	    api.init = init;
	
	    // Execute listener immediately if already initialized
	    api.addInitListener = function(listener) {
	        if (api.initialized) {
	            listener(api);
	        } else {
	            initListeners.push(listener);
	        }
	    };
	
	    var shimListeners = [];
	
	    api.addShimListener = function(listener) {
	        shimListeners.push(listener);
	    };
	
	    function shim(win) {
	        win = win || window;
	        init();
	
	        // Notify listeners
	        for (var i = 0, len = shimListeners.length; i < len; ++i) {
	            shimListeners[i](win);
	        }
	    }
	
	    if (isBrowser) {
	        api.shim = api.createMissingNativeApi = shim;
	        createAliasForDeprecatedMethod(api, "createMissingNativeApi", "shim");
	    }
	
	    function Module(name, dependencies, initializer) {
	        this.name = name;
	        this.dependencies = dependencies;
	        this.initialized = false;
	        this.supported = false;
	        this.initializer = initializer;
	    }
	
	    Module.prototype = {
	        init: function() {
	            var requiredModuleNames = this.dependencies || [];
	            for (var i = 0, len = requiredModuleNames.length, requiredModule, moduleName; i < len; ++i) {
	                moduleName = requiredModuleNames[i];
	
	                requiredModule = modules[moduleName];
	                if (!requiredModule || !(requiredModule instanceof Module)) {
	                    throw new Error("required module '" + moduleName + "' not found");
	                }
	
	                requiredModule.init();
	
	                if (!requiredModule.supported) {
	                    throw new Error("required module '" + moduleName + "' not supported");
	                }
	            }
	
	            // Now run initializer
	            this.initializer(this);
	        },
	
	        fail: function(reason) {
	            this.initialized = true;
	            this.supported = false;
	            throw new Error(reason);
	        },
	
	        warn: function(msg) {
	            api.warn("Module " + this.name + ": " + msg);
	        },
	
	        deprecationNotice: function(deprecated, replacement) {
	            api.warn("DEPRECATED: " + deprecated + " in module " + this.name + " is deprecated. Please use " +
	                replacement + " instead");
	        },
	
	        createError: function(msg) {
	            return new Error("Error in Rangy " + this.name + " module: " + msg);
	        }
	    };
	
	    function createModule(name, dependencies, initFunc) {
	        var newModule = new Module(name, dependencies, function(module) {
	            if (!module.initialized) {
	                module.initialized = true;
	                try {
	                    initFunc(api, module);
	                    module.supported = true;
	                } catch (ex) {
	                    var errorMessage = "Module '" + name + "' failed to load: " + getErrorDesc(ex);
	                    consoleLog(errorMessage);
	                    if (ex.stack) {
	                        consoleLog(ex.stack);
	                    }
	                }
	            }
	        });
	        modules[name] = newModule;
	        return newModule;
	    }
	
	    api.createModule = function(name) {
	        // Allow 2 or 3 arguments (second argument is an optional array of dependencies)
	        var initFunc, dependencies;
	        if (arguments.length == 2) {
	            initFunc = arguments[1];
	            dependencies = [];
	        } else {
	            initFunc = arguments[2];
	            dependencies = arguments[1];
	        }
	
	        var module = createModule(name, dependencies, initFunc);
	
	        // Initialize the module immediately if the core is already initialized
	        if (api.initialized && api.supported) {
	            module.init();
	        }
	    };
	
	    api.createCoreModule = function(name, dependencies, initFunc) {
	        createModule(name, dependencies, initFunc);
	    };
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Ensure rangy.rangePrototype and rangy.selectionPrototype are available immediately
	
	    function RangePrototype() {}
	    api.RangePrototype = RangePrototype;
	    api.rangePrototype = new RangePrototype();
	
	    function SelectionPrototype() {}
	    api.selectionPrototype = new SelectionPrototype();
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // DOM utility methods used by Rangy
	    api.createCoreModule("DomUtil", [], function(api, module) {
	        var UNDEF = "undefined";
	        var util = api.util;
	        var getBody = util.getBody;
	
	        // Perform feature tests
	        if (!util.areHostMethods(document, ["createDocumentFragment", "createElement", "createTextNode"])) {
	            module.fail("document missing a Node creation method");
	        }
	
	        if (!util.isHostMethod(document, "getElementsByTagName")) {
	            module.fail("document missing getElementsByTagName method");
	        }
	
	        var el = document.createElement("div");
	        if (!util.areHostMethods(el, ["insertBefore", "appendChild", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]))) {
	            module.fail("Incomplete Element implementation");
	        }
	
	        // innerHTML is required for Range's createContextualFragment method
	        if (!util.isHostProperty(el, "innerHTML")) {
	            module.fail("Element is missing innerHTML property");
	        }
	
	        var textNode = document.createTextNode("test");
	        if (!util.areHostMethods(textNode, ["splitText", "deleteData", "insertData", "appendData", "cloneNode"] ||
	                !util.areHostObjects(el, ["previousSibling", "nextSibling", "childNodes", "parentNode"]) ||
	                !util.areHostProperties(textNode, ["data"]))) {
	            module.fail("Incomplete Text Node implementation");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Removed use of indexOf because of a bizarre bug in Opera that is thrown in one of the Acid3 tests. I haven't been
	        // able to replicate it outside of the test. The bug is that indexOf returns -1 when called on an Array that
	        // contains just the document as a single element and the value searched for is the document.
	        var arrayContains = /*Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val) > -1;
	            }:*/
	
	            function(arr, val) {
	                var i = arr.length;
	                while (i--) {
	                    if (arr[i] === val) {
	                        return true;
	                    }
	                }
	                return false;
	            };
	
	        // Opera 11 puts HTML elements in the null namespace, it seems, and IE 7 has undefined namespaceURI
	        function isHtmlNamespace(node) {
	            var ns;
	            return typeof node.namespaceURI == UNDEF || ((ns = node.namespaceURI) === null || ns == "http://www.w3.org/1999/xhtml");
	        }
	
	        function parentElement(node) {
	            var parent = node.parentNode;
	            return (parent.nodeType == 1) ? parent : null;
	        }
	
	        function getNodeIndex(node) {
	            var i = 0;
	            while( (node = node.previousSibling) ) {
	                ++i;
	            }
	            return i;
	        }
	
	        function getNodeLength(node) {
	            switch (node.nodeType) {
	                case 7:
	                case 10:
	                    return 0;
	                case 3:
	                case 8:
	                    return node.length;
	                default:
	                    return node.childNodes.length;
	            }
	        }
	
	        function getCommonAncestor(node1, node2) {
	            var ancestors = [], n;
	            for (n = node1; n; n = n.parentNode) {
	                ancestors.push(n);
	            }
	
	            for (n = node2; n; n = n.parentNode) {
	                if (arrayContains(ancestors, n)) {
	                    return n;
	                }
	            }
	
	            return null;
	        }
	
	        function isAncestorOf(ancestor, descendant, selfIsAncestor) {
	            var n = selfIsAncestor ? descendant : descendant.parentNode;
	            while (n) {
	                if (n === ancestor) {
	                    return true;
	                } else {
	                    n = n.parentNode;
	                }
	            }
	            return false;
	        }
	
	        function isOrIsAncestorOf(ancestor, descendant) {
	            return isAncestorOf(ancestor, descendant, true);
	        }
	
	        function getClosestAncestorIn(node, ancestor, selfIsAncestor) {
	            var p, n = selfIsAncestor ? node : node.parentNode;
	            while (n) {
	                p = n.parentNode;
	                if (p === ancestor) {
	                    return n;
	                }
	                n = p;
	            }
	            return null;
	        }
	
	        function isCharacterDataNode(node) {
	            var t = node.nodeType;
	            return t == 3 || t == 4 || t == 8 ; // Text, CDataSection or Comment
	        }
	
	        function isTextOrCommentNode(node) {
	            if (!node) {
	                return false;
	            }
	            var t = node.nodeType;
	            return t == 3 || t == 8 ; // Text or Comment
	        }
	
	        function insertAfter(node, precedingNode) {
	            var nextNode = precedingNode.nextSibling, parent = precedingNode.parentNode;
	            if (nextNode) {
	                parent.insertBefore(node, nextNode);
	            } else {
	                parent.appendChild(node);
	            }
	            return node;
	        }
	
	        // Note that we cannot use splitText() because it is bugridden in IE 9.
	        function splitDataNode(node, index, positionsToPreserve) {
	            var newNode = node.cloneNode(false);
	            newNode.deleteData(0, index);
	            node.deleteData(index, node.length - index);
	            insertAfter(newNode, node);
	
	            // Preserve positions
	            if (positionsToPreserve) {
	                for (var i = 0, position; position = positionsToPreserve[i++]; ) {
	                    // Handle case where position was inside the portion of node after the split point
	                    if (position.node == node && position.offset > index) {
	                        position.node = newNode;
	                        position.offset -= index;
	                    }
	                    // Handle the case where the position is a node offset within node's parent
	                    else if (position.node == node.parentNode && position.offset > getNodeIndex(node)) {
	                        ++position.offset;
	                    }
	                }
	            }
	            return newNode;
	        }
	
	        function getDocument(node) {
	            if (node.nodeType == 9) {
	                return node;
	            } else if (typeof node.ownerDocument != UNDEF) {
	                return node.ownerDocument;
	            } else if (typeof node.document != UNDEF) {
	                return node.document;
	            } else if (node.parentNode) {
	                return getDocument(node.parentNode);
	            } else {
	                throw module.createError("getDocument: no document found for node");
	            }
	        }
	
	        function getWindow(node) {
	            var doc = getDocument(node);
	            if (typeof doc.defaultView != UNDEF) {
	                return doc.defaultView;
	            } else if (typeof doc.parentWindow != UNDEF) {
	                return doc.parentWindow;
	            } else {
	                throw module.createError("Cannot get a window object for node");
	            }
	        }
	
	        function getIframeDocument(iframeEl) {
	            if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument;
	            } else if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow.document;
	            } else {
	                throw module.createError("getIframeDocument: No Document object found for iframe element");
	            }
	        }
	
	        function getIframeWindow(iframeEl) {
	            if (typeof iframeEl.contentWindow != UNDEF) {
	                return iframeEl.contentWindow;
	            } else if (typeof iframeEl.contentDocument != UNDEF) {
	                return iframeEl.contentDocument.defaultView;
	            } else {
	                throw module.createError("getIframeWindow: No Window object found for iframe element");
	            }
	        }
	
	        // This looks bad. Is it worth it?
	        function isWindow(obj) {
	            return obj && util.isHostMethod(obj, "setTimeout") && util.isHostObject(obj, "document");
	        }
	
	        function getContentDocument(obj, module, methodName) {
	            var doc;
	
	            if (!obj) {
	                doc = document;
	            }
	
	            // Test if a DOM node has been passed and obtain a document object for it if so
	            else if (util.isHostProperty(obj, "nodeType")) {
	                doc = (obj.nodeType == 1 && obj.tagName.toLowerCase() == "iframe") ?
	                    getIframeDocument(obj) : getDocument(obj);
	            }
	
	            // Test if the doc parameter appears to be a Window object
	            else if (isWindow(obj)) {
	                doc = obj.document;
	            }
	
	            if (!doc) {
	                throw module.createError(methodName + "(): Parameter must be a Window object or DOM node");
	            }
	
	            return doc;
	        }
	
	        function getRootContainer(node) {
	            var parent;
	            while ( (parent = node.parentNode) ) {
	                node = parent;
	            }
	            return node;
	        }
	
	        function comparePoints(nodeA, offsetA, nodeB, offsetB) {
	            // See http://www.w3.org/TR/DOM-Level-2-Traversal-Range/ranges.html#Level-2-Range-Comparing
	            var nodeC, root, childA, childB, n;
	            if (nodeA == nodeB) {
	                // Case 1: nodes are the same
	                return offsetA === offsetB ? 0 : (offsetA < offsetB) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeB, nodeA, true)) ) {
	                // Case 2: node C (container B or an ancestor) is a child node of A
	                return offsetA <= getNodeIndex(nodeC) ? -1 : 1;
	            } else if ( (nodeC = getClosestAncestorIn(nodeA, nodeB, true)) ) {
	                // Case 3: node C (container A or an ancestor) is a child node of B
	                return getNodeIndex(nodeC) < offsetB  ? -1 : 1;
	            } else {
	                root = getCommonAncestor(nodeA, nodeB);
	                if (!root) {
	                    throw new Error("comparePoints error: nodes have no common ancestor");
	                }
	
	                // Case 4: containers are siblings or descendants of siblings
	                childA = (nodeA === root) ? root : getClosestAncestorIn(nodeA, root, true);
	                childB = (nodeB === root) ? root : getClosestAncestorIn(nodeB, root, true);
	
	                if (childA === childB) {
	                    // This shouldn't be possible
	                    throw module.createError("comparePoints got to case 4 and childA and childB are the same!");
	                } else {
	                    n = root.firstChild;
	                    while (n) {
	                        if (n === childA) {
	                            return -1;
	                        } else if (n === childB) {
	                            return 1;
	                        }
	                        n = n.nextSibling;
	                    }
	                }
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test for IE's crash (IE 6/7) or exception (IE >= 8) when a reference to garbage-collected text node is queried
	        var crashyTextNodes = false;
	
	        function isBrokenNode(node) {
	            var n;
	            try {
	                n = node.parentNode;
	                return false;
	            } catch (e) {
	                return true;
	            }
	        }
	
	        (function() {
	            var el = document.createElement("b");
	            el.innerHTML = "1";
	            var textNode = el.firstChild;
	            el.innerHTML = "<br />";
	            crashyTextNodes = isBrokenNode(textNode);
	
	            api.features.crashyTextNodes = crashyTextNodes;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function inspectNode(node) {
	            if (!node) {
	                return "[No node]";
	            }
	            if (crashyTextNodes && isBrokenNode(node)) {
	                return "[Broken node]";
	            }
	            if (isCharacterDataNode(node)) {
	                return '"' + node.data + '"';
	            }
	            if (node.nodeType == 1) {
	                var idAttr = node.id ? ' id="' + node.id + '"' : "";
	                return "<" + node.nodeName + idAttr + ">[index:" + getNodeIndex(node) + ",length:" + node.childNodes.length + "][" + (node.innerHTML || "[innerHTML not supported]").slice(0, 25) + "]";
	            }
	            return node.nodeName;
	        }
	
	        function fragmentFromNodeChildren(node) {
	            var fragment = getDocument(node).createDocumentFragment(), child;
	            while ( (child = node.firstChild) ) {
	                fragment.appendChild(child);
	            }
	            return fragment;
	        }
	
	        var getComputedStyleProperty;
	        if (typeof window.getComputedStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return getWindow(el).getComputedStyle(el, null)[propName];
	            };
	        } else if (typeof document.documentElement.currentStyle != UNDEF) {
	            getComputedStyleProperty = function(el, propName) {
	                return el.currentStyle ? el.currentStyle[propName] : "";
	            };
	        } else {
	            module.fail("No means of obtaining computed style properties found");
	        }
	
	        function createTestElement(doc, html, contentEditable) {
	            var body = getBody(doc);
	            var el = doc.createElement("div");
	            el.contentEditable = "" + !!contentEditable;
	            if (html) {
	                el.innerHTML = html;
	            }
	
	            // Insert the test element at the start of the body to prevent scrolling to the bottom in iOS (issue #292)
	            var bodyFirstChild = body.firstChild;
	            if (bodyFirstChild) {
	                body.insertBefore(el, bodyFirstChild);
	            } else {
	                body.appendChild(el);
	            }
	
	            return el;
	        }
	
	        function removeNode(node) {
	            return node.parentNode.removeChild(node);
	        }
	
	        function NodeIterator(root) {
	            this.root = root;
	            this._next = root;
	        }
	
	        NodeIterator.prototype = {
	            _current: null,
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                var n = this._current = this._next;
	                var child, next;
	                if (this._current) {
	                    child = n.firstChild;
	                    if (child) {
	                        this._next = child;
	                    } else {
	                        next = null;
	                        while ((n !== this.root) && !(next = n.nextSibling)) {
	                            n = n.parentNode;
	                        }
	                        this._next = next;
	                    }
	                }
	                return this._current;
	            },
	
	            detach: function() {
	                this._current = this._next = this.root = null;
	            }
	        };
	
	        function createIterator(root) {
	            return new NodeIterator(root);
	        }
	
	        function DomPosition(node, offset) {
	            this.node = node;
	            this.offset = offset;
	        }
	
	        DomPosition.prototype = {
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset == pos.offset;
	            },
	
	            inspect: function() {
	                return "[DomPosition(" + inspectNode(this.node) + ":" + this.offset + ")]";
	            },
	
	            toString: function() {
	                return this.inspect();
	            }
	        };
	
	        function DOMException(codeName) {
	            this.code = this[codeName];
	            this.codeName = codeName;
	            this.message = "DOMException: " + this.codeName;
	        }
	
	        DOMException.prototype = {
	            INDEX_SIZE_ERR: 1,
	            HIERARCHY_REQUEST_ERR: 3,
	            WRONG_DOCUMENT_ERR: 4,
	            NO_MODIFICATION_ALLOWED_ERR: 7,
	            NOT_FOUND_ERR: 8,
	            NOT_SUPPORTED_ERR: 9,
	            INVALID_STATE_ERR: 11,
	            INVALID_NODE_TYPE_ERR: 24
	        };
	
	        DOMException.prototype.toString = function() {
	            return this.message;
	        };
	
	        api.dom = {
	            arrayContains: arrayContains,
	            isHtmlNamespace: isHtmlNamespace,
	            parentElement: parentElement,
	            getNodeIndex: getNodeIndex,
	            getNodeLength: getNodeLength,
	            getCommonAncestor: getCommonAncestor,
	            isAncestorOf: isAncestorOf,
	            isOrIsAncestorOf: isOrIsAncestorOf,
	            getClosestAncestorIn: getClosestAncestorIn,
	            isCharacterDataNode: isCharacterDataNode,
	            isTextOrCommentNode: isTextOrCommentNode,
	            insertAfter: insertAfter,
	            splitDataNode: splitDataNode,
	            getDocument: getDocument,
	            getWindow: getWindow,
	            getIframeWindow: getIframeWindow,
	            getIframeDocument: getIframeDocument,
	            getBody: getBody,
	            isWindow: isWindow,
	            getContentDocument: getContentDocument,
	            getRootContainer: getRootContainer,
	            comparePoints: comparePoints,
	            isBrokenNode: isBrokenNode,
	            inspectNode: inspectNode,
	            getComputedStyleProperty: getComputedStyleProperty,
	            createTestElement: createTestElement,
	            removeNode: removeNode,
	            fragmentFromNodeChildren: fragmentFromNodeChildren,
	            createIterator: createIterator,
	            DomPosition: DomPosition
	        };
	
	        api.DOMException = DOMException;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Pure JavaScript implementation of DOM Range
	    api.createCoreModule("DomRange", ["DomUtil"], function(api, module) {
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DOMException = api.DOMException;
	
	        var isCharacterDataNode = dom.isCharacterDataNode;
	        var getNodeIndex = dom.getNodeIndex;
	        var isOrIsAncestorOf = dom.isOrIsAncestorOf;
	        var getDocument = dom.getDocument;
	        var comparePoints = dom.comparePoints;
	        var splitDataNode = dom.splitDataNode;
	        var getClosestAncestorIn = dom.getClosestAncestorIn;
	        var getNodeLength = dom.getNodeLength;
	        var arrayContains = dom.arrayContains;
	        var getRootContainer = dom.getRootContainer;
	        var crashyTextNodes = api.features.crashyTextNodes;
	
	        var removeNode = dom.removeNode;
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Utility functions
	
	        function isNonTextPartiallySelected(node, range) {
	            return (node.nodeType != 3) &&
	                   (isOrIsAncestorOf(node, range.startContainer) || isOrIsAncestorOf(node, range.endContainer));
	        }
	
	        function getRangeDocument(range) {
	            return range.document || getDocument(range.startContainer);
	        }
	
	        function getRangeRoot(range) {
	            return getRootContainer(range.startContainer);
	        }
	
	        function getBoundaryBeforeNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node));
	        }
	
	        function getBoundaryAfterNode(node) {
	            return new DomPosition(node.parentNode, getNodeIndex(node) + 1);
	        }
	
	        function insertNodeAtPosition(node, n, o) {
	            var firstNodeInserted = node.nodeType == 11 ? node.firstChild : node;
	            if (isCharacterDataNode(n)) {
	                if (o == n.length) {
	                    dom.insertAfter(node, n);
	                } else {
	                    n.parentNode.insertBefore(node, o == 0 ? n : splitDataNode(n, o));
	                }
	            } else if (o >= n.childNodes.length) {
	                n.appendChild(node);
	            } else {
	                n.insertBefore(node, n.childNodes[o]);
	            }
	            return firstNodeInserted;
	        }
	
	        function rangesIntersect(rangeA, rangeB, touchingIsIntersecting) {
	            assertRangeValid(rangeA);
	            assertRangeValid(rangeB);
	
	            if (getRangeDocument(rangeB) != getRangeDocument(rangeA)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	
	            var startComparison = comparePoints(rangeA.startContainer, rangeA.startOffset, rangeB.endContainer, rangeB.endOffset),
	                endComparison = comparePoints(rangeA.endContainer, rangeA.endOffset, rangeB.startContainer, rangeB.startOffset);
	
	            return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	        }
	
	        function cloneSubtree(iterator) {
	            var partiallySelected;
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	                partiallySelected = iterator.isPartiallySelectedSubtree();
	                node = node.cloneNode(!partiallySelected);
	                if (partiallySelected) {
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(cloneSubtree(subIterator));
	                    subIterator.detach();
	                }
	
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function iterateSubtree(rangeIterator, func, iteratorState) {
	            var it, n;
	            iteratorState = iteratorState || { stop: false };
	            for (var node, subRangeIterator; node = rangeIterator.next(); ) {
	                if (rangeIterator.isPartiallySelectedSubtree()) {
	                    if (func(node) === false) {
	                        iteratorState.stop = true;
	                        return;
	                    } else {
	                        // The node is partially selected by the Range, so we can use a new RangeIterator on the portion of
	                        // the node selected by the Range.
	                        subRangeIterator = rangeIterator.getSubtreeIterator();
	                        iterateSubtree(subRangeIterator, func, iteratorState);
	                        subRangeIterator.detach();
	                        if (iteratorState.stop) {
	                            return;
	                        }
	                    }
	                } else {
	                    // The whole node is selected, so we can use efficient DOM iteration to iterate over the node and its
	                    // descendants
	                    it = dom.createIterator(node);
	                    while ( (n = it.next()) ) {
	                        if (func(n) === false) {
	                            iteratorState.stop = true;
	                            return;
	                        }
	                    }
	                }
	            }
	        }
	
	        function deleteSubtree(iterator) {
	            var subIterator;
	            while (iterator.next()) {
	                if (iterator.isPartiallySelectedSubtree()) {
	                    subIterator = iterator.getSubtreeIterator();
	                    deleteSubtree(subIterator);
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	            }
	        }
	
	        function extractSubtree(iterator) {
	            for (var node, frag = getRangeDocument(iterator.range).createDocumentFragment(), subIterator; node = iterator.next(); ) {
	
	                if (iterator.isPartiallySelectedSubtree()) {
	                    node = node.cloneNode(false);
	                    subIterator = iterator.getSubtreeIterator();
	                    node.appendChild(extractSubtree(subIterator));
	                    subIterator.detach();
	                } else {
	                    iterator.remove();
	                }
	                if (node.nodeType == 10) { // DocumentType
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	                frag.appendChild(node);
	            }
	            return frag;
	        }
	
	        function getNodesInRange(range, nodeTypes, filter) {
	            var filterNodeTypes = !!(nodeTypes && nodeTypes.length), regex;
	            var filterExists = !!filter;
	            if (filterNodeTypes) {
	                regex = new RegExp("^(" + nodeTypes.join("|") + ")$");
	            }
	
	            var nodes = [];
	            iterateSubtree(new RangeIterator(range, false), function(node) {
	                if (filterNodeTypes && !regex.test(node.nodeType)) {
	                    return;
	                }
	                if (filterExists && !filter(node)) {
	                    return;
	                }
	                // Don't include a boundary container if it is a character data node and the range does not contain any
	                // of its character data. See issue 190.
	                var sc = range.startContainer;
	                if (node == sc && isCharacterDataNode(sc) && range.startOffset == sc.length) {
	                    return;
	                }
	
	                var ec = range.endContainer;
	                if (node == ec && isCharacterDataNode(ec) && range.endOffset == 0) {
	                    return;
	                }
	
	                nodes.push(node);
	            });
	            return nodes;
	        }
	
	        function inspect(range) {
	            var name = (typeof range.getName == "undefined") ? "Range" : range.getName();
	            return "[" + name + "(" + dom.inspectNode(range.startContainer) + ":" + range.startOffset + ", " +
	                    dom.inspectNode(range.endContainer) + ":" + range.endOffset + ")]";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // RangeIterator code partially borrows from IERange by Tim Ryan (http://github.com/timcameronryan/IERange)
	
	        function RangeIterator(range, clonePartiallySelectedTextNodes) {
	            this.range = range;
	            this.clonePartiallySelectedTextNodes = clonePartiallySelectedTextNodes;
	
	
	            if (!range.collapsed) {
	                this.sc = range.startContainer;
	                this.so = range.startOffset;
	                this.ec = range.endContainer;
	                this.eo = range.endOffset;
	                var root = range.commonAncestorContainer;
	
	                if (this.sc === this.ec && isCharacterDataNode(this.sc)) {
	                    this.isSingleCharacterDataNode = true;
	                    this._first = this._last = this._next = this.sc;
	                } else {
	                    this._first = this._next = (this.sc === root && !isCharacterDataNode(this.sc)) ?
	                        this.sc.childNodes[this.so] : getClosestAncestorIn(this.sc, root, true);
	                    this._last = (this.ec === root && !isCharacterDataNode(this.ec)) ?
	                        this.ec.childNodes[this.eo - 1] : getClosestAncestorIn(this.ec, root, true);
	                }
	            }
	        }
	
	        RangeIterator.prototype = {
	            _current: null,
	            _next: null,
	            _first: null,
	            _last: null,
	            isSingleCharacterDataNode: false,
	
	            reset: function() {
	                this._current = null;
	                this._next = this._first;
	            },
	
	            hasNext: function() {
	                return !!this._next;
	            },
	
	            next: function() {
	                // Move to next node
	                var current = this._current = this._next;
	                if (current) {
	                    this._next = (current !== this._last) ? current.nextSibling : null;
	
	                    // Check for partially selected text nodes
	                    if (isCharacterDataNode(current) && this.clonePartiallySelectedTextNodes) {
	                        if (current === this.ec) {
	                            (current = current.cloneNode(true)).deleteData(this.eo, current.length - this.eo);
	                        }
	                        if (this._current === this.sc) {
	                            (current = current.cloneNode(true)).deleteData(0, this.so);
	                        }
	                    }
	                }
	
	                return current;
	            },
	
	            remove: function() {
	                var current = this._current, start, end;
	
	                if (isCharacterDataNode(current) && (current === this.sc || current === this.ec)) {
	                    start = (current === this.sc) ? this.so : 0;
	                    end = (current === this.ec) ? this.eo : current.length;
	                    if (start != end) {
	                        current.deleteData(start, end - start);
	                    }
	                } else {
	                    if (current.parentNode) {
	                        removeNode(current);
	                    } else {
	                    }
	                }
	            },
	
	            // Checks if the current node is partially selected
	            isPartiallySelectedSubtree: function() {
	                var current = this._current;
	                return isNonTextPartiallySelected(current, this.range);
	            },
	
	            getSubtreeIterator: function() {
	                var subRange;
	                if (this.isSingleCharacterDataNode) {
	                    subRange = this.range.cloneRange();
	                    subRange.collapse(false);
	                } else {
	                    subRange = new Range(getRangeDocument(this.range));
	                    var current = this._current;
	                    var startContainer = current, startOffset = 0, endContainer = current, endOffset = getNodeLength(current);
	
	                    if (isOrIsAncestorOf(current, this.sc)) {
	                        startContainer = this.sc;
	                        startOffset = this.so;
	                    }
	                    if (isOrIsAncestorOf(current, this.ec)) {
	                        endContainer = this.ec;
	                        endOffset = this.eo;
	                    }
	
	                    updateBoundaries(subRange, startContainer, startOffset, endContainer, endOffset);
	                }
	                return new RangeIterator(subRange, this.clonePartiallySelectedTextNodes);
	            },
	
	            detach: function() {
	                this.range = this._current = this._next = this._first = this._last = this.sc = this.so = this.ec = this.eo = null;
	            }
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var beforeAfterNodeTypes = [1, 3, 4, 5, 7, 8, 10];
	        var rootContainerNodeTypes = [2, 9, 11];
	        var readonlyNodeTypes = [5, 6, 10, 12];
	        var insertableNodeTypes = [1, 3, 4, 5, 7, 8, 10, 11];
	        var surroundNodeTypes = [1, 3, 4, 5, 7, 8];
	
	        function createAncestorFinder(nodeTypes) {
	            return function(node, selfIsAncestor) {
	                var t, n = selfIsAncestor ? node : node.parentNode;
	                while (n) {
	                    t = n.nodeType;
	                    if (arrayContains(nodeTypes, t)) {
	                        return n;
	                    }
	                    n = n.parentNode;
	                }
	                return null;
	            };
	        }
	
	        var getDocumentOrFragmentContainer = createAncestorFinder( [9, 11] );
	        var getReadonlyAncestor = createAncestorFinder(readonlyNodeTypes);
	        var getDocTypeNotationEntityAncestor = createAncestorFinder( [6, 10, 12] );
	
	        function assertNoDocTypeNotationEntityAncestor(node, allowSelf) {
	            if (getDocTypeNotationEntityAncestor(node, allowSelf)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidNodeType(node, invalidTypes) {
	            if (!arrayContains(invalidTypes, node.nodeType)) {
	                throw new DOMException("INVALID_NODE_TYPE_ERR");
	            }
	        }
	
	        function assertValidOffset(node, offset) {
	            if (offset < 0 || offset > (isCharacterDataNode(node) ? node.length : node.childNodes.length)) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            }
	        }
	
	        function assertSameDocumentOrFragment(node1, node2) {
	            if (getDocumentOrFragmentContainer(node1, true) !== getDocumentOrFragmentContainer(node2, true)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        function assertNodeNotReadOnly(node) {
	            if (getReadonlyAncestor(node, true)) {
	                throw new DOMException("NO_MODIFICATION_ALLOWED_ERR");
	            }
	        }
	
	        function assertNode(node, codeName) {
	            if (!node) {
	                throw new DOMException(codeName);
	            }
	        }
	
	        function isValidOffset(node, offset) {
	            return offset <= (isCharacterDataNode(node) ? node.length : node.childNodes.length);
	        }
	
	        function isRangeValid(range) {
	            return (!!range.startContainer && !!range.endContainer &&
	                    !(crashyTextNodes && (dom.isBrokenNode(range.startContainer) || dom.isBrokenNode(range.endContainer))) &&
	                    getRootContainer(range.startContainer) == getRootContainer(range.endContainer) &&
	                    isValidOffset(range.startContainer, range.startOffset) &&
	                    isValidOffset(range.endContainer, range.endOffset));
	        }
	
	        function assertRangeValid(range) {
	            if (!isRangeValid(range)) {
	                throw new Error("Range error: Range is not valid. This usually happens after DOM mutation. Range: (" + range.inspect() + ")");
	            }
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Test the browser's innerHTML support to decide how to implement createContextualFragment
	        var styleEl = document.createElement("style");
	        var htmlParsingConforms = false;
	        try {
	            styleEl.innerHTML = "<b>x</b>";
	            htmlParsingConforms = (styleEl.firstChild.nodeType == 3); // Opera incorrectly creates an element node
	        } catch (e) {
	            // IE 6 and 7 throw
	        }
	
	        api.features.htmlParsingConforms = htmlParsingConforms;
	
	        var createContextualFragment = htmlParsingConforms ?
	
	            // Implementation as per HTML parsing spec, trusting in the browser's implementation of innerHTML. See
	            // discussion and base code for this implementation at issue 67.
	            // Spec: http://html5.org/specs/dom-parsing.html#extensions-to-the-range-interface
	            // Thanks to Aleks Williams.
	            function(fragmentStr) {
	                // "Let node the context object's start's node."
	                var node = this.startContainer;
	                var doc = getDocument(node);
	
	                // "If the context object's start's node is null, raise an INVALID_STATE_ERR
	                // exception and abort these steps."
	                if (!node) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // "Let element be as follows, depending on node's interface:"
	                // Document, Document Fragment: null
	                var el = null;
	
	                // "Element: node"
	                if (node.nodeType == 1) {
	                    el = node;
	
	                // "Text, Comment: node's parentElement"
	                } else if (isCharacterDataNode(node)) {
	                    el = dom.parentElement(node);
	                }
	
	                // "If either element is null or element's ownerDocument is an HTML document
	                // and element's local name is "html" and element's namespace is the HTML
	                // namespace"
	                if (el === null || (
	                    el.nodeName == "HTML" &&
	                    dom.isHtmlNamespace(getDocument(el).documentElement) &&
	                    dom.isHtmlNamespace(el)
	                )) {
	
	                // "let element be a new Element with "body" as its local name and the HTML
	                // namespace as its namespace.""
	                    el = doc.createElement("body");
	                } else {
	                    el = el.cloneNode(false);
	                }
	
	                // "If the node's document is an HTML document: Invoke the HTML fragment parsing algorithm."
	                // "If the node's document is an XML document: Invoke the XML fragment parsing algorithm."
	                // "In either case, the algorithm must be invoked with fragment as the input
	                // and element as the context element."
	                el.innerHTML = fragmentStr;
	
	                // "If this raises an exception, then abort these steps. Otherwise, let new
	                // children be the nodes returned."
	
	                // "Let fragment be a new DocumentFragment."
	                // "Append all new children to fragment."
	                // "Return fragment."
	                return dom.fragmentFromNodeChildren(el);
	            } :
	
	            // In this case, innerHTML cannot be trusted, so fall back to a simpler, non-conformant implementation that
	            // previous versions of Rangy used (with the exception of using a body element rather than a div)
	            function(fragmentStr) {
	                var doc = getRangeDocument(this);
	                var el = doc.createElement("body");
	                el.innerHTML = fragmentStr;
	
	                return dom.fragmentFromNodeChildren(el);
	            };
	
	        function splitRangeBoundaries(range, positionsToPreserve) {
	            assertRangeValid(range);
	
	            var sc = range.startContainer, so = range.startOffset, ec = range.endContainer, eo = range.endOffset;
	            var startEndSame = (sc === ec);
	
	            if (isCharacterDataNode(ec) && eo > 0 && eo < ec.length) {
	                splitDataNode(ec, eo, positionsToPreserve);
	            }
	
	            if (isCharacterDataNode(sc) && so > 0 && so < sc.length) {
	                sc = splitDataNode(sc, so, positionsToPreserve);
	                if (startEndSame) {
	                    eo -= so;
	                    ec = sc;
	                } else if (ec == sc.parentNode && eo >= getNodeIndex(sc)) {
	                    eo++;
	                }
	                so = 0;
	            }
	            range.setStartAndEnd(sc, so, ec, eo);
	        }
	
	        function rangeToHtml(range) {
	            assertRangeValid(range);
	            var container = range.commonAncestorContainer.parentNode.cloneNode(false);
	            container.appendChild( range.cloneContents() );
	            return container.innerHTML;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var rangeProperties = ["startContainer", "startOffset", "endContainer", "endOffset", "collapsed",
	            "commonAncestorContainer"];
	
	        var s2s = 0, s2e = 1, e2e = 2, e2s = 3;
	        var n_b = 0, n_a = 1, n_b_a = 2, n_i = 3;
	
	        util.extend(api.rangePrototype, {
	            compareBoundaryPoints: function(how, range) {
	                assertRangeValid(this);
	                assertSameDocumentOrFragment(this.startContainer, range.startContainer);
	
	                var nodeA, offsetA, nodeB, offsetB;
	                var prefixA = (how == e2s || how == s2s) ? "start" : "end";
	                var prefixB = (how == s2e || how == s2s) ? "start" : "end";
	                nodeA = this[prefixA + "Container"];
	                offsetA = this[prefixA + "Offset"];
	                nodeB = range[prefixB + "Container"];
	                offsetB = range[prefixB + "Offset"];
	                return comparePoints(nodeA, offsetA, nodeB, offsetB);
	            },
	
	            insertNode: function(node) {
	                assertRangeValid(this);
	                assertValidNodeType(node, insertableNodeTypes);
	                assertNodeNotReadOnly(this.startContainer);
	
	                if (isOrIsAncestorOf(node, this.startContainer)) {
	                    throw new DOMException("HIERARCHY_REQUEST_ERR");
	                }
	
	                // No check for whether the container of the start of the Range is of a type that does not allow
	                // children of the type of node: the browser's DOM implementation should do this for us when we attempt
	                // to add the node
	
	                var firstNodeInserted = insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                this.setStartBefore(firstNodeInserted);
	            },
	
	            cloneContents: function() {
	                assertRangeValid(this);
	
	                var clone, frag;
	                if (this.collapsed) {
	                    return getRangeDocument(this).createDocumentFragment();
	                } else {
	                    if (this.startContainer === this.endContainer && isCharacterDataNode(this.startContainer)) {
	                        clone = this.startContainer.cloneNode(true);
	                        clone.data = clone.data.slice(this.startOffset, this.endOffset);
	                        frag = getRangeDocument(this).createDocumentFragment();
	                        frag.appendChild(clone);
	                        return frag;
	                    } else {
	                        var iterator = new RangeIterator(this, true);
	                        clone = cloneSubtree(iterator);
	                        iterator.detach();
	                    }
	                    return clone;
	                }
	            },
	
	            canSurroundContents: function() {
	                assertRangeValid(this);
	                assertNodeNotReadOnly(this.startContainer);
	                assertNodeNotReadOnly(this.endContainer);
	
	                // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                // no non-text nodes.
	                var iterator = new RangeIterator(this, true);
	                var boundariesInvalid = (iterator._first && (isNonTextPartiallySelected(iterator._first, this)) ||
	                        (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                iterator.detach();
	                return !boundariesInvalid;
	            },
	
	            surroundContents: function(node) {
	                assertValidNodeType(node, surroundNodeTypes);
	
	                if (!this.canSurroundContents()) {
	                    throw new DOMException("INVALID_STATE_ERR");
	                }
	
	                // Extract the contents
	                var content = this.extractContents();
	
	                // Clear the children of the node
	                if (node.hasChildNodes()) {
	                    while (node.lastChild) {
	                        node.removeChild(node.lastChild);
	                    }
	                }
	
	                // Insert the new node and add the extracted contents
	                insertNodeAtPosition(node, this.startContainer, this.startOffset);
	                node.appendChild(content);
	
	                this.selectNode(node);
	            },
	
	            cloneRange: function() {
	                assertRangeValid(this);
	                var range = new Range(getRangeDocument(this));
	                var i = rangeProperties.length, prop;
	                while (i--) {
	                    prop = rangeProperties[i];
	                    range[prop] = this[prop];
	                }
	                return range;
	            },
	
	            toString: function() {
	                assertRangeValid(this);
	                var sc = this.startContainer;
	                if (sc === this.endContainer && isCharacterDataNode(sc)) {
	                    return (sc.nodeType == 3 || sc.nodeType == 4) ? sc.data.slice(this.startOffset, this.endOffset) : "";
	                } else {
	                    var textParts = [], iterator = new RangeIterator(this, true);
	                    iterateSubtree(iterator, function(node) {
	                        // Accept only text or CDATA nodes, not comments
	                        if (node.nodeType == 3 || node.nodeType == 4) {
	                            textParts.push(node.data);
	                        }
	                    });
	                    iterator.detach();
	                    return textParts.join("");
	                }
	            },
	
	            // The methods below are all non-standard. The following batch were introduced by Mozilla but have since
	            // been removed from Mozilla.
	
	            compareNode: function(node) {
	                assertRangeValid(this);
	
	                var parent = node.parentNode;
	                var nodeIndex = getNodeIndex(node);
	
	                if (!parent) {
	                    throw new DOMException("NOT_FOUND_ERR");
	                }
	
	                var startComparison = this.comparePoint(parent, nodeIndex),
	                    endComparison = this.comparePoint(parent, nodeIndex + 1);
	
	                if (startComparison < 0) { // Node starts before
	                    return (endComparison > 0) ? n_b_a : n_b;
	                } else {
	                    return (endComparison > 0) ? n_a : n_i;
	                }
	            },
	
	            comparePoint: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                if (comparePoints(node, offset, this.startContainer, this.startOffset) < 0) {
	                    return -1;
	                } else if (comparePoints(node, offset, this.endContainer, this.endOffset) > 0) {
	                    return 1;
	                }
	                return 0;
	            },
	
	            createContextualFragment: createContextualFragment,
	
	            toHtml: function() {
	                return rangeToHtml(this);
	            },
	
	            // touchingIsIntersecting determines whether this method considers a node that borders a range intersects
	            // with it (as in WebKit) or not (as in Gecko pre-1.9, and the default)
	            intersectsNode: function(node, touchingIsIntersecting) {
	                assertRangeValid(this);
	                if (getRootContainer(node) != getRangeRoot(this)) {
	                    return false;
	                }
	
	                var parent = node.parentNode, offset = getNodeIndex(node);
	                if (!parent) {
	                    return true;
	                }
	
	                var startComparison = comparePoints(parent, offset, this.endContainer, this.endOffset),
	                    endComparison = comparePoints(parent, offset + 1, this.startContainer, this.startOffset);
	
	                return touchingIsIntersecting ? startComparison <= 0 && endComparison >= 0 : startComparison < 0 && endComparison > 0;
	            },
	
	            isPointInRange: function(node, offset) {
	                assertRangeValid(this);
	                assertNode(node, "HIERARCHY_REQUEST_ERR");
	                assertSameDocumentOrFragment(node, this.startContainer);
	
	                return (comparePoints(node, offset, this.startContainer, this.startOffset) >= 0) &&
	                       (comparePoints(node, offset, this.endContainer, this.endOffset) <= 0);
	            },
	
	            // The methods below are non-standard and invented by me.
	
	            // Sharing a boundary start-to-end or end-to-start does not count as intersection.
	            intersectsRange: function(range) {
	                return rangesIntersect(this, range, false);
	            },
	
	            // Sharing a boundary start-to-end or end-to-start does count as intersection.
	            intersectsOrTouchesRange: function(range) {
	                return rangesIntersect(this, range, true);
	            },
	
	            intersection: function(range) {
	                if (this.intersectsRange(range)) {
	                    var startComparison = comparePoints(this.startContainer, this.startOffset, range.startContainer, range.startOffset),
	                        endComparison = comparePoints(this.endContainer, this.endOffset, range.endContainer, range.endOffset);
	
	                    var intersectionRange = this.cloneRange();
	                    if (startComparison == -1) {
	                        intersectionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (endComparison == 1) {
	                        intersectionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return intersectionRange;
	                }
	                return null;
	            },
	
	            union: function(range) {
	                if (this.intersectsOrTouchesRange(range)) {
	                    var unionRange = this.cloneRange();
	                    if (comparePoints(range.startContainer, range.startOffset, this.startContainer, this.startOffset) == -1) {
	                        unionRange.setStart(range.startContainer, range.startOffset);
	                    }
	                    if (comparePoints(range.endContainer, range.endOffset, this.endContainer, this.endOffset) == 1) {
	                        unionRange.setEnd(range.endContainer, range.endOffset);
	                    }
	                    return unionRange;
	                } else {
	                    throw new DOMException("Ranges do not intersect");
	                }
	            },
	
	            containsNode: function(node, allowPartial) {
	                if (allowPartial) {
	                    return this.intersectsNode(node, false);
	                } else {
	                    return this.compareNode(node) == n_i;
	                }
	            },
	
	            containsNodeContents: function(node) {
	                return this.comparePoint(node, 0) >= 0 && this.comparePoint(node, getNodeLength(node)) <= 0;
	            },
	
	            containsRange: function(range) {
	                var intersection = this.intersection(range);
	                return intersection !== null && range.equals(intersection);
	            },
	
	            containsNodeText: function(node) {
	                var nodeRange = this.cloneRange();
	                nodeRange.selectNode(node);
	                var textNodes = nodeRange.getNodes([3]);
	                if (textNodes.length > 0) {
	                    nodeRange.setStart(textNodes[0], 0);
	                    var lastTextNode = textNodes.pop();
	                    nodeRange.setEnd(lastTextNode, lastTextNode.length);
	                    return this.containsRange(nodeRange);
	                } else {
	                    return this.containsNodeContents(node);
	                }
	            },
	
	            getNodes: function(nodeTypes, filter) {
	                assertRangeValid(this);
	                return getNodesInRange(this, nodeTypes, filter);
	            },
	
	            getDocument: function() {
	                return getRangeDocument(this);
	            },
	
	            collapseBefore: function(node) {
	                this.setEndBefore(node);
	                this.collapse(false);
	            },
	
	            collapseAfter: function(node) {
	                this.setStartAfter(node);
	                this.collapse(true);
	            },
	
	            getBookmark: function(containerNode) {
	                var doc = getRangeDocument(this);
	                var preSelectionRange = api.createRange(doc);
	                containerNode = containerNode || dom.getBody(doc);
	                preSelectionRange.selectNodeContents(containerNode);
	                var range = this.intersection(preSelectionRange);
	                var start = 0, end = 0;
	                if (range) {
	                    preSelectionRange.setEnd(range.startContainer, range.startOffset);
	                    start = preSelectionRange.toString().length;
	                    end = start + range.toString().length;
	                }
	
	                return {
	                    start: start,
	                    end: end,
	                    containerNode: containerNode
	                };
	            },
	
	            moveToBookmark: function(bookmark) {
	                var containerNode = bookmark.containerNode;
	                var charIndex = 0;
	                this.setStart(containerNode, 0);
	                this.collapse(true);
	                var nodeStack = [containerNode], node, foundStart = false, stop = false;
	                var nextCharIndex, i, childNodes;
	
	                while (!stop && (node = nodeStack.pop())) {
	                    if (node.nodeType == 3) {
	                        nextCharIndex = charIndex + node.length;
	                        if (!foundStart && bookmark.start >= charIndex && bookmark.start <= nextCharIndex) {
	                            this.setStart(node, bookmark.start - charIndex);
	                            foundStart = true;
	                        }
	                        if (foundStart && bookmark.end >= charIndex && bookmark.end <= nextCharIndex) {
	                            this.setEnd(node, bookmark.end - charIndex);
	                            stop = true;
	                        }
	                        charIndex = nextCharIndex;
	                    } else {
	                        childNodes = node.childNodes;
	                        i = childNodes.length;
	                        while (i--) {
	                            nodeStack.push(childNodes[i]);
	                        }
	                    }
	                }
	            },
	
	            getName: function() {
	                return "DomRange";
	            },
	
	            equals: function(range) {
	                return Range.rangesEqual(this, range);
	            },
	
	            isValid: function() {
	                return isRangeValid(this);
	            },
	
	            inspect: function() {
	                return inspect(this);
	            },
	
	            detach: function() {
	                // In DOM4, detach() is now a no-op.
	            }
	        });
	
	        function copyComparisonConstantsToObject(obj) {
	            obj.START_TO_START = s2s;
	            obj.START_TO_END = s2e;
	            obj.END_TO_END = e2e;
	            obj.END_TO_START = e2s;
	
	            obj.NODE_BEFORE = n_b;
	            obj.NODE_AFTER = n_a;
	            obj.NODE_BEFORE_AND_AFTER = n_b_a;
	            obj.NODE_INSIDE = n_i;
	        }
	
	        function copyComparisonConstants(constructor) {
	            copyComparisonConstantsToObject(constructor);
	            copyComparisonConstantsToObject(constructor.prototype);
	        }
	
	        function createRangeContentRemover(remover, boundaryUpdater) {
	            return function() {
	                assertRangeValid(this);
	
	                var sc = this.startContainer, so = this.startOffset, root = this.commonAncestorContainer;
	
	                var iterator = new RangeIterator(this, true);
	
	                // Work out where to position the range after content removal
	                var node, boundary;
	                if (sc !== root) {
	                    node = getClosestAncestorIn(sc, root, true);
	                    boundary = getBoundaryAfterNode(node);
	                    sc = boundary.node;
	                    so = boundary.offset;
	                }
	
	                // Check none of the range is read-only
	                iterateSubtree(iterator, assertNodeNotReadOnly);
	
	                iterator.reset();
	
	                // Remove the content
	                var returnValue = remover(iterator);
	                iterator.detach();
	
	                // Move to the new position
	                boundaryUpdater(this, sc, so, sc, so);
	
	                return returnValue;
	            };
	        }
	
	        function createPrototypeRange(constructor, boundaryUpdater) {
	            function createBeforeAfterNodeSetter(isBefore, isStart) {
	                return function(node) {
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	                    assertValidNodeType(getRootContainer(node), rootContainerNodeTypes);
	
	                    var boundary = (isBefore ? getBoundaryBeforeNode : getBoundaryAfterNode)(node);
	                    (isStart ? setRangeStart : setRangeEnd)(this, boundary.node, boundary.offset);
	                };
	            }
	
	            function setRangeStart(range, node, offset) {
	                var ec = range.endContainer, eo = range.endOffset;
	                if (node !== range.startContainer || offset !== range.startOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(ec) || comparePoints(node, offset, ec, eo) == 1) {
	                        ec = node;
	                        eo = offset;
	                    }
	                    boundaryUpdater(range, node, offset, ec, eo);
	                }
	            }
	
	            function setRangeEnd(range, node, offset) {
	                var sc = range.startContainer, so = range.startOffset;
	                if (node !== range.endContainer || offset !== range.endOffset) {
	                    // Check the root containers of the range and the new boundary, and also check whether the new boundary
	                    // is after the current end. In either case, collapse the range to the new position
	                    if (getRootContainer(node) != getRootContainer(sc) || comparePoints(node, offset, sc, so) == -1) {
	                        sc = node;
	                        so = offset;
	                    }
	                    boundaryUpdater(range, sc, so, node, offset);
	                }
	            }
	
	            // Set up inheritance
	            var F = function() {};
	            F.prototype = api.rangePrototype;
	            constructor.prototype = new F();
	
	            util.extend(constructor.prototype, {
	                setStart: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeStart(this, node, offset);
	                },
	
	                setEnd: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	
	                    setRangeEnd(this, node, offset);
	                },
	
	                /**
	                 * Convenience method to set a range's start and end boundaries. Overloaded as follows:
	                 * - Two parameters (node, offset) creates a collapsed range at that position
	                 * - Three parameters (node, startOffset, endOffset) creates a range contained with node starting at
	                 *   startOffset and ending at endOffset
	                 * - Four parameters (startNode, startOffset, endNode, endOffset) creates a range starting at startOffset in
	                 *   startNode and ending at endOffset in endNode
	                 */
	                setStartAndEnd: function() {
	                    var args = arguments;
	                    var sc = args[0], so = args[1], ec = sc, eo = so;
	
	                    switch (args.length) {
	                        case 3:
	                            eo = args[2];
	                            break;
	                        case 4:
	                            ec = args[2];
	                            eo = args[3];
	                            break;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                setBoundary: function(node, offset, isStart) {
	                    this["set" + (isStart ? "Start" : "End")](node, offset);
	                },
	
	                setStartBefore: createBeforeAfterNodeSetter(true, true),
	                setStartAfter: createBeforeAfterNodeSetter(false, true),
	                setEndBefore: createBeforeAfterNodeSetter(true, false),
	                setEndAfter: createBeforeAfterNodeSetter(false, false),
	
	                collapse: function(isStart) {
	                    assertRangeValid(this);
	                    if (isStart) {
	                        boundaryUpdater(this, this.startContainer, this.startOffset, this.startContainer, this.startOffset);
	                    } else {
	                        boundaryUpdater(this, this.endContainer, this.endOffset, this.endContainer, this.endOffset);
	                    }
	                },
	
	                selectNodeContents: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	
	                    boundaryUpdater(this, node, 0, node, getNodeLength(node));
	                },
	
	                selectNode: function(node) {
	                    assertNoDocTypeNotationEntityAncestor(node, false);
	                    assertValidNodeType(node, beforeAfterNodeTypes);
	
	                    var start = getBoundaryBeforeNode(node), end = getBoundaryAfterNode(node);
	                    boundaryUpdater(this, start.node, start.offset, end.node, end.offset);
	                },
	
	                extractContents: createRangeContentRemover(extractSubtree, boundaryUpdater),
	
	                deleteContents: createRangeContentRemover(deleteSubtree, boundaryUpdater),
	
	                canSurroundContents: function() {
	                    assertRangeValid(this);
	                    assertNodeNotReadOnly(this.startContainer);
	                    assertNodeNotReadOnly(this.endContainer);
	
	                    // Check if the contents can be surrounded. Specifically, this means whether the range partially selects
	                    // no non-text nodes.
	                    var iterator = new RangeIterator(this, true);
	                    var boundariesInvalid = (iterator._first && isNonTextPartiallySelected(iterator._first, this) ||
	                            (iterator._last && isNonTextPartiallySelected(iterator._last, this)));
	                    iterator.detach();
	                    return !boundariesInvalid;
	                },
	
	                splitBoundaries: function() {
	                    splitRangeBoundaries(this);
	                },
	
	                splitBoundariesPreservingPositions: function(positionsToPreserve) {
	                    splitRangeBoundaries(this, positionsToPreserve);
	                },
	
	                normalizeBoundaries: function() {
	                    assertRangeValid(this);
	
	                    var sc = this.startContainer, so = this.startOffset, ec = this.endContainer, eo = this.endOffset;
	
	                    var mergeForward = function(node) {
	                        var sibling = node.nextSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            ec = node;
	                            eo = node.length;
	                            node.appendData(sibling.data);
	                            removeNode(sibling);
	                        }
	                    };
	
	                    var mergeBackward = function(node) {
	                        var sibling = node.previousSibling;
	                        if (sibling && sibling.nodeType == node.nodeType) {
	                            sc = node;
	                            var nodeLength = node.length;
	                            so = sibling.length;
	                            node.insertData(0, sibling.data);
	                            removeNode(sibling);
	                            if (sc == ec) {
	                                eo += so;
	                                ec = sc;
	                            } else if (ec == node.parentNode) {
	                                var nodeIndex = getNodeIndex(node);
	                                if (eo == nodeIndex) {
	                                    ec = node;
	                                    eo = nodeLength;
	                                } else if (eo > nodeIndex) {
	                                    eo--;
	                                }
	                            }
	                        }
	                    };
	
	                    var normalizeStart = true;
	                    var sibling;
	
	                    if (isCharacterDataNode(ec)) {
	                        if (eo == ec.length) {
	                            mergeForward(ec);
	                        } else if (eo == 0) {
	                            sibling = ec.previousSibling;
	                            if (sibling && sibling.nodeType == ec.nodeType) {
	                                eo = sibling.length;
	                                if (sc == ec) {
	                                    normalizeStart = false;
	                                }
	                                sibling.appendData(ec.data);
	                                removeNode(ec);
	                                ec = sibling;
	                            }
	                        }
	                    } else {
	                        if (eo > 0) {
	                            var endNode = ec.childNodes[eo - 1];
	                            if (endNode && isCharacterDataNode(endNode)) {
	                                mergeForward(endNode);
	                            }
	                        }
	                        normalizeStart = !this.collapsed;
	                    }
	
	                    if (normalizeStart) {
	                        if (isCharacterDataNode(sc)) {
	                            if (so == 0) {
	                                mergeBackward(sc);
	                            } else if (so == sc.length) {
	                                sibling = sc.nextSibling;
	                                if (sibling && sibling.nodeType == sc.nodeType) {
	                                    if (ec == sibling) {
	                                        ec = sc;
	                                        eo += sc.length;
	                                    }
	                                    sc.appendData(sibling.data);
	                                    removeNode(sibling);
	                                }
	                            }
	                        } else {
	                            if (so < sc.childNodes.length) {
	                                var startNode = sc.childNodes[so];
	                                if (startNode && isCharacterDataNode(startNode)) {
	                                    mergeBackward(startNode);
	                                }
	                            }
	                        }
	                    } else {
	                        sc = ec;
	                        so = eo;
	                    }
	
	                    boundaryUpdater(this, sc, so, ec, eo);
	                },
	
	                collapseToPoint: function(node, offset) {
	                    assertNoDocTypeNotationEntityAncestor(node, true);
	                    assertValidOffset(node, offset);
	                    this.setStartAndEnd(node, offset);
	                }
	            });
	
	            copyComparisonConstants(constructor);
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Updates commonAncestorContainer and collapsed after boundary change
	        function updateCollapsedAndCommonAncestor(range) {
	            range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	            range.commonAncestorContainer = range.collapsed ?
	                range.startContainer : dom.getCommonAncestor(range.startContainer, range.endContainer);
	        }
	
	        function updateBoundaries(range, startContainer, startOffset, endContainer, endOffset) {
	            range.startContainer = startContainer;
	            range.startOffset = startOffset;
	            range.endContainer = endContainer;
	            range.endOffset = endOffset;
	            range.document = dom.getDocument(startContainer);
	
	            updateCollapsedAndCommonAncestor(range);
	        }
	
	        function Range(doc) {
	            this.startContainer = doc;
	            this.startOffset = 0;
	            this.endContainer = doc;
	            this.endOffset = 0;
	            this.document = doc;
	            updateCollapsedAndCommonAncestor(this);
	        }
	
	        createPrototypeRange(Range, updateBoundaries);
	
	        util.extend(Range, {
	            rangeProperties: rangeProperties,
	            RangeIterator: RangeIterator,
	            copyComparisonConstants: copyComparisonConstants,
	            createPrototypeRange: createPrototypeRange,
	            inspect: inspect,
	            toHtml: rangeToHtml,
	            getRangeDocument: getRangeDocument,
	            rangesEqual: function(r1, r2) {
	                return r1.startContainer === r2.startContainer &&
	                    r1.startOffset === r2.startOffset &&
	                    r1.endContainer === r2.endContainer &&
	                    r1.endOffset === r2.endOffset;
	            }
	        });
	
	        api.DomRange = Range;
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wrappers for the browser's native DOM Range and/or TextRange implementation
	    api.createCoreModule("WrappedRange", ["DomRange"], function(api, module) {
	        var WrappedRange, WrappedTextRange;
	        var dom = api.dom;
	        var util = api.util;
	        var DomPosition = dom.DomPosition;
	        var DomRange = api.DomRange;
	        var getBody = dom.getBody;
	        var getContentDocument = dom.getContentDocument;
	        var isCharacterDataNode = dom.isCharacterDataNode;
	
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        if (api.features.implementsDomRange) {
	            // This is a wrapper around the browser's native DOM Range. It has two aims:
	            // - Provide workarounds for specific browser bugs
	            // - provide convenient extensions, which are inherited from Rangy's DomRange
	
	            (function() {
	                var rangeProto;
	                var rangeProperties = DomRange.rangeProperties;
	
	                function updateRangeProperties(range) {
	                    var i = rangeProperties.length, prop;
	                    while (i--) {
	                        prop = rangeProperties[i];
	                        range[prop] = range.nativeRange[prop];
	                    }
	                    // Fix for broken collapsed property in IE 9.
	                    range.collapsed = (range.startContainer === range.endContainer && range.startOffset === range.endOffset);
	                }
	
	                function updateNativeRange(range, startContainer, startOffset, endContainer, endOffset) {
	                    var startMoved = (range.startContainer !== startContainer || range.startOffset != startOffset);
	                    var endMoved = (range.endContainer !== endContainer || range.endOffset != endOffset);
	                    var nativeRangeDifferent = !range.equals(range.nativeRange);
	
	                    // Always set both boundaries for the benefit of IE9 (see issue 35)
	                    if (startMoved || endMoved || nativeRangeDifferent) {
	                        range.setEnd(endContainer, endOffset);
	                        range.setStart(startContainer, startOffset);
	                    }
	                }
	
	                var createBeforeAfterNodeSetter;
	
	                WrappedRange = function(range) {
	                    if (!range) {
	                        throw module.createError("WrappedRange: Range must be specified");
	                    }
	                    this.nativeRange = range;
	                    updateRangeProperties(this);
	                };
	
	                DomRange.createPrototypeRange(WrappedRange, updateNativeRange);
	
	                rangeProto = WrappedRange.prototype;
	
	                rangeProto.selectNode = function(node) {
	                    this.nativeRange.selectNode(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneContents = function() {
	                    return this.nativeRange.cloneContents();
	                };
	
	                // Due to a long-standing Firefox bug that I have not been able to find a reliable way to detect,
	                // insertNode() is never delegated to the native range.
	
	                rangeProto.surroundContents = function(node) {
	                    this.nativeRange.surroundContents(node);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.collapse = function(isStart) {
	                    this.nativeRange.collapse(isStart);
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.cloneRange = function() {
	                    return new WrappedRange(this.nativeRange.cloneRange());
	                };
	
	                rangeProto.refresh = function() {
	                    updateRangeProperties(this);
	                };
	
	                rangeProto.toString = function() {
	                    return this.nativeRange.toString();
	                };
	
	                // Create test range and node for feature detection
	
	                var testTextNode = document.createTextNode("test");
	                getBody(document).appendChild(testTextNode);
	                var range = document.createRange();
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for Firefox 2 bug that prevents moving the start of a Range to a point after its current end and
	                // correct for it
	
	                range.setStart(testTextNode, 0);
	                range.setEnd(testTextNode, 0);
	
	                try {
	                    range.setStart(testTextNode, 1);
	
	                    rangeProto.setStart = function(node, offset) {
	                        this.nativeRange.setStart(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        this.nativeRange.setEnd(node, offset);
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name) {
	                        return function(node) {
	                            this.nativeRange[name](node);
	                            updateRangeProperties(this);
	                        };
	                    };
	
	                } catch(ex) {
	
	                    rangeProto.setStart = function(node, offset) {
	                        try {
	                            this.nativeRange.setStart(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setEnd(node, offset);
	                            this.nativeRange.setStart(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.setEnd = function(node, offset) {
	                        try {
	                            this.nativeRange.setEnd(node, offset);
	                        } catch (ex) {
	                            this.nativeRange.setStart(node, offset);
	                            this.nativeRange.setEnd(node, offset);
	                        }
	                        updateRangeProperties(this);
	                    };
	
	                    createBeforeAfterNodeSetter = function(name, oppositeName) {
	                        return function(node) {
	                            try {
	                                this.nativeRange[name](node);
	                            } catch (ex) {
	                                this.nativeRange[oppositeName](node);
	                                this.nativeRange[name](node);
	                            }
	                            updateRangeProperties(this);
	                        };
	                    };
	                }
	
	                rangeProto.setStartBefore = createBeforeAfterNodeSetter("setStartBefore", "setEndBefore");
	                rangeProto.setStartAfter = createBeforeAfterNodeSetter("setStartAfter", "setEndAfter");
	                rangeProto.setEndBefore = createBeforeAfterNodeSetter("setEndBefore", "setStartBefore");
	                rangeProto.setEndAfter = createBeforeAfterNodeSetter("setEndAfter", "setStartAfter");
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Always use DOM4-compliant selectNodeContents implementation: it's simpler and less code than testing
	                // whether the native implementation can be trusted
	                rangeProto.selectNodeContents = function(node) {
	                    this.setStartAndEnd(node, 0, dom.getNodeLength(node));
	                };
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for and correct WebKit bug that has the behaviour of compareBoundaryPoints round the wrong way for
	                // constants START_TO_END and END_TO_START: https://bugs.webkit.org/show_bug.cgi?id=20738
	
	                range.selectNodeContents(testTextNode);
	                range.setEnd(testTextNode, 3);
	
	                var range2 = document.createRange();
	                range2.selectNodeContents(testTextNode);
	                range2.setEnd(testTextNode, 4);
	                range2.setStart(testTextNode, 2);
	
	                if (range.compareBoundaryPoints(range.START_TO_END, range2) == -1 &&
	                        range.compareBoundaryPoints(range.END_TO_START, range2) == 1) {
	                    // This is the wrong way round, so correct for it
	
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        range = range.nativeRange || range;
	                        if (type == range.START_TO_END) {
	                            type = range.END_TO_START;
	                        } else if (type == range.END_TO_START) {
	                            type = range.START_TO_END;
	                        }
	                        return this.nativeRange.compareBoundaryPoints(type, range);
	                    };
	                } else {
	                    rangeProto.compareBoundaryPoints = function(type, range) {
	                        return this.nativeRange.compareBoundaryPoints(type, range.nativeRange || range);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for IE deleteContents() and extractContents() bug and correct it. See issue 107.
	
	                var el = document.createElement("div");
	                el.innerHTML = "123";
	                var textNode = el.firstChild;
	                var body = getBody(document);
	                body.appendChild(el);
	
	                range.setStart(textNode, 1);
	                range.setEnd(textNode, 2);
	                range.deleteContents();
	
	                if (textNode.data == "13") {
	                    // Behaviour is correct per DOM4 Range so wrap the browser's implementation of deleteContents() and
	                    // extractContents()
	                    rangeProto.deleteContents = function() {
	                        this.nativeRange.deleteContents();
	                        updateRangeProperties(this);
	                    };
	
	                    rangeProto.extractContents = function() {
	                        var frag = this.nativeRange.extractContents();
	                        updateRangeProperties(this);
	                        return frag;
	                    };
	                } else {
	                }
	
	                body.removeChild(el);
	                body = null;
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Test for existence of createContextualFragment and delegate to it if it exists
	                if (util.isHostMethod(range, "createContextualFragment")) {
	                    rangeProto.createContextualFragment = function(fragmentStr) {
	                        return this.nativeRange.createContextualFragment(fragmentStr);
	                    };
	                }
	
	                /*--------------------------------------------------------------------------------------------------------*/
	
	                // Clean up
	                getBody(document).removeChild(testTextNode);
	
	                rangeProto.getName = function() {
	                    return "WrappedRange";
	                };
	
	                api.WrappedRange = WrappedRange;
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return doc.createRange();
	                };
	            })();
	        }
	
	        if (api.features.implementsTextRange) {
	            /*
	            This is a workaround for a bug where IE returns the wrong container element from the TextRange's parentElement()
	            method. For example, in the following (where pipes denote the selection boundaries):
	
	            <ul id="ul"><li id="a">| a </li><li id="b"> b |</li></ul>
	
	            var range = document.selection.createRange();
	            alert(range.parentElement().id); // Should alert "ul" but alerts "b"
	
	            This method returns the common ancestor node of the following:
	            - the parentElement() of the textRange
	            - the parentElement() of the textRange after calling collapse(true)
	            - the parentElement() of the textRange after calling collapse(false)
	            */
	            var getTextRangeContainerElement = function(textRange) {
	                var parentEl = textRange.parentElement();
	                var range = textRange.duplicate();
	                range.collapse(true);
	                var startEl = range.parentElement();
	                range = textRange.duplicate();
	                range.collapse(false);
	                var endEl = range.parentElement();
	                var startEndContainer = (startEl == endEl) ? startEl : dom.getCommonAncestor(startEl, endEl);
	
	                return startEndContainer == parentEl ? startEndContainer : dom.getCommonAncestor(parentEl, startEndContainer);
	            };
	
	            var textRangeIsCollapsed = function(textRange) {
	                return textRange.compareEndPoints("StartToEnd", textRange) == 0;
	            };
	
	            // Gets the boundary of a TextRange expressed as a node and an offset within that node. This function started
	            // out as an improved version of code found in Tim Cameron Ryan's IERange (http://code.google.com/p/ierange/)
	            // but has grown, fixing problems with line breaks in preformatted text, adding workaround for IE TextRange
	            // bugs, handling for inputs and images, plus optimizations.
	            var getTextRangeBoundaryPosition = function(textRange, wholeRangeContainerElement, isStart, isCollapsed, startInfo) {
	                var workingRange = textRange.duplicate();
	                workingRange.collapse(isStart);
	                var containerElement = workingRange.parentElement();
	
	                // Sometimes collapsing a TextRange that's at the start of a text node can move it into the previous node, so
	                // check for that
	                if (!dom.isOrIsAncestorOf(wholeRangeContainerElement, containerElement)) {
	                    containerElement = wholeRangeContainerElement;
	                }
	
	
	                // Deal with nodes that cannot "contain rich HTML markup". In practice, this means form inputs, images and
	                // similar. See http://msdn.microsoft.com/en-us/library/aa703950%28VS.85%29.aspx
	                if (!containerElement.canHaveHTML) {
	                    var pos = new DomPosition(containerElement.parentNode, dom.getNodeIndex(containerElement));
	                    return {
	                        boundaryPosition: pos,
	                        nodeInfo: {
	                            nodeIndex: pos.offset,
	                            containerElement: pos.node
	                        }
	                    };
	                }
	
	                var workingNode = dom.getDocument(containerElement).createElement("span");
	
	                // Workaround for HTML5 Shiv's insane violation of document.createElement(). See Rangy issue 104 and HTML5
	                // Shiv issue 64: https://github.com/aFarkas/html5shiv/issues/64
	                if (workingNode.parentNode) {
	                    dom.removeNode(workingNode);
	                }
	
	                var comparison, workingComparisonType = isStart ? "StartToStart" : "StartToEnd";
	                var previousNode, nextNode, boundaryPosition, boundaryNode;
	                var start = (startInfo && startInfo.containerElement == containerElement) ? startInfo.nodeIndex : 0;
	                var childNodeCount = containerElement.childNodes.length;
	                var end = childNodeCount;
	
	                // Check end first. Code within the loop assumes that the endth child node of the container is definitely
	                // after the range boundary.
	                var nodeIndex = end;
	
	                while (true) {
	                    if (nodeIndex == childNodeCount) {
	                        containerElement.appendChild(workingNode);
	                    } else {
	                        containerElement.insertBefore(workingNode, containerElement.childNodes[nodeIndex]);
	                    }
	                    workingRange.moveToElementText(workingNode);
	                    comparison = workingRange.compareEndPoints(workingComparisonType, textRange);
	                    if (comparison == 0 || start == end) {
	                        break;
	                    } else if (comparison == -1) {
	                        if (end == start + 1) {
	                            // We know the endth child node is after the range boundary, so we must be done.
	                            break;
	                        } else {
	                            start = nodeIndex;
	                        }
	                    } else {
	                        end = (end == start + 1) ? start : nodeIndex;
	                    }
	                    nodeIndex = Math.floor((start + end) / 2);
	                    containerElement.removeChild(workingNode);
	                }
	
	
	                // We've now reached or gone past the boundary of the text range we're interested in
	                // so have identified the node we want
	                boundaryNode = workingNode.nextSibling;
	
	                if (comparison == -1 && boundaryNode && isCharacterDataNode(boundaryNode)) {
	                    // This is a character data node (text, comment, cdata). The working range is collapsed at the start of
	                    // the node containing the text range's boundary, so we move the end of the working range to the
	                    // boundary point and measure the length of its text to get the boundary's offset within the node.
	                    workingRange.setEndPoint(isStart ? "EndToStart" : "EndToEnd", textRange);
	
	                    var offset;
	
	                    if (/[\r\n]/.test(boundaryNode.data)) {
	                        /*
	                        For the particular case of a boundary within a text node containing rendered line breaks (within a
	                        <pre> element, for example), we need a slightly complicated approach to get the boundary's offset in
	                        IE. The facts:
	
	                        - Each line break is represented as \r in the text node's data/nodeValue properties
	                        - Each line break is represented as \r\n in the TextRange's 'text' property
	                        - The 'text' property of the TextRange does not contain trailing line breaks
	
	                        To get round the problem presented by the final fact above, we can use the fact that TextRange's
	                        moveStart() and moveEnd() methods return the actual number of characters moved, which is not
	                        necessarily the same as the number of characters it was instructed to move. The simplest approach is
	                        to use this to store the characters moved when moving both the start and end of the range to the
	                        start of the document body and subtracting the start offset from the end offset (the
	                        "move-negative-gazillion" method). However, this is extremely slow when the document is large and
	                        the range is near the end of it. Clearly doing the mirror image (i.e. moving the range boundaries to
	                        the end of the document) has the same problem.
	
	                        Another approach that works is to use moveStart() to move the start boundary of the range up to the
	                        end boundary one character at a time and incrementing a counter with the value returned by the
	                        moveStart() call. However, the check for whether the start boundary has reached the end boundary is
	                        expensive, so this method is slow (although unlike "move-negative-gazillion" is largely unaffected
	                        by the location of the range within the document).
	
	                        The approach used below is a hybrid of the two methods above. It uses the fact that a string
	                        containing the TextRange's 'text' property with each \r\n converted to a single \r character cannot
	                        be longer than the text of the TextRange, so the start of the range is moved that length initially
	                        and then a character at a time to make up for any trailing line breaks not contained in the 'text'
	                        property. This has good performance in most situations compared to the previous two methods.
	                        */
	                        var tempRange = workingRange.duplicate();
	                        var rangeLength = tempRange.text.replace(/\r\n/g, "\r").length;
	
	                        offset = tempRange.moveStart("character", rangeLength);
	                        while ( (comparison = tempRange.compareEndPoints("StartToEnd", tempRange)) == -1) {
	                            offset++;
	                            tempRange.moveStart("character", 1);
	                        }
	                    } else {
	                        offset = workingRange.text.length;
	                    }
	                    boundaryPosition = new DomPosition(boundaryNode, offset);
	                } else {
	
	                    // If the boundary immediately follows a character data node and this is the end boundary, we should favour
	                    // a position within that, and likewise for a start boundary preceding a character data node
	                    previousNode = (isCollapsed || !isStart) && workingNode.previousSibling;
	                    nextNode = (isCollapsed || isStart) && workingNode.nextSibling;
	                    if (nextNode && isCharacterDataNode(nextNode)) {
	                        boundaryPosition = new DomPosition(nextNode, 0);
	                    } else if (previousNode && isCharacterDataNode(previousNode)) {
	                        boundaryPosition = new DomPosition(previousNode, previousNode.data.length);
	                    } else {
	                        boundaryPosition = new DomPosition(containerElement, dom.getNodeIndex(workingNode));
	                    }
	                }
	
	                // Clean up
	                dom.removeNode(workingNode);
	
	                return {
	                    boundaryPosition: boundaryPosition,
	                    nodeInfo: {
	                        nodeIndex: nodeIndex,
	                        containerElement: containerElement
	                    }
	                };
	            };
	
	            // Returns a TextRange representing the boundary of a TextRange expressed as a node and an offset within that
	            // node. This function started out as an optimized version of code found in Tim Cameron Ryan's IERange
	            // (http://code.google.com/p/ierange/)
	            var createBoundaryTextRange = function(boundaryPosition, isStart) {
	                var boundaryNode, boundaryParent, boundaryOffset = boundaryPosition.offset;
	                var doc = dom.getDocument(boundaryPosition.node);
	                var workingNode, childNodes, workingRange = getBody(doc).createTextRange();
	                var nodeIsDataNode = isCharacterDataNode(boundaryPosition.node);
	
	                if (nodeIsDataNode) {
	                    boundaryNode = boundaryPosition.node;
	                    boundaryParent = boundaryNode.parentNode;
	                } else {
	                    childNodes = boundaryPosition.node.childNodes;
	                    boundaryNode = (boundaryOffset < childNodes.length) ? childNodes[boundaryOffset] : null;
	                    boundaryParent = boundaryPosition.node;
	                }
	
	                // Position the range immediately before the node containing the boundary
	                workingNode = doc.createElement("span");
	
	                // Making the working element non-empty element persuades IE to consider the TextRange boundary to be within
	                // the element rather than immediately before or after it
	                workingNode.innerHTML = "&#feff;";
	
	                // insertBefore is supposed to work like appendChild if the second parameter is null. However, a bug report
	                // for IERange suggests that it can crash the browser: http://code.google.com/p/ierange/issues/detail?id=12
	                if (boundaryNode) {
	                    boundaryParent.insertBefore(workingNode, boundaryNode);
	                } else {
	                    boundaryParent.appendChild(workingNode);
	                }
	
	                workingRange.moveToElementText(workingNode);
	                workingRange.collapse(!isStart);
	
	                // Clean up
	                boundaryParent.removeChild(workingNode);
	
	                // Move the working range to the text offset, if required
	                if (nodeIsDataNode) {
	                    workingRange[isStart ? "moveStart" : "moveEnd"]("character", boundaryOffset);
	                }
	
	                return workingRange;
	            };
	
	            /*------------------------------------------------------------------------------------------------------------*/
	
	            // This is a wrapper around a TextRange, providing full DOM Range functionality using rangy's DomRange as a
	            // prototype
	
	            WrappedTextRange = function(textRange) {
	                this.textRange = textRange;
	                this.refresh();
	            };
	
	            WrappedTextRange.prototype = new DomRange(document);
	
	            WrappedTextRange.prototype.refresh = function() {
	                var start, end, startBoundary;
	
	                // TextRange's parentElement() method cannot be trusted. getTextRangeContainerElement() works around that.
	                var rangeContainerElement = getTextRangeContainerElement(this.textRange);
	
	                if (textRangeIsCollapsed(this.textRange)) {
	                    end = start = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true,
	                        true).boundaryPosition;
	                } else {
	                    startBoundary = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, true, false);
	                    start = startBoundary.boundaryPosition;
	
	                    // An optimization used here is that if the start and end boundaries have the same parent element, the
	                    // search scope for the end boundary can be limited to exclude the portion of the element that precedes
	                    // the start boundary
	                    end = getTextRangeBoundaryPosition(this.textRange, rangeContainerElement, false, false,
	                        startBoundary.nodeInfo).boundaryPosition;
	                }
	
	                this.setStart(start.node, start.offset);
	                this.setEnd(end.node, end.offset);
	            };
	
	            WrappedTextRange.prototype.getName = function() {
	                return "WrappedTextRange";
	            };
	
	            DomRange.copyComparisonConstants(WrappedTextRange);
	
	            var rangeToTextRange = function(range) {
	                if (range.collapsed) {
	                    return createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                } else {
	                    var startRange = createBoundaryTextRange(new DomPosition(range.startContainer, range.startOffset), true);
	                    var endRange = createBoundaryTextRange(new DomPosition(range.endContainer, range.endOffset), false);
	                    var textRange = getBody( DomRange.getRangeDocument(range) ).createTextRange();
	                    textRange.setEndPoint("StartToStart", startRange);
	                    textRange.setEndPoint("EndToEnd", endRange);
	                    return textRange;
	                }
	            };
	
	            WrappedTextRange.rangeToTextRange = rangeToTextRange;
	
	            WrappedTextRange.prototype.toTextRange = function() {
	                return rangeToTextRange(this);
	            };
	
	            api.WrappedTextRange = WrappedTextRange;
	
	            // IE 9 and above have both implementations and Rangy makes both available. The next few lines sets which
	            // implementation to use by default.
	            if (!api.features.implementsDomRange || api.config.preferTextRange) {
	                // Add WrappedTextRange as the Range property of the global object to allow expression like Range.END_TO_END to work
	                var globalObj = (function(f) { return f("return this;")(); })(Function);
	                if (typeof globalObj.Range == "undefined") {
	                    globalObj.Range = WrappedTextRange;
	                }
	
	                api.createNativeRange = function(doc) {
	                    doc = getContentDocument(doc, module, "createNativeRange");
	                    return getBody(doc).createTextRange();
	                };
	
	                api.WrappedRange = WrappedTextRange;
	            }
	        }
	
	        api.createRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRange");
	            return new api.WrappedRange(api.createNativeRange(doc));
	        };
	
	        api.createRangyRange = function(doc) {
	            doc = getContentDocument(doc, module, "createRangyRange");
	            return new DomRange(doc);
	        };
	
	        util.createAliasForDeprecatedMethod(api, "createIframeRange", "createRange");
	        util.createAliasForDeprecatedMethod(api, "createIframeRangyRange", "createRangyRange");
	
	        api.addShimListener(function(win) {
	            var doc = win.document;
	            if (typeof doc.createRange == "undefined") {
	                doc.createRange = function() {
	                    return api.createRange(doc);
	                };
	            }
	            doc = win = null;
	        });
	    });
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // This module creates a selection object wrapper that conforms as closely as possible to the Selection specification
	    // in the HTML Editing spec (http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html#selections)
	    api.createCoreModule("WrappedSelection", ["DomRange", "WrappedRange"], function(api, module) {
	        api.config.checkSelectionRanges = true;
	
	        var BOOLEAN = "boolean";
	        var NUMBER = "number";
	        var dom = api.dom;
	        var util = api.util;
	        var isHostMethod = util.isHostMethod;
	        var DomRange = api.DomRange;
	        var WrappedRange = api.WrappedRange;
	        var DOMException = api.DOMException;
	        var DomPosition = dom.DomPosition;
	        var getNativeSelection;
	        var selectionIsCollapsed;
	        var features = api.features;
	        var CONTROL = "Control";
	        var getDocument = dom.getDocument;
	        var getBody = dom.getBody;
	        var rangesEqual = DomRange.rangesEqual;
	
	
	        // Utility function to support direction parameters in the API that may be a string ("backward", "backwards",
	        // "forward" or "forwards") or a Boolean (true for backwards).
	        function isDirectionBackward(dir) {
	            return (typeof dir == "string") ? /^backward(s)?$/i.test(dir) : !!dir;
	        }
	
	        function getWindow(win, methodName) {
	            if (!win) {
	                return window;
	            } else if (dom.isWindow(win)) {
	                return win;
	            } else if (win instanceof WrappedSelection) {
	                return win.win;
	            } else {
	                var doc = dom.getContentDocument(win, module, methodName);
	                return dom.getWindow(doc);
	            }
	        }
	
	        function getWinSelection(winParam) {
	            return getWindow(winParam, "getWinSelection").getSelection();
	        }
	
	        function getDocSelection(winParam) {
	            return getWindow(winParam, "getDocSelection").document.selection;
	        }
	
	        function winSelectionIsBackward(sel) {
	            var backward = false;
	            if (sel.anchorNode) {
	                backward = (dom.comparePoints(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset) == 1);
	            }
	            return backward;
	        }
	
	        // Test for the Range/TextRange and Selection features required
	        // Test for ability to retrieve selection
	        var implementsWinGetSelection = isHostMethod(window, "getSelection"),
	            implementsDocSelection = util.isHostObject(document, "selection");
	
	        features.implementsWinGetSelection = implementsWinGetSelection;
	        features.implementsDocSelection = implementsDocSelection;
	
	        var useDocumentSelection = implementsDocSelection && (!implementsWinGetSelection || api.config.preferTextRange);
	
	        if (useDocumentSelection) {
	            getNativeSelection = getDocSelection;
	            api.isSelectionValid = function(winParam) {
	                var doc = getWindow(winParam, "isSelectionValid").document, nativeSel = doc.selection;
	
	                // Check whether the selection TextRange is actually contained within the correct document
	                return (nativeSel.type != "None" || getDocument(nativeSel.createRange().parentElement()) == doc);
	            };
	        } else if (implementsWinGetSelection) {
	            getNativeSelection = getWinSelection;
	            api.isSelectionValid = function() {
	                return true;
	            };
	        } else {
	            module.fail("Neither document.selection or window.getSelection() detected.");
	            return false;
	        }
	
	        api.getNativeSelection = getNativeSelection;
	
	        var testSelection = getNativeSelection();
	
	        // In Firefox, the selection is null in an iframe with display: none. See issue #138.
	        if (!testSelection) {
	            module.fail("Native selection was null (possibly issue 138?)");
	            return false;
	        }
	
	        var testRange = api.createNativeRange(document);
	        var body = getBody(document);
	
	        // Obtaining a range from a selection
	        var selectionHasAnchorAndFocus = util.areHostProperties(testSelection,
	            ["anchorNode", "focusNode", "anchorOffset", "focusOffset"]);
	
	        features.selectionHasAnchorAndFocus = selectionHasAnchorAndFocus;
	
	        // Test for existence of native selection extend() method
	        var selectionHasExtend = isHostMethod(testSelection, "extend");
	        features.selectionHasExtend = selectionHasExtend;
	
	        // Test if rangeCount exists
	        var selectionHasRangeCount = (typeof testSelection.rangeCount == NUMBER);
	        features.selectionHasRangeCount = selectionHasRangeCount;
	
	        var selectionSupportsMultipleRanges = false;
	        var collapsedNonEditableSelectionsSupported = true;
	
	        var addRangeBackwardToNative = selectionHasExtend ?
	            function(nativeSelection, range) {
	                var doc = DomRange.getRangeDocument(range);
	                var endRange = api.createRange(doc);
	                endRange.collapseToPoint(range.endContainer, range.endOffset);
	                nativeSelection.addRange(getNativeRange(endRange));
	                nativeSelection.extend(range.startContainer, range.startOffset);
	            } : null;
	
	        if (util.areHostMethods(testSelection, ["addRange", "getRangeAt", "removeAllRanges"]) &&
	                typeof testSelection.rangeCount == NUMBER && features.implementsDomRange) {
	
	            (function() {
	                // Previously an iframe was used but this caused problems in some circumstances in IE, so tests are
	                // performed on the current document's selection. See issue 109.
	
	                // Note also that if a selection previously existed, it is wiped and later restored by these tests. This
	                // will result in the selection direction begin reversed if the original selection was backwards and the
	                // browser does not support setting backwards selections (Internet Explorer, I'm looking at you).
	                var sel = window.getSelection();
	                if (sel) {
	                    // Store the current selection
	                    var originalSelectionRangeCount = sel.rangeCount;
	                    var selectionHasMultipleRanges = (originalSelectionRangeCount > 1);
	                    var originalSelectionRanges = [];
	                    var originalSelectionBackward = winSelectionIsBackward(sel);
	                    for (var i = 0; i < originalSelectionRangeCount; ++i) {
	                        originalSelectionRanges[i] = sel.getRangeAt(i);
	                    }
	
	                    // Create some test elements
	                    var testEl = dom.createTestElement(document, "", false);
	                    var textNode = testEl.appendChild( document.createTextNode("\u00a0\u00a0\u00a0") );
	
	                    // Test whether the native selection will allow a collapsed selection within a non-editable element
	                    var r1 = document.createRange();
	
	                    r1.setStart(textNode, 1);
	                    r1.collapse(true);
	                    sel.removeAllRanges();
	                    sel.addRange(r1);
	                    collapsedNonEditableSelectionsSupported = (sel.rangeCount == 1);
	                    sel.removeAllRanges();
	
	                    // Test whether the native selection is capable of supporting multiple ranges.
	                    if (!selectionHasMultipleRanges) {
	                        // Doing the original feature test here in Chrome 36 (and presumably later versions) prints a
	                        // console error of "Discontiguous selection is not supported." that cannot be suppressed. There's
	                        // nothing we can do about this while retaining the feature test so we have to resort to a browser
	                        // sniff. I'm not happy about it. See
	                        // https://code.google.com/p/chromium/issues/detail?id=399791
	                        var chromeMatch = window.navigator.appVersion.match(/Chrome\/(.*?) /);
	                        if (chromeMatch && parseInt(chromeMatch[1]) >= 36) {
	                            selectionSupportsMultipleRanges = false;
	                        } else {
	                            var r2 = r1.cloneRange();
	                            r1.setStart(textNode, 0);
	                            r2.setEnd(textNode, 3);
	                            r2.setStart(textNode, 2);
	                            sel.addRange(r1);
	                            sel.addRange(r2);
	                            selectionSupportsMultipleRanges = (sel.rangeCount == 2);
	                        }
	                    }
	
	                    // Clean up
	                    dom.removeNode(testEl);
	                    sel.removeAllRanges();
	
	                    for (i = 0; i < originalSelectionRangeCount; ++i) {
	                        if (i == 0 && originalSelectionBackward) {
	                            if (addRangeBackwardToNative) {
	                                addRangeBackwardToNative(sel, originalSelectionRanges[i]);
	                            } else {
	                                api.warn("Rangy initialization: original selection was backwards but selection has been restored forwards because the browser does not support Selection.extend");
	                                sel.addRange(originalSelectionRanges[i]);
	                            }
	                        } else {
	                            sel.addRange(originalSelectionRanges[i]);
	                        }
	                    }
	                }
	            })();
	        }
	
	        features.selectionSupportsMultipleRanges = selectionSupportsMultipleRanges;
	        features.collapsedNonEditableSelectionsSupported = collapsedNonEditableSelectionsSupported;
	
	        // ControlRanges
	        var implementsControlRange = false, testControlRange;
	
	        if (body && isHostMethod(body, "createControlRange")) {
	            testControlRange = body.createControlRange();
	            if (util.areHostProperties(testControlRange, ["item", "add"])) {
	                implementsControlRange = true;
	            }
	        }
	        features.implementsControlRange = implementsControlRange;
	
	        // Selection collapsedness
	        if (selectionHasAnchorAndFocus) {
	            selectionIsCollapsed = function(sel) {
	                return sel.anchorNode === sel.focusNode && sel.anchorOffset === sel.focusOffset;
	            };
	        } else {
	            selectionIsCollapsed = function(sel) {
	                return sel.rangeCount ? sel.getRangeAt(sel.rangeCount - 1).collapsed : false;
	            };
	        }
	
	        function updateAnchorAndFocusFromRange(sel, range, backward) {
	            var anchorPrefix = backward ? "end" : "start", focusPrefix = backward ? "start" : "end";
	            sel.anchorNode = range[anchorPrefix + "Container"];
	            sel.anchorOffset = range[anchorPrefix + "Offset"];
	            sel.focusNode = range[focusPrefix + "Container"];
	            sel.focusOffset = range[focusPrefix + "Offset"];
	        }
	
	        function updateAnchorAndFocusFromNativeSelection(sel) {
	            var nativeSel = sel.nativeSelection;
	            sel.anchorNode = nativeSel.anchorNode;
	            sel.anchorOffset = nativeSel.anchorOffset;
	            sel.focusNode = nativeSel.focusNode;
	            sel.focusOffset = nativeSel.focusOffset;
	        }
	
	        function updateEmptySelection(sel) {
	            sel.anchorNode = sel.focusNode = null;
	            sel.anchorOffset = sel.focusOffset = 0;
	            sel.rangeCount = 0;
	            sel.isCollapsed = true;
	            sel._ranges.length = 0;
	        }
	
	        function getNativeRange(range) {
	            var nativeRange;
	            if (range instanceof DomRange) {
	                nativeRange = api.createNativeRange(range.getDocument());
	                nativeRange.setEnd(range.endContainer, range.endOffset);
	                nativeRange.setStart(range.startContainer, range.startOffset);
	            } else if (range instanceof WrappedRange) {
	                nativeRange = range.nativeRange;
	            } else if (features.implementsDomRange && (range instanceof dom.getWindow(range.startContainer).Range)) {
	                nativeRange = range;
	            }
	            return nativeRange;
	        }
	
	        function rangeContainsSingleElement(rangeNodes) {
	            if (!rangeNodes.length || rangeNodes[0].nodeType != 1) {
	                return false;
	            }
	            for (var i = 1, len = rangeNodes.length; i < len; ++i) {
	                if (!dom.isAncestorOf(rangeNodes[0], rangeNodes[i])) {
	                    return false;
	                }
	            }
	            return true;
	        }
	
	        function getSingleElementFromRange(range) {
	            var nodes = range.getNodes();
	            if (!rangeContainsSingleElement(nodes)) {
	                throw module.createError("getSingleElementFromRange: range " + range.inspect() + " did not consist of a single element");
	            }
	            return nodes[0];
	        }
	
	        // Simple, quick test which only needs to distinguish between a TextRange and a ControlRange
	        function isTextRange(range) {
	            return !!range && typeof range.text != "undefined";
	        }
	
	        function updateFromTextRange(sel, range) {
	            // Create a Range from the selected TextRange
	            var wrappedRange = new WrappedRange(range);
	            sel._ranges = [wrappedRange];
	
	            updateAnchorAndFocusFromRange(sel, wrappedRange, false);
	            sel.rangeCount = 1;
	            sel.isCollapsed = wrappedRange.collapsed;
	        }
	
	        function updateControlSelection(sel) {
	            // Update the wrapped selection based on what's now in the native selection
	            sel._ranges.length = 0;
	            if (sel.docSelection.type == "None") {
	                updateEmptySelection(sel);
	            } else {
	                var controlRange = sel.docSelection.createRange();
	                if (isTextRange(controlRange)) {
	                    // This case (where the selection type is "Control" and calling createRange() on the selection returns
	                    // a TextRange) can happen in IE 9. It happens, for example, when all elements in the selected
	                    // ControlRange have been removed from the ControlRange and removed from the document.
	                    updateFromTextRange(sel, controlRange);
	                } else {
	                    sel.rangeCount = controlRange.length;
	                    var range, doc = getDocument(controlRange.item(0));
	                    for (var i = 0; i < sel.rangeCount; ++i) {
	                        range = api.createRange(doc);
	                        range.selectNode(controlRange.item(i));
	                        sel._ranges.push(range);
	                    }
	                    sel.isCollapsed = sel.rangeCount == 1 && sel._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], false);
	                }
	            }
	        }
	
	        function addRangeToControlSelection(sel, range) {
	            var controlRange = sel.docSelection.createRange();
	            var rangeElement = getSingleElementFromRange(range);
	
	            // Create a new ControlRange containing all the elements in the selected ControlRange plus the element
	            // contained by the supplied range
	            var doc = getDocument(controlRange.item(0));
	            var newControlRange = getBody(doc).createControlRange();
	            for (var i = 0, len = controlRange.length; i < len; ++i) {
	                newControlRange.add(controlRange.item(i));
	            }
	            try {
	                newControlRange.add(rangeElement);
	            } catch (ex) {
	                throw module.createError("addRange(): Element within the specified Range could not be added to control selection (does it have layout?)");
	            }
	            newControlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        var getSelectionRangeAt;
	
	        if (isHostMethod(testSelection, "getRangeAt")) {
	            // try/catch is present because getRangeAt() must have thrown an error in some browser and some situation.
	            // Unfortunately, I didn't write a comment about the specifics and am now scared to take it out. Let that be a
	            // lesson to us all, especially me.
	            getSelectionRangeAt = function(sel, index) {
	                try {
	                    return sel.getRangeAt(index);
	                } catch (ex) {
	                    return null;
	                }
	            };
	        } else if (selectionHasAnchorAndFocus) {
	            getSelectionRangeAt = function(sel) {
	                var doc = getDocument(sel.anchorNode);
	                var range = api.createRange(doc);
	                range.setStartAndEnd(sel.anchorNode, sel.anchorOffset, sel.focusNode, sel.focusOffset);
	
	                // Handle the case when the selection was selected backwards (from the end to the start in the
	                // document)
	                if (range.collapsed !== this.isCollapsed) {
	                    range.setStartAndEnd(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset);
	                }
	
	                return range;
	            };
	        }
	
	        function WrappedSelection(selection, docSelection, win) {
	            this.nativeSelection = selection;
	            this.docSelection = docSelection;
	            this._ranges = [];
	            this.win = win;
	            this.refresh();
	        }
	
	        WrappedSelection.prototype = api.selectionPrototype;
	
	        function deleteProperties(sel) {
	            sel.win = sel.anchorNode = sel.focusNode = sel._ranges = null;
	            sel.rangeCount = sel.anchorOffset = sel.focusOffset = 0;
	            sel.detached = true;
	        }
	
	        var cachedRangySelections = [];
	
	        function actOnCachedSelection(win, action) {
	            var i = cachedRangySelections.length, cached, sel;
	            while (i--) {
	                cached = cachedRangySelections[i];
	                sel = cached.selection;
	                if (action == "deleteAll") {
	                    deleteProperties(sel);
	                } else if (cached.win == win) {
	                    if (action == "delete") {
	                        cachedRangySelections.splice(i, 1);
	                        return true;
	                    } else {
	                        return sel;
	                    }
	                }
	            }
	            if (action == "deleteAll") {
	                cachedRangySelections.length = 0;
	            }
	            return null;
	        }
	
	        var getSelection = function(win) {
	            // Check if the parameter is a Rangy Selection object
	            if (win && win instanceof WrappedSelection) {
	                win.refresh();
	                return win;
	            }
	
	            win = getWindow(win, "getNativeSelection");
	
	            var sel = actOnCachedSelection(win);
	            var nativeSel = getNativeSelection(win), docSel = implementsDocSelection ? getDocSelection(win) : null;
	            if (sel) {
	                sel.nativeSelection = nativeSel;
	                sel.docSelection = docSel;
	                sel.refresh();
	            } else {
	                sel = new WrappedSelection(nativeSel, docSel, win);
	                cachedRangySelections.push( { win: win, selection: sel } );
	            }
	            return sel;
	        };
	
	        api.getSelection = getSelection;
	
	        util.createAliasForDeprecatedMethod(api, "getIframeSelection", "getSelection");
	
	        var selProto = WrappedSelection.prototype;
	
	        function createControlSelection(sel, ranges) {
	            // Ensure that the selection becomes of type "Control"
	            var doc = getDocument(ranges[0].startContainer);
	            var controlRange = getBody(doc).createControlRange();
	            for (var i = 0, el, len = ranges.length; i < len; ++i) {
	                el = getSingleElementFromRange(ranges[i]);
	                try {
	                    controlRange.add(el);
	                } catch (ex) {
	                    throw module.createError("setRanges(): Element within one of the specified Ranges could not be added to control selection (does it have layout?)");
	                }
	            }
	            controlRange.select();
	
	            // Update the wrapped selection based on what's now in the native selection
	            updateControlSelection(sel);
	        }
	
	        // Selecting a range
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && util.areHostMethods(testSelection, ["removeAllRanges", "addRange"])) {
	            selProto.removeAllRanges = function() {
	                this.nativeSelection.removeAllRanges();
	                updateEmptySelection(this);
	            };
	
	            var addRangeBackward = function(sel, range) {
	                addRangeBackwardToNative(sel.nativeSelection, range);
	                sel.refresh();
	            };
	
	            if (selectionHasRangeCount) {
	                selProto.addRange = function(range, direction) {
	                    if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                        addRangeToControlSelection(this, range);
	                    } else {
	                        if (isDirectionBackward(direction) && selectionHasExtend) {
	                            addRangeBackward(this, range);
	                        } else {
	                            var previousRangeCount;
	                            if (selectionSupportsMultipleRanges) {
	                                previousRangeCount = this.rangeCount;
	                            } else {
	                                this.removeAllRanges();
	                                previousRangeCount = 0;
	                            }
	                            // Clone the native range so that changing the selected range does not affect the selection.
	                            // This is contrary to the spec but is the only way to achieve consistency between browsers. See
	                            // issue 80.
	                            var clonedNativeRange = getNativeRange(range).cloneRange();
	                            try {
	                                this.nativeSelection.addRange(clonedNativeRange);
	                            } catch (ex) {
	                            }
	
	                            // Check whether adding the range was successful
	                            this.rangeCount = this.nativeSelection.rangeCount;
	
	                            if (this.rangeCount == previousRangeCount + 1) {
	                                // The range was added successfully
	
	                                // Check whether the range that we added to the selection is reflected in the last range extracted from
	                                // the selection
	                                if (api.config.checkSelectionRanges) {
	                                    var nativeRange = getSelectionRangeAt(this.nativeSelection, this.rangeCount - 1);
	                                    if (nativeRange && !rangesEqual(nativeRange, range)) {
	                                        // Happens in WebKit with, for example, a selection placed at the start of a text node
	                                        range = new WrappedRange(nativeRange);
	                                    }
	                                }
	                                this._ranges[this.rangeCount - 1] = range;
	                                updateAnchorAndFocusFromRange(this, range, selectionIsBackward(this.nativeSelection));
	                                this.isCollapsed = selectionIsCollapsed(this);
	                            } else {
	                                // The range was not added successfully. The simplest thing is to refresh
	                                this.refresh();
	                            }
	                        }
	                    }
	                };
	            } else {
	                selProto.addRange = function(range, direction) {
	                    if (isDirectionBackward(direction) && selectionHasExtend) {
	                        addRangeBackward(this, range);
	                    } else {
	                        this.nativeSelection.addRange(getNativeRange(range));
	                        this.refresh();
	                    }
	                };
	            }
	
	            selProto.setRanges = function(ranges) {
	                if (implementsControlRange && implementsDocSelection && ranges.length > 1) {
	                    createControlSelection(this, ranges);
	                } else {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        this.addRange(ranges[i]);
	                    }
	                }
	            };
	        } else if (isHostMethod(testSelection, "empty") && isHostMethod(testRange, "select") &&
	                   implementsControlRange && useDocumentSelection) {
	
	            selProto.removeAllRanges = function() {
	                // Added try/catch as fix for issue #21
	                try {
	                    this.docSelection.empty();
	
	                    // Check for empty() not working (issue #24)
	                    if (this.docSelection.type != "None") {
	                        // Work around failure to empty a control selection by instead selecting a TextRange and then
	                        // calling empty()
	                        var doc;
	                        if (this.anchorNode) {
	                            doc = getDocument(this.anchorNode);
	                        } else if (this.docSelection.type == CONTROL) {
	                            var controlRange = this.docSelection.createRange();
	                            if (controlRange.length) {
	                                doc = getDocument( controlRange.item(0) );
	                            }
	                        }
	                        if (doc) {
	                            var textRange = getBody(doc).createTextRange();
	                            textRange.select();
	                            this.docSelection.empty();
	                        }
	                    }
	                } catch(ex) {}
	                updateEmptySelection(this);
	            };
	
	            selProto.addRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    addRangeToControlSelection(this, range);
	                } else {
	                    api.WrappedTextRange.rangeToTextRange(range).select();
	                    this._ranges[0] = range;
	                    this.rangeCount = 1;
	                    this.isCollapsed = this._ranges[0].collapsed;
	                    updateAnchorAndFocusFromRange(this, range, false);
	                }
	            };
	
	            selProto.setRanges = function(ranges) {
	                this.removeAllRanges();
	                var rangeCount = ranges.length;
	                if (rangeCount > 1) {
	                    createControlSelection(this, ranges);
	                } else if (rangeCount) {
	                    this.addRange(ranges[0]);
	                }
	            };
	        } else {
	            module.fail("No means of selecting a Range or TextRange was found");
	            return false;
	        }
	
	        selProto.getRangeAt = function(index) {
	            if (index < 0 || index >= this.rangeCount) {
	                throw new DOMException("INDEX_SIZE_ERR");
	            } else {
	                // Clone the range to preserve selection-range independence. See issue 80.
	                return this._ranges[index].cloneRange();
	            }
	        };
	
	        var refreshSelection;
	
	        if (useDocumentSelection) {
	            refreshSelection = function(sel) {
	                var range;
	                if (api.isSelectionValid(sel.win)) {
	                    range = sel.docSelection.createRange();
	                } else {
	                    range = getBody(sel.win.document).createTextRange();
	                    range.collapse(true);
	                }
	
	                if (sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else if (isTextRange(range)) {
	                    updateFromTextRange(sel, range);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else if (isHostMethod(testSelection, "getRangeAt") && typeof testSelection.rangeCount == NUMBER) {
	            refreshSelection = function(sel) {
	                if (implementsControlRange && implementsDocSelection && sel.docSelection.type == CONTROL) {
	                    updateControlSelection(sel);
	                } else {
	                    sel._ranges.length = sel.rangeCount = sel.nativeSelection.rangeCount;
	                    if (sel.rangeCount) {
	                        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                            sel._ranges[i] = new api.WrappedRange(sel.nativeSelection.getRangeAt(i));
	                        }
	                        updateAnchorAndFocusFromRange(sel, sel._ranges[sel.rangeCount - 1], selectionIsBackward(sel.nativeSelection));
	                        sel.isCollapsed = selectionIsCollapsed(sel);
	                    } else {
	                        updateEmptySelection(sel);
	                    }
	                }
	            };
	        } else if (selectionHasAnchorAndFocus && typeof testSelection.isCollapsed == BOOLEAN && typeof testRange.collapsed == BOOLEAN && features.implementsDomRange) {
	            refreshSelection = function(sel) {
	                var range, nativeSel = sel.nativeSelection;
	                if (nativeSel.anchorNode) {
	                    range = getSelectionRangeAt(nativeSel, 0);
	                    sel._ranges = [range];
	                    sel.rangeCount = 1;
	                    updateAnchorAndFocusFromNativeSelection(sel);
	                    sel.isCollapsed = selectionIsCollapsed(sel);
	                } else {
	                    updateEmptySelection(sel);
	                }
	            };
	        } else {
	            module.fail("No means of obtaining a Range or TextRange from the user's selection was found");
	            return false;
	        }
	
	        selProto.refresh = function(checkForChanges) {
	            var oldRanges = checkForChanges ? this._ranges.slice(0) : null;
	            var oldAnchorNode = this.anchorNode, oldAnchorOffset = this.anchorOffset;
	
	            refreshSelection(this);
	            if (checkForChanges) {
	                // Check the range count first
	                var i = oldRanges.length;
	                if (i != this._ranges.length) {
	                    return true;
	                }
	
	                // Now check the direction. Checking the anchor position is the same is enough since we're checking all the
	                // ranges after this
	                if (this.anchorNode != oldAnchorNode || this.anchorOffset != oldAnchorOffset) {
	                    return true;
	                }
	
	                // Finally, compare each range in turn
	                while (i--) {
	                    if (!rangesEqual(oldRanges[i], this._ranges[i])) {
	                        return true;
	                    }
	                }
	                return false;
	            }
	        };
	
	        // Removal of a single range
	        var removeRangeManually = function(sel, range) {
	            var ranges = sel.getAllRanges();
	            sel.removeAllRanges();
	            for (var i = 0, len = ranges.length; i < len; ++i) {
	                if (!rangesEqual(range, ranges[i])) {
	                    sel.addRange(ranges[i]);
	                }
	            }
	            if (!sel.rangeCount) {
	                updateEmptySelection(sel);
	            }
	        };
	
	        if (implementsControlRange && implementsDocSelection) {
	            selProto.removeRange = function(range) {
	                if (this.docSelection.type == CONTROL) {
	                    var controlRange = this.docSelection.createRange();
	                    var rangeElement = getSingleElementFromRange(range);
	
	                    // Create a new ControlRange containing all the elements in the selected ControlRange minus the
	                    // element contained by the supplied range
	                    var doc = getDocument(controlRange.item(0));
	                    var newControlRange = getBody(doc).createControlRange();
	                    var el, removed = false;
	                    for (var i = 0, len = controlRange.length; i < len; ++i) {
	                        el = controlRange.item(i);
	                        if (el !== rangeElement || removed) {
	                            newControlRange.add(controlRange.item(i));
	                        } else {
	                            removed = true;
	                        }
	                    }
	                    newControlRange.select();
	
	                    // Update the wrapped selection based on what's now in the native selection
	                    updateControlSelection(this);
	                } else {
	                    removeRangeManually(this, range);
	                }
	            };
	        } else {
	            selProto.removeRange = function(range) {
	                removeRangeManually(this, range);
	            };
	        }
	
	        // Detecting if a selection is backward
	        var selectionIsBackward;
	        if (!useDocumentSelection && selectionHasAnchorAndFocus && features.implementsDomRange) {
	            selectionIsBackward = winSelectionIsBackward;
	
	            selProto.isBackward = function() {
	                return selectionIsBackward(this);
	            };
	        } else {
	            selectionIsBackward = selProto.isBackward = function() {
	                return false;
	            };
	        }
	
	        // Create an alias for backwards compatibility. From 1.3, everything is "backward" rather than "backwards"
	        selProto.isBackwards = selProto.isBackward;
	
	        // Selection stringifier
	        // This is conformant to the old HTML5 selections draft spec but differs from WebKit and Mozilla's implementation.
	        // The current spec does not yet define this method.
	        selProto.toString = function() {
	            var rangeTexts = [];
	            for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                rangeTexts[i] = "" + this._ranges[i];
	            }
	            return rangeTexts.join("");
	        };
	
	        function assertNodeInSameDocument(sel, node) {
	            if (sel.win.document != getDocument(node)) {
	                throw new DOMException("WRONG_DOCUMENT_ERR");
	            }
	        }
	
	        // No current browser conforms fully to the spec for this method, so Rangy's own method is always used
	        selProto.collapse = function(node, offset) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.collapseToPoint(node, offset);
	            this.setSingleRange(range);
	            this.isCollapsed = true;
	        };
	
	        selProto.collapseToStart = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[0];
	                this.collapse(range.startContainer, range.startOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        selProto.collapseToEnd = function() {
	            if (this.rangeCount) {
	                var range = this._ranges[this.rangeCount - 1];
	                this.collapse(range.endContainer, range.endOffset);
	            } else {
	                throw new DOMException("INVALID_STATE_ERR");
	            }
	        };
	
	        // The spec is very specific on how selectAllChildren should be implemented and not all browsers implement it as
	        // specified so the native implementation is never used by Rangy.
	        selProto.selectAllChildren = function(node) {
	            assertNodeInSameDocument(this, node);
	            var range = api.createRange(node);
	            range.selectNodeContents(node);
	            this.setSingleRange(range);
	        };
	
	        selProto.deleteFromDocument = function() {
	            // Sepcial behaviour required for IE's control selections
	            if (implementsControlRange && implementsDocSelection && this.docSelection.type == CONTROL) {
	                var controlRange = this.docSelection.createRange();
	                var element;
	                while (controlRange.length) {
	                    element = controlRange.item(0);
	                    controlRange.remove(element);
	                    dom.removeNode(element);
	                }
	                this.refresh();
	            } else if (this.rangeCount) {
	                var ranges = this.getAllRanges();
	                if (ranges.length) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        ranges[i].deleteContents();
	                    }
	                    // The spec says nothing about what the selection should contain after calling deleteContents on each
	                    // range. Firefox moves the selection to where the final selected range was, so we emulate that
	                    this.addRange(ranges[len - 1]);
	                }
	            }
	        };
	
	        // The following are non-standard extensions
	        selProto.eachRange = function(func, returnValue) {
	            for (var i = 0, len = this._ranges.length; i < len; ++i) {
	                if ( func( this.getRangeAt(i) ) ) {
	                    return returnValue;
	                }
	            }
	        };
	
	        selProto.getAllRanges = function() {
	            var ranges = [];
	            this.eachRange(function(range) {
	                ranges.push(range);
	            });
	            return ranges;
	        };
	
	        selProto.setSingleRange = function(range, direction) {
	            this.removeAllRanges();
	            this.addRange(range, direction);
	        };
	
	        selProto.callMethodOnEachRange = function(methodName, params) {
	            var results = [];
	            this.eachRange( function(range) {
	                results.push( range[methodName].apply(range, params || []) );
	            } );
	            return results;
	        };
	
	        function createStartOrEndSetter(isStart) {
	            return function(node, offset) {
	                var range;
	                if (this.rangeCount) {
	                    range = this.getRangeAt(0);
	                    range["set" + (isStart ? "Start" : "End")](node, offset);
	                } else {
	                    range = api.createRange(this.win.document);
	                    range.setStartAndEnd(node, offset);
	                }
	                this.setSingleRange(range, this.isBackward());
	            };
	        }
	
	        selProto.setStart = createStartOrEndSetter(true);
	        selProto.setEnd = createStartOrEndSetter(false);
	
	        // Add select() method to Range prototype. Any existing selection will be removed.
	        api.rangePrototype.select = function(direction) {
	            getSelection( this.getDocument() ).setSingleRange(this, direction);
	        };
	
	        selProto.changeEachRange = function(func) {
	            var ranges = [];
	            var backward = this.isBackward();
	
	            this.eachRange(function(range) {
	                func(range);
	                ranges.push(range);
	            });
	
	            this.removeAllRanges();
	            if (backward && ranges.length == 1) {
	                this.addRange(ranges[0], "backward");
	            } else {
	                this.setRanges(ranges);
	            }
	        };
	
	        selProto.containsNode = function(node, allowPartial) {
	            return this.eachRange( function(range) {
	                return range.containsNode(node, allowPartial);
	            }, true ) || false;
	        };
	
	        selProto.getBookmark = function(containerNode) {
	            return {
	                backward: this.isBackward(),
	                rangeBookmarks: this.callMethodOnEachRange("getBookmark", [containerNode])
	            };
	        };
	
	        selProto.moveToBookmark = function(bookmark) {
	            var selRanges = [];
	            for (var i = 0, rangeBookmark, range; rangeBookmark = bookmark.rangeBookmarks[i++]; ) {
	                range = api.createRange(this.win);
	                range.moveToBookmark(rangeBookmark);
	                selRanges.push(range);
	            }
	            if (bookmark.backward) {
	                this.setSingleRange(selRanges[0], "backward");
	            } else {
	                this.setRanges(selRanges);
	            }
	        };
	
	        selProto.saveRanges = function() {
	            return {
	                backward: this.isBackward(),
	                ranges: this.callMethodOnEachRange("cloneRange")
	            };
	        };
	
	        selProto.restoreRanges = function(selRanges) {
	            this.removeAllRanges();
	            for (var i = 0, range; range = selRanges.ranges[i]; ++i) {
	                this.addRange(range, (selRanges.backward && i == 0));
	            }
	        };
	
	        selProto.toHtml = function() {
	            var rangeHtmls = [];
	            this.eachRange(function(range) {
	                rangeHtmls.push( DomRange.toHtml(range) );
	            });
	            return rangeHtmls.join("");
	        };
	
	        if (features.implementsTextRange) {
	            selProto.getNativeTextRange = function() {
	                var sel, textRange;
	                if ( (sel = this.docSelection) ) {
	                    var range = sel.createRange();
	                    if (isTextRange(range)) {
	                        return range;
	                    } else {
	                        throw module.createError("getNativeTextRange: selection is a control selection");
	                    }
	                } else if (this.rangeCount > 0) {
	                    return api.WrappedTextRange.rangeToTextRange( this.getRangeAt(0) );
	                } else {
	                    throw module.createError("getNativeTextRange: selection contains no range");
	                }
	            };
	        }
	
	        function inspect(sel) {
	            var rangeInspects = [];
	            var anchor = new DomPosition(sel.anchorNode, sel.anchorOffset);
	            var focus = new DomPosition(sel.focusNode, sel.focusOffset);
	            var name = (typeof sel.getName == "function") ? sel.getName() : "Selection";
	
	            if (typeof sel.rangeCount != "undefined") {
	                for (var i = 0, len = sel.rangeCount; i < len; ++i) {
	                    rangeInspects[i] = DomRange.inspect(sel.getRangeAt(i));
	                }
	            }
	            return "[" + name + "(Ranges: " + rangeInspects.join(", ") +
	                    ")(anchor: " + anchor.inspect() + ", focus: " + focus.inspect() + "]";
	        }
	
	        selProto.getName = function() {
	            return "WrappedSelection";
	        };
	
	        selProto.inspect = function() {
	            return inspect(this);
	        };
	
	        selProto.detach = function() {
	            actOnCachedSelection(this.win, "delete");
	            deleteProperties(this);
	        };
	
	        WrappedSelection.detachAll = function() {
	            actOnCachedSelection(null, "deleteAll");
	        };
	
	        WrappedSelection.inspect = inspect;
	        WrappedSelection.isDirectionBackward = isDirectionBackward;
	
	        api.Selection = WrappedSelection;
	
	        api.selectionPrototype = selProto;
	
	        api.addShimListener(function(win) {
	            if (typeof win.getSelection == "undefined") {
	                win.getSelection = function() {
	                    return getSelection(win);
	                };
	            }
	            win = null;
	        });
	    });
	    
	
	    /*----------------------------------------------------------------------------------------------------------------*/
	
	    // Wait for document to load before initializing
	    var docReady = false;
	
	    var loadHandler = function(e) {
	        if (!docReady) {
	            docReady = true;
	            if (!api.initialized && api.config.autoInitialize) {
	                init();
	            }
	        }
	    };
	
	    if (isBrowser) {
	        // Test whether the document has already been loaded and initialize immediately if so
	        if (document.readyState == "complete") {
	            loadHandler();
	        } else {
	            if (isHostMethod(document, "addEventListener")) {
	                document.addEventListener("DOMContentLoaded", loadHandler, false);
	            }
	
	            // Add a fallback in case the DOMContentLoaded event isn't supported
	            addListener(window, "load", loadHandler);
	        }
	    }
	
	    return api;
	}, this);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Defines all supported event types by Editable.JS and provides default
	 * implementations for them defined in {{#crossLink "Behavior"}}{{/crossLink}}
	 *
	 * @type {Object}
	 */
	var log = exports.log = false;
	var logErrors = exports.logErrors = true;
	var editableClass = exports.editableClass = 'js-editable';
	var editableDisabledClass = exports.editableDisabledClass = 'js-editable-disabled';
	var pastingAttribute = exports.pastingAttribute = 'data-editable-is-pasting';
	var boldMarkup = exports.boldMarkup = {
	  type: 'tag',
	  name: 'strong',
	  attribs: {}
	};
	var italicMarkup = exports.italicMarkup = {
	  type: 'tag',
	  name: 'em',
	  attribs: {}
	};
	var underlineMarkup = exports.underlineMarkup = {
	  type: 'tag',
	  name: 'u',
	  attribs: {}
	};
	var linkMarkup = exports.linkMarkup = {
	  type: 'tag',
	  name: 'a',
	  attribs: {}
	
	  // Rules that are applied when filtering pasted content
	};var pastedHtmlRules = exports.pastedHtmlRules = {
	  // Elements and their attributes to keep in pasted text
	  // Note that elements not explicitly allowed here will not be removed, their
	  // tags will get stripped but their content will be kept. Use `blacklistedElements`
	  // to get rid of a whole element (tag+content)
	  allowedElements: {
	    'a': {
	      'href': true,
	      'rel': true,
	      'target': true
	    },
	    'strong': {},
	    'em': {},
	    'br': {}
	  },
	
	  // Elements that have required attributes.
	  // If these are not present the elements are filtered out.
	  // Required attributes have to be present in the 'allowed' object
	  // as well if they should not be filtered out.
	  requiredAttributes: {
	    'a': ['href']
	  },
	
	  // Elements that should be transformed into other elements
	  transformElements: {
	    'b': 'strong',
	    'i': 'em'
	  },
	
	  // A list of elements which should be split into paragraphs.
	  splitIntoBlocks: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'blockquote'],
	
	  // A list of HTML block level elements.
	  blockLevelElements: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'div', 'p', 'pre', 'hr', 'blockquote', 'article', 'figure', 'header', 'footer', 'ul', 'ol', 'li', 'section', 'table', 'video'],
	
	  // A list of elements that will get completly removed when pasted. Their tags
	  // and content (text content and child elements) will get removed.
	  blacklistedElements: ['style', 'script'],
	
	  keepInternalRelativeLinks: false
	};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.tidyHtml = tidyHtml;
	exports.normalizeTags = normalizeTags;
	exports.normalizeWhitespace = normalizeWhitespace;
	exports.cleanInternals = cleanInternals;
	exports.extractContent = extractContent;
	exports.getInnerHtmlOfFragment = getInnerHtmlOfFragment;
	exports.createFragmentFromString = createFragmentFromString;
	exports.adoptElement = adoptElement;
	exports.cloneRangeContents = cloneRangeContents;
	exports.unwrapInternalNodes = unwrapInternalNodes;
	exports.getTags = getTags;
	exports.getTagsByName = getTagsByName;
	exports.getTagsByNameAndAttributes = getTagsByNameAndAttributes;
	exports.areSameAttributes = areSameAttributes;
	exports.getInnerTags = getInnerTags;
	exports.getTagNames = getTagNames;
	exports.isAffectedBy = isAffectedBy;
	exports.selectNodeContents = selectNodeContents;
	exports.isExactSelection = isExactSelection;
	exports.expandTo = expandTo;
	exports.toggleTag = toggleTag;
	exports.isWrappable = isWrappable;
	exports.forceWrap = forceWrap;
	exports.wrap = wrap;
	exports.unwrap = unwrap;
	exports.removeFormattingElem = removeFormattingElem;
	exports.removeFormatting = removeFormatting;
	exports.nuke = nuke;
	exports.nukeElem = nukeElem;
	exports.insertCharacter = insertCharacter;
	exports.surround = surround;
	exports.deleteCharacter = deleteCharacter;
	exports.containsString = containsString;
	exports.nukeTag = nukeTag;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	var _rangeSaveRestore = __webpack_require__(51);
	
	var rangeSaveRestore = _interopRequireWildcard(_rangeSaveRestore);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _string = __webpack_require__(26);
	
	var string = _interopRequireWildcard(_string);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function restoreRange(host, range, func) {
	  range = rangeSaveRestore.save(range);
	  func.call(exports);
	  return rangeSaveRestore.restore(host, range);
	}
	
	var zeroWidthSpace = /\u200B/g;
	var zeroWidthNonBreakingSpace = /\uFEFF/g;
	var whitespaceExceptSpace = /[^\S ]/g;
	
	// Clean up the Html.
	function tidyHtml(element) {
	  // if (element.normalize) element.normalize()
	  normalizeTags(element);
	}
	
	// Remove empty tags and merge consecutive tags (they must have the same
	// attributes).
	//
	// @method normalizeTags
	// @param  {HTMLElement} element The element to process.
	function normalizeTags(element) {
	  var fragment = document.createDocumentFragment();
	
	  Array.prototype.forEach.call(element.childNodes, function (node) {
	    // skip empty tags, so they'll get removed
	    if (node.nodeName !== 'BR' && !node.textContent) return;
	
	    if (node.nodeType === nodeType.elementNode && node.nodeName !== 'BR') {
	      var sibling = node;
	      while ((sibling = sibling.nextSibling) !== null) {
	        if (!parser.isSameNode(sibling, node)) break;
	
	        (0, _from2.default)(sibling.childNodes).forEach(function (siblingChild) {
	          node.appendChild(siblingChild.cloneNode(true));
	        });
	
	        sibling.parentNode.removeChild(sibling);
	      }
	
	      normalizeTags(node);
	    }
	
	    fragment.appendChild(node.cloneNode(true));
	  });
	
	  while (element.firstChild) {
	    element.removeChild(element.firstChild);
	  }element.appendChild(fragment);
	}
	
	function normalizeWhitespace(text) {
	  return text.replace(whitespaceExceptSpace, ' ');
	}
	
	// Clean the element from character, tags, etc... added by the plugin logic.
	//
	// @method cleanInternals
	// @param  {HTMLElement} element The element to process.
	function cleanInternals(element) {
	  // Uses extract content for simplicity. A custom method
	  // that does not clone the element could be faster if needed.
	  element.innerHTML = extractContent(element, true);
	}
	
	// Extracts the content from a host element.
	// Does not touch or change the host. Just returns
	// the content and removes elements marked for removal by editable.
	//
	// @param {DOM node or document framgent} Element where to clean out the innerHTML. If you pass a document fragment it will be empty after this call.
	// @param {Boolean} Flag whether to keep ui elements like spellchecking highlights.
	// @returns {String} The cleaned innerHTML of the passed element or document fragment.
	function extractContent(element, keepUiElements) {
	  var innerHtml = (element.nodeType === nodeType.documentFragmentNode ? getInnerHtmlOfFragment(element) : element.innerHTML).replace(zeroWidthNonBreakingSpace, '') // Used for forcing inline elments to have a height
	  .replace(zeroWidthSpace, '<br>'); // Used for cross-browser newlines
	
	  var clone = document.createElement('div');
	  clone.innerHTML = innerHtml;
	  unwrapInternalNodes(clone, keepUiElements);
	
	  return clone.innerHTML;
	}
	
	function getInnerHtmlOfFragment(documentFragment) {
	  var div = document.createElement('div');
	  div.appendChild(documentFragment);
	  return div.innerHTML;
	}
	
	// Create a document fragment from an html string
	// @param {String} e.g. 'some html <span>text</span>.'
	function createFragmentFromString(htmlString) {
	  var fragment = document.createDocumentFragment();
	
	  (0, _jquery2.default)('<div>').html(htmlString).contents().each(function (i, el) {
	    fragment.appendChild(el);
	  });
	
	  return fragment;
	}
	
	function adoptElement(node, doc) {
	  return node.ownerDocument !== doc ? doc.adoptNode(node) : node;
	}
	
	// This is a slight variation of the cloneContents method of a rangyRange.
	// It will return a fragment with the cloned contents of the range
	// without the commonAncestorElement.
	//
	// @param {rangyRange}
	// @return {DocumentFragment}
	function cloneRangeContents(range) {
	  var rangeFragment = range.cloneContents();
	  var parent = rangeFragment.childNodes[0];
	  var fragment = document.createDocumentFragment();
	  while (parent.childNodes.length) {
	    fragment.appendChild(parent.childNodes[0]);
	  }return fragment;
	}
	
	// Remove elements that were inserted for internal or user interface purposes
	//
	// @param {DOM node}
	// @param {Boolean} whether to keep ui elements like spellchecking highlights
	// Currently:
	// - Saved ranges
	function unwrapInternalNodes(sibling, keepUiElements) {
	  while (sibling) {
	    var nextSibling = sibling.nextSibling;
	
	    if (sibling.nodeType !== nodeType.elementNode) {
	      sibling = nextSibling;
	      continue;
	    }
	
	    var attr = sibling.getAttribute('data-editable');
	
	    if (sibling.firstChild) unwrapInternalNodes(sibling.firstChild, keepUiElements);
	
	    if (attr === 'remove' || attr === 'ui-remove' && !keepUiElements) {
	      (0, _jquery2.default)(sibling).remove();
	    }if (attr === 'unwrap' || attr === 'ui-unwrap' && !keepUiElements) {
	      unwrap(sibling);
	    }
	
	    sibling = nextSibling;
	  }
	}
	
	// Get all tags that start or end inside the range
	function getTags(host, range, filterFunc) {
	  var tags = getInnerTags(range, filterFunc);
	
	  // get all tags that surround the range
	  var node = range.commonAncestorContainer;
	  while (node !== host) {
	    if (!filterFunc || filterFunc(node)) tags.push(node);
	    node = node.parentNode;
	  }
	
	  return tags;
	}
	
	function getTagsByName(host, range, tagName) {
	  return getTags(host, range, function (node) {
	    return node.nodeName.toUpperCase() === tagName.toUpperCase();
	  });
	}
	
	function getTagsByNameAndAttributes(host, range, elem) {
	  return getTags(host, range, function (node) {
	    return node.nodeName.toUpperCase() === elem.nodeName.toUpperCase() && areSameAttributes(node.attributes, elem.attributes);
	  });
	}
	
	function areSameAttributes(attrs1, attrs2) {
	  if (attrs1.length !== attrs2.length) return false;
	
	  for (var i = 0; i < attrs1.length; i++) {
	    var attr = attrs2[attrs1[i].name];
	    if (!(attr && attr.value === attrs1[i].value)) return false;
	  }
	
	  return true;
	}
	
	// Get all tags that start or end inside the range
	function getInnerTags(range, filterFunc) {
	  return range.getNodes([nodeType.elementNode], filterFunc);
	}
	
	// Transform an array of elements into a an array
	// of tagnames in uppercase
	//
	// @return example: ['STRONG', 'B']
	function getTagNames() {
	  var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return elements.map(function (element) {
	    return element.nodeName;
	  });
	}
	
	function isAffectedBy(host, range, tagName) {
	  return getTags(host, range).some(function (elem) {
	    return elem.nodeName === tagName.toUpperCase();
	  });
	}
	
	// select a whole element
	function selectNodeContents(element) {
	  var range = _rangy2.default.createRange();
	  range.selectNodeContents(element);
	  return range;
	}
	
	// Check if the range selects all of the elements contents,
	// not less or more.
	//
	// @param visible: Only compare visible text. That way it does not
	//   matter if the user selects an additional whitespace or not.
	function isExactSelection(range, elem, visible) {
	  var elemRange = _rangy2.default.createRange();
	  elemRange.selectNodeContents(elem);
	
	  if (!range.intersectsRange(elemRange)) return false;
	
	  var rangeText = range.toString();
	  var elemText = (0, _jquery2.default)(elem).text();
	
	  if (visible) {
	    rangeText = string.trim(rangeText);
	    elemText = string.trim(elemText);
	  }
	
	  return rangeText !== '' && rangeText === elemText;
	}
	
	function expandTo(host, range, elem) {
	  range.selectNodeContents(elem);
	  return range;
	}
	
	function toggleTag(host, range, elem) {
	  var elems = getTagsByNameAndAttributes(host, range, elem);
	
	  if (elems.length === 1 && isExactSelection(range, elems[0], 'visible')) {
	    return removeFormattingElem(host, range, elem);
	  }
	
	  return forceWrap(host, range, elem);
	}
	
	function isWrappable(range) {
	  return range.canSurroundContents();
	}
	
	function forceWrap(host, range, elem) {
	  var restoredRange = restoreRange(host, range, function () {
	    nukeElem(host, range, elem);
	  });
	
	  // remove all tags if the range is not wrappable
	  if (!isWrappable(restoredRange)) {
	    restoredRange = restoreRange(host, restoredRange, function () {
	      nuke(host, restoredRange);
	    });
	  }
	
	  wrap(restoredRange, elem);
	  return restoredRange;
	}
	
	function wrap(range, elem) {
	  var el = string.isString(elem) ? (0, _jquery2.default)(elem).get(0) : elem;
	
	  if (!isWrappable(range)) {
	    console.log('content.wrap(): can not surround range');
	    return;
	  }
	
	  range.surroundContents(el);
	}
	
	function unwrap(elem) {
	  var $elem = (0, _jquery2.default)(elem);
	  var contents = $elem.contents();
	
	  contents.length ? contents.unwrap() : $elem.remove();
	}
	
	function removeFormattingElem(host, range, elem) {
	  return restoreRange(host, range, function () {
	    nukeElem(host, range, elem);
	  });
	}
	
	function removeFormatting(host, range, tagName) {
	  return restoreRange(host, range, function () {
	    nuke(host, range, tagName);
	  });
	}
	
	// Unwrap all tags this range is affected by.
	// Can also affect content outside of the range.
	function nuke(host, range, tagName) {
	  getTags(host, range).forEach(function (elem) {
	    if (elem.nodeName.toUpperCase() !== 'BR' && (!tagName || elem.nodeName.toUpperCase() === tagName.toUpperCase())) {
	      unwrap(elem);
	    }
	  });
	}
	
	// Unwrap all tags this range is affected by.
	// Can also affect content outside of the range.
	function nukeElem(host, range, node) {
	  getTags(host, range).forEach(function (elem) {
	    if (elem.nodeName.toUpperCase() !== 'BR' && (!node || elem.nodeName.toUpperCase() === node.nodeName.toUpperCase() && areSameAttributes(elem.attributes, node.attributes))) {
	      unwrap(elem);
	    }
	  });
	}
	
	// Insert a single character (or string) before or after the
	// the range.
	function insertCharacter(range, character, atStart) {
	  var insertEl = document.createTextNode(character);
	  var boundaryRange = range.cloneRange();
	
	  boundaryRange.collapse(atStart);
	  boundaryRange.insertNode(insertEl);
	  range[atStart ? 'setStartBefore' : 'setEndAfter'](insertEl);
	  range.normalizeBoundaries();
	}
	
	// Surround the range with characters like start and end quotes.
	//
	// @method surround
	function surround(host, range, startCharacter, endCharacter) {
	  insertCharacter(range, endCharacter || startCharacter, false);
	  insertCharacter(range, startCharacter, true);
	  return range;
	}
	
	// Removes a character from the text within a range.
	//
	// @method deleteCharacter
	function deleteCharacter(host, range, character) {
	  if (!containsString(range, character)) return range;
	
	  range.splitBoundaries();
	  var restoredRange = restoreRange(host, range, function () {
	    var charRegexp = string.regexp(character);
	
	    range.getNodes([nodeType.textNode], function (node) {
	      return node.nodeValue.search(charRegexp) >= 0;
	    }).forEach(function (node) {
	      node.nodeValue = node.nodeValue.replace(charRegexp, '');
	    });
	  });
	
	  restoredRange.normalizeBoundaries();
	  return restoredRange;
	}
	
	function containsString(range, str) {
	  return range.toString().indexOf(str) >= 0;
	}
	
	// Unwrap all tags this range is affected by.
	// Can also affect content outside of the range.
	function nukeTag(host, range, tagName) {
	  getTags(host, range).forEach(function (elem) {
	    if (elem.nodeName.toUpperCase() === tagName.toUpperCase()) unwrap(elem);
	  });
	}

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(17);
	var IE8_DOM_DEFINE = __webpack_require__(56);
	var toPrimitive = __webpack_require__(43);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(12) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var core = __webpack_require__(4);
	var ctx = __webpack_require__(34);
	var hide = __webpack_require__(18);
	var has = __webpack_require__(14);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.getHost = getHost;
	exports.getNodeIndex = getNodeIndex;
	exports.isVoid = isVoid;
	exports.isVoidTextNode = isVoidTextNode;
	exports.isWhitespaceOnly = isWhitespaceOnly;
	exports.isLinebreak = isLinebreak;
	exports.lastOffsetWithContent = lastOffsetWithContent;
	exports.isBeginningOfHost = isBeginningOfHost;
	exports.isEndOfHost = isEndOfHost;
	exports.isStartOffset = isStartOffset;
	exports.isEndOffset = isEndOffset;
	exports.isTextEndOfHost = isTextEndOfHost;
	exports.isTextEndOffset = isTextEndOffset;
	exports.isSameNode = isSameNode;
	exports.latestChild = latestChild;
	exports.isDocumentFragmentWithoutChildren = isDocumentFragmentWithoutChildren;
	exports.isInlineElement = isInlineElement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _string = __webpack_require__(26);
	
	var string = _interopRequireWildcard(_string);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The parser module provides helper methods to parse html-chunks
	 * manipulations and helpers for common tasks.
	 * Provides DOM lookup helpers
	 *
	 * @module core
	 * @submodule parser
	 */
	
	/**
	 * Get the editableJS host block of a node.
	 *
	 * @method getHost
	 * @param {DOM Node}
	 * @return {DOM Node}
	 */
	function getHost(node) {
	  var editableSelector = '.' + config.editableClass;
	  var hostNode = (0, _jquery2.default)(node).closest(editableSelector);
	  return hostNode[0];
	}
	
	/**
	 * Get the index of a node so that
	 * parent.childNodes[ getNodeIndex(node) ] would return the node again.
	 *
	 * @method getNodeIndex
	 * @param {HTMLElement}
	 */
	function getNodeIndex(node) {
	  var index = 0;
	  while ((node = node.previousSibling) !== null) {
	    index++;
	  }return index;
	}
	
	/**
	 * Check if node contains text or element nodes
	 * whitespace counts too!
	 *
	 * @method isVoid
	 * @param {HTMLElement}
	 */
	function isVoid(node) {
	  var _this = this;
	
	  return (0, _from2.default)(node.childNodes).every(function (child) {
	    if (child.nodeType === nodeType.textNode && !_this.isVoidTextNode(child)) {
	      return false;
	    }
	    if (child.nodeType === nodeType.elementNode) {
	      return false;
	    }
	    return true;
	  });
	}
	
	/**
	 * Check if node is a text node and completely empty without any whitespace
	 *
	 * @method isVoidTextNode
	 * @param {HTMLElement}
	 */
	function isVoidTextNode(node) {
	  return node.nodeType === nodeType.textNode && !node.nodeValue;
	}
	
	/**
	 * Check if node is a text node and contains nothing but whitespace
	 *
	 * @method isWhitespaceOnly
	 * @param {HTMLElement}
	 */
	function isWhitespaceOnly(node) {
	  return node.nodeType === nodeType.textNode && this.lastOffsetWithContent(node) === 0;
	}
	
	function isLinebreak(node) {
	  return node.nodeType === nodeType.elementNode && node.tagName === 'BR';
	}
	
	/**
	 * Returns the last offset where the cursor can be positioned to
	 * be at the visible end of its container.
	 * Currently works only for empty text nodes (not empty tags)
	 *
	 * @method isWhitespaceOnly
	 * @param {HTMLElement}
	 */
	function lastOffsetWithContent(node) {
	  var _this2 = this;
	
	  if (node.nodeType === nodeType.textNode) return string.trimRight(node.nodeValue).length;
	
	  var lastOffset = 0;
	  (0, _from2.default)(node.childNodes).reverse().every(function (node, index, nodes) {
	    if (_this2.isWhitespaceOnly(node) || _this2.isLinebreak(node)) return true;
	
	    lastOffset = nodes.length - index;
	    return false;
	  });
	  return lastOffset;
	}
	
	function isBeginningOfHost(host, container, offset) {
	  if (container === host) return this.isStartOffset(container, offset);
	
	  if (this.isStartOffset(container, offset)) {
	    // The index of the element simulates a range offset
	    // right before the element.
	    var offsetInParent = this.getNodeIndex(container);
	    return this.isBeginningOfHost(host, container.parentNode, offsetInParent);
	  }
	
	  return false;
	}
	
	function isEndOfHost(host, container, offset) {
	  if (container === host) return this.isEndOffset(container, offset);
	
	  if (this.isEndOffset(container, offset)) {
	    // The index of the element plus one simulates a range offset
	    // right after the element.
	    var offsetInParent = this.getNodeIndex(container) + 1;
	    return this.isEndOfHost(host, container.parentNode, offsetInParent);
	  }
	
	  return false;
	}
	
	function isStartOffset(container, offset) {
	  if (container.nodeType === nodeType.textNode) return offset === 0;
	
	  if (container.childNodes.length === 0) return true;
	
	  return container.childNodes[offset] === container.firstChild;
	}
	
	function isEndOffset(container, offset) {
	  if (container.nodeType === nodeType.textNode) return offset === container.length;
	
	  if (container.childNodes.length === 0) return true;
	
	  if (offset > 0) return container.childNodes[offset - 1] === container.lastChild;
	
	  return false;
	}
	
	function isTextEndOfHost(host, container, offset) {
	  if (container === host) return this.isTextEndOffset(container, offset);
	
	  if (this.isTextEndOffset(container, offset)) {
	    // The index of the element plus one simulates a range offset
	    // right after the element.
	    var offsetInParent = this.getNodeIndex(container) + 1;
	    return this.isTextEndOfHost(host, container.parentNode, offsetInParent);
	  }
	
	  return false;
	}
	
	function isTextEndOffset(container, offset) {
	  if (container.nodeType === nodeType.textNode) {
	    var text = string.trimRight(container.nodeValue);
	    return offset >= text.length;
	  }
	
	  if (container.childNodes.length === 0) return true;
	
	  return offset >= this.lastOffsetWithContent(container);
	}
	
	function isSameNode(target, source) {
	  var i, len, attr;
	
	  if (target.nodeType !== source.nodeType) return false;
	
	  if (target.nodeName !== source.nodeName) return false;
	
	  for (i = 0, len = target.attributes.length; i < len; i++) {
	    attr = target.attributes[i];
	    if (source.getAttribute(attr.name) !== attr.value) return false;
	  }
	
	  return true;
	}
	
	/**
	 * Return the deepest last child of a node.
	 *
	 * @method  latestChild
	 * @param  {HTMLElement} container The container to iterate on.
	 * @return {HTMLElement}           THe deepest last child in the container.
	 */
	function latestChild(container) {
	  return container.lastChild ? this.latestChild(container.lastChild) : container;
	}
	
	/**
	 * Checks if a documentFragment has no children.
	 * Fragments without children can cause errors if inserted into ranges.
	 *
	 * @method  isDocumentFragmentWithoutChildren
	 * @param  {HTMLElement} DOM node.
	 * @return {Boolean}
	 */
	function isDocumentFragmentWithoutChildren(fragment) {
	  return fragment && fragment.nodeType === nodeType.documentFragmentNode && fragment.childNodes.length === 0;
	}
	
	/**
	 * Determine if an element behaves like an inline element.
	 */
	function isInlineElement(window, element) {
	  var styles = element.currentStyle || window.getComputedStyle(element, '');
	  var display = styles.display;
	  switch (display) {
	    case 'inline':
	    case 'inline-block':
	      return true;
	    default:
	      return false;
	  }
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var createDesc = __webpack_require__(23);
	module.exports = __webpack_require__(12) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(104);
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 22 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(35);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _viewport = __webpack_require__(79);
	
	var viewport = _interopRequireWildcard(_viewport);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _string = __webpack_require__(26);
	
	var string = _interopRequireWildcard(_string);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	var _error = __webpack_require__(32);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _rangeSaveRestore = __webpack_require__(51);
	
	var rangeSaveRestore = _interopRequireWildcard(_rangeSaveRestore);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The Cursor module provides a cross-browser abstraction layer for cursor.
	 *
	 * @module core
	 * @submodule cursor
	 */
	
	var Cursor = function () {
	  /**
	  * Class for the Cursor module.
	  *
	  * @class Cursor
	  * @constructor
	  */
	  function Cursor(editableHost, rangyRange) {
	    (0, _classCallCheck3.default)(this, Cursor);
	
	    this.setHost(editableHost);
	    this.range = rangyRange;
	    this.isCursor = true;
	  }
	
	  (0, _createClass3.default)(Cursor, [{
	    key: 'isAtEnd',
	    value: function isAtEnd() {
	      return parser.isEndOfHost(this.host, this.range.endContainer, this.range.endOffset);
	    }
	  }, {
	    key: 'isAtTextEnd',
	    value: function isAtTextEnd() {
	      return parser.isTextEndOfHost(this.host, this.range.endContainer, this.range.endOffset);
	    }
	  }, {
	    key: 'isAtLastLine',
	    value: function isAtLastLine() {
	      var range = _rangy2.default.createRange();
	      range.selectNodeContents(this.host);
	
	      var hostCoords = range.nativeRange.getBoundingClientRect();
	      var cursorCoords = this.range.nativeRange.getBoundingClientRect();
	
	      return hostCoords.bottom === cursorCoords.bottom;
	    }
	  }, {
	    key: 'isAtFirstLine',
	    value: function isAtFirstLine() {
	      var range = _rangy2.default.createRange();
	      range.selectNodeContents(this.host);
	
	      var hostCoords = range.nativeRange.getBoundingClientRect();
	      var cursorCoords = this.range.nativeRange.getBoundingClientRect();
	
	      return hostCoords.top === cursorCoords.top;
	    }
	  }, {
	    key: 'isAtBeginning',
	    value: function isAtBeginning() {
	      return parser.isBeginningOfHost(this.host, this.range.startContainer, this.range.startOffset);
	    }
	
	    // Insert content before the cursor
	    //
	    // @param {String, DOM node or document fragment}
	
	  }, {
	    key: 'insertBefore',
	    value: function insertBefore(element) {
	      if (string.isString(element)) element = content.createFragmentFromString(element);
	      if (parser.isDocumentFragmentWithoutChildren(element)) return;
	
	      element = this.adoptElement(element);
	
	      var preceedingElement = element;
	      if (element.nodeType === nodeType.documentFragmentNode) {
	        var lastIndex = element.childNodes.length - 1;
	        preceedingElement = element.childNodes[lastIndex];
	      }
	
	      this.range.insertNode(element);
	      this.range.setStartAfter(preceedingElement);
	      this.range.setEndAfter(preceedingElement);
	    }
	
	    // Insert content after the cursor
	    //
	    // @param {String, DOM node or document fragment}
	
	  }, {
	    key: 'insertAfter',
	    value: function insertAfter(element) {
	      if (string.isString(element)) element = content.createFragmentFromString(element);
	      if (parser.isDocumentFragmentWithoutChildren(element)) return;
	
	      element = this.adoptElement(element);
	      this.range.insertNode(element);
	    }
	
	    // Alias for #setVisibleSelection()
	
	  }, {
	    key: 'setSelection',
	    value: function setSelection() {
	      this.setVisibleSelection();
	    }
	  }, {
	    key: 'setVisibleSelection',
	    value: function setVisibleSelection() {
	      if (this.win.document.activeElement !== this.host) {
	        var _viewport$getScrollPo = viewport.getScrollPosition(this.win),
	            x = _viewport$getScrollPo.x,
	            y = _viewport$getScrollPo.y;
	
	        this.win.scrollTo(x, y);
	      }
	      _rangy2.default.getSelection(this.win).setSingleRange(this.range);
	    }
	
	    // Take the following example:
	    // (The character '|' represents the cursor position)
	    //
	    // <div contenteditable="true">fo|o</div>
	    // before() will return a document fragment containing a text node 'fo'.
	    //
	    // @returns {Document Fragment} content before the cursor or selection.
	
	  }, {
	    key: 'before',
	    value: function before() {
	      var range = this.range.cloneRange();
	      range.collapse(true);
	      range.setStartBefore(this.host);
	      return content.cloneRangeContents(range);
	    }
	  }, {
	    key: 'textBefore',
	    value: function textBefore() {
	      var range = this.range.cloneRange();
	      range.collapse(true);
	      range.setStartBefore(this.host);
	      return range.toString();
	    }
	
	    // Same as before() but returns a string.
	
	  }, {
	    key: 'beforeHtml',
	    value: function beforeHtml() {
	      return content.getInnerHtmlOfFragment(this.before());
	    }
	
	    // Take the following example:
	    // (The character '|' represents the cursor position)
	    //
	    // <div contenteditable="true">fo|o</div>
	    // after() will return a document fragment containing a text node 'o'.
	    //
	    // @returns {Document Fragment} content after the cursor or selection.
	
	  }, {
	    key: 'after',
	    value: function after() {
	      var range = this.range.cloneRange();
	      range.collapse(false);
	      range.setEndAfter(this.host);
	      return content.cloneRangeContents(range);
	    }
	  }, {
	    key: 'textAfter',
	    value: function textAfter() {
	      var range = this.range.cloneRange();
	      range.collapse(false);
	      range.setEndAfter(this.host);
	      return range.toString();
	    }
	
	    // Same as after() but returns a string.
	
	  }, {
	    key: 'afterHtml',
	    value: function afterHtml() {
	      return content.getInnerHtmlOfFragment(this.after());
	    }
	
	    // Get the BoundingClientRect of the cursor.
	    // The returned values are transformed to be absolute
	    // (relative to the document).
	
	  }, {
	    key: 'getCoordinates',
	    value: function getCoordinates() {
	      var positioning = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'absolute';
	
	      var coords = this.range.nativeRange.getBoundingClientRect();
	      if (positioning === 'fixed') return coords;
	
	      // translate into absolute positions
	
	      var _viewport$getScrollPo2 = viewport.getScrollPosition(this.win),
	          x = _viewport$getScrollPo2.x,
	          y = _viewport$getScrollPo2.y;
	
	      return {
	        top: coords.top + y,
	        bottom: coords.bottom + y,
	        left: coords.left + x,
	        right: coords.right + x,
	        height: coords.height,
	        width: coords.width
	      };
	    }
	  }, {
	    key: 'moveBefore',
	    value: function moveBefore(element) {
	      this.updateHost(element);
	      this.range.setStartBefore(element);
	      this.range.setEndBefore(element);
	      if (this.isSelection) return new Cursor(this.host, this.range);
	    }
	  }, {
	    key: 'moveAfter',
	    value: function moveAfter(element) {
	      this.updateHost(element);
	      this.range.setStartAfter(element);
	      this.range.setEndAfter(element);
	      if (this.isSelection) return new Cursor(this.host, this.range);
	    }
	
	    // Move the cursor to the beginning of the host.
	
	  }, {
	    key: 'moveAtBeginning',
	    value: function moveAtBeginning() {
	      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.host;
	
	      this.updateHost(element);
	      this.range.selectNodeContents(element);
	      this.range.collapse(true);
	      if (this.isSelection) return new Cursor(this.host, this.range);
	    }
	
	    // Move the cursor to the end of the host.
	
	  }, {
	    key: 'moveAtEnd',
	    value: function moveAtEnd() {
	      var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.host;
	
	      this.updateHost(element);
	      this.range.selectNodeContents(element);
	      this.range.collapse(false);
	      if (this.isSelection) return new Cursor(this.host, this.range);
	    }
	
	    // Move the cursor after the last visible character of the host.
	
	  }, {
	    key: 'moveAtTextEnd',
	    value: function moveAtTextEnd(element) {
	      return this.moveAtEnd(parser.latestChild(element));
	    }
	  }, {
	    key: 'setHost',
	    value: function setHost(element) {
	      if (element.jquery) element = element[0];
	      this.host = element;
	      this.win = element === undefined || element === null ? window : element.ownerDocument.defaultView;
	    }
	  }, {
	    key: 'updateHost',
	    value: function updateHost(element) {
	      var host = parser.getHost(element);
	      if (!host) (0, _error2.default)('Can not set cursor outside of an editable block');
	      this.setHost(host);
	    }
	  }, {
	    key: 'retainVisibleSelection',
	    value: function retainVisibleSelection(callback) {
	      this.save();
	      callback();
	      this.restore();
	      this.setVisibleSelection();
	    }
	  }, {
	    key: 'save',
	    value: function save() {
	      this.savedRangeInfo = rangeSaveRestore.save(this.range);
	      this.savedRangeInfo.host = this.host;
	    }
	  }, {
	    key: 'restore',
	    value: function restore() {
	      if (!this.savedRangeInfo) (0, _error2.default)('Could not restore selection');
	
	      this.host = this.savedRangeInfo.host;
	      this.range = rangeSaveRestore.restore(this.host, this.savedRangeInfo);
	      this.savedRangeInfo = undefined;
	    }
	  }, {
	    key: 'equals',
	    value: function equals(cursor) {
	      if (!cursor) return false;
	
	      if (!cursor.host) return false;
	      if (!cursor.host.isEqualNode(this.host)) return false;
	
	      if (!cursor.range) return false;
	      if (!cursor.range.equals(this.range)) return false;
	
	      return true;
	    }
	
	    // Create an element with the correct ownerWindow
	    // (see: http://www.w3.org/DOM/faq.html#ownerdoc)
	
	  }, {
	    key: 'createElement',
	    value: function createElement(tagName) {
	      var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var element = this.win.document.createElement(tagName);
	      for (var attributeName in attributes) {
	        var attributeValue = attributes[attributeName];
	        element.setAttribute(attributeName, attributeValue);
	      }
	      return element;
	    }
	  }, {
	    key: 'createTextNode',
	    value: function createTextNode(text) {
	      return this.win.document.createTextNode(text);
	    }
	
	    // Make sure a node has the correct ownerWindow
	    // (see: https://developer.mozilla.org/en-US/docs/Web/API/Document/importNode)
	
	  }, {
	    key: 'adoptElement',
	    value: function adoptElement(node) {
	      return content.adoptElement(node, this.win.document);
	    }
	
	    // Currently we call triggerChange manually after format changes.
	    // This is to prevent excessive triggering of the change event during
	    // merge or split operations or other manipulations by scripts.
	
	  }, {
	    key: 'triggerChange',
	    value: function triggerChange() {
	      (0, _jquery2.default)(this.host).trigger('formatEditable');
	    }
	  }]);
	  return Cursor;
	}();
	
	exports.default = Cursor;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trimRight = trimRight;
	exports.trimLeft = trimLeft;
	exports.trim = trim;
	exports.isString = isString;
	exports.regexp = regexp;
	exports.escapeHtml = escapeHtml;
	exports.browserEscapeHtml = browserEscapeHtml;
	var toString = Object.prototype.toString;
	var htmlCharacters = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  "'": '&#39;'
	
	  // TODO: replace with lodash methods
	};function trimRight(text) {
	  return text.replace(/\s+$/, '');
	}
	
	function trimLeft(text) {
	  return text.replace(/^\s+/, '');
	}
	
	function trim(text) {
	  return text.replace(/^\s+|\s+$/g, '');
	}
	
	function isString(obj) {
	  return toString.call(obj) === '[object String]';
	}
	
	/**
	 * Turn any string into a regular expression.
	 * This can be used to search or replace a string conveniently.
	 */
	
	function regexp(str, flags) {
	  if (!flags) flags = 'g';
	  var escapedStr = str.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
	  return new RegExp(escapedStr, flags);
	}
	
	/**
	 * Escape HTML characters <, > and &
	 * Usage: escapeHtml('<div>')
	 *
	 * @param { String }
	 * @param { Boolean } Optional. If true " and ' will also be escaped.
	 * @return { String } Escaped Html you can assign to innerHTML of an element.
	 */
	
	// TODO: replace with npm.im/he
	
	function escapeHtml(s, forAttribute) {
	  return s.replace(forAttribute ? /[&<>'"]/g : /[&<>]/g, function (c) {
	    // "'
	    return htmlCharacters[c];
	  });
	}
	
	/**
	 * Escape a string the browser way.
	 */
	
	function browserEscapeHtml(str) {
	  var div = document.createElement('div');
	  div.appendChild(document.createTextNode(str));
	  return div.innerHTML;
	}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(62);
	var enumBugKeys = __webpack_require__(36);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(83);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _highlightText2 = __webpack_require__(31);
	
	var _highlightText3 = _interopRequireDefault(_highlightText2);
	
	var _textHighlighting = __webpack_require__(50);
	
	var _textHighlighting2 = _interopRequireDefault(_textHighlighting);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isInHost(el, host) {
	  if (!el.closest) {
	    el = el.parentNode;
	  }
	  return el.closest('[data-editable]:not([data-word-id])') === host;
	}
	
	var highlightSupport = {
	  highlightText: function highlightText(editableHost, text, highlightId) {
	    if (this.hasHighlight(editableHost, highlightId)) return;
	
	    var blockText = _highlightText3.default.extractText(editableHost);
	
	    var marker = '<span class="highlight-comment"></span>';
	    var markerNode = highlightSupport.createMarkerNode(marker, 'highlight', this.win);
	
	    var textSearch = new _textHighlighting2.default(markerNode, 'text');
	    var matches = textSearch.findMatches(blockText, [text]);
	
	    if (matches && matches.length) {
	      if (highlightId) matches[0].id = highlightId;
	      _highlightText3.default.highlightMatches(editableHost, matches);
	      return matches[0].startIndex;
	    }
	  },
	  highlightRange: function highlightRange(editableHost, highlightId, startIndex, endIndex, dispatcher) {
	    if (this.hasHighlight(editableHost, highlightId)) {
	      this.removeHighlight(editableHost, highlightId);
	    }
	    var range = _rangy2.default.createRange();
	    range.selectCharacters(editableHost, startIndex, endIndex);
	
	    if (!isInHost(range.commonAncestorContainer, editableHost)) {
	      return -1;
	    }
	
	    var marker = highlightSupport.createMarkerNode('<span class="highlight-comment" data-word-id="' + highlightId + '"></span>', 'comment', this.win);
	    var fragment = range.extractContents();
	    marker.appendChild(fragment);
	    range.deleteContents();
	    range.insertNode(marker);
	    highlightSupport.cleanupStaleMarkerNodes(editableHost, 'comment');
	    if (dispatcher) {
	      dispatcher.notify('change', editableHost);
	    }
	    return startIndex;
	  },
	  updateHighlight: function updateHighlight(editableHost, highlightId, addCssClass, removeCssClass) {
	    if (!document.documentElement.classList) return;
	
	    (0, _jquery2.default)(editableHost).find('[data-word-id="' + highlightId + '"]').each(function (index, elem) {
	      if (removeCssClass) elem.classList.remove(removeCssClass);
	      if (addCssClass) elem.classList.add(addCssClass);
	    });
	  },
	  removeHighlight: function removeHighlight(editableHost, highlightId, dispatcher) {
	    (0, _jquery2.default)(editableHost).find('[data-word-id="' + highlightId + '"]').each(function (index, elem) {
	      content.unwrap(elem);
	      if (dispatcher) {
	        dispatcher.notify('change', editableHost);
	      }
	    });
	  },
	  hasHighlight: function hasHighlight(editableHost, highlightId) {
	    var matches = (0, _jquery2.default)(editableHost).find('[data-word-id="' + highlightId + '"]');
	    return !!matches.length;
	  },
	  extractHighlightedRanges: function extractHighlightedRanges(editableHost) {
	    var _this = this;
	
	    var markers = (0, _jquery2.default)(editableHost).find('[data-word-id]');
	    if (!markers.length) {
	      return;
	    }
	    var groups = {};
	    markers.each(function (_, marker) {
	      var highlightId = (0, _jquery2.default)(marker).data('word-id');
	      if (!groups[highlightId]) {
	        groups[highlightId] = (0, _jquery2.default)(editableHost).find('[data-word-id="' + highlightId + '"]');
	      }
	    });
	    var res = {};
	    (0, _keys2.default)(groups).forEach(function (highlightId) {
	      var position = _this.extractMarkerNodePosition(editableHost, groups[highlightId]);
	      if (position) {
	        res[highlightId] = position;
	      }
	    });
	
	    return res;
	  },
	  extractMarkerNodePosition: function extractMarkerNodePosition(editableHost, markers) {
	    var range = _rangy2.default.createRange();
	    if (markers.length > 1) {
	      range.setStartBefore(markers.first()[0]);
	      range.setEndAfter(markers.last()[0]);
	    } else {
	      range.selectNode(markers[0]);
	    }
	    var textRange = range.toCharacterRange(editableHost);
	    return {
	      start: textRange.start,
	      end: textRange.end,
	      text: range.text()
	    };
	  },
	  cleanupStaleMarkerNodes: function cleanupStaleMarkerNodes(editableHost, highlightType) {
	    editableHost.querySelectorAll('span[data-highlight="' + highlightType + '"]').forEach(function (node) {
	      if (!node.textContent.length) {
	        node.parentNode.removeChild(node);
	      }
	    });
	  },
	  createMarkerNode: function createMarkerNode(markerMarkup, highlightType, win) {
	    var marker = (0, _jquery2.default)(markerMarkup)[0];
	
	    if (win) {
	      marker = content.adoptElement(marker, win.document);
	    }
	
	    marker.setAttribute('data-editable', 'ui-unwrap');
	    marker.setAttribute('data-highlight', highlightType);
	    return marker;
	  }
	};
	
	exports.default = highlightSupport;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _nodeIterator = __webpack_require__(72);
	
	var _nodeIterator2 = _interopRequireDefault(_nodeIterator);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  // Get the text from an editable block with a NodeIterator.
	  // This must work the same as when later iterating over the text
	  // in highlightMatches().
	  extractText: function extractText(element) {
	    var text = '';
	    getText(element, function (part) {
	      text += part;
	    });
	    return text;
	  },
	
	
	  // Go through the element to highlight the matches while keeping the
	  // existing html valid (highlighting a match may require inserting multiple
	  // elements).
	  //
	  // @params
	  // - matches
	  //   Array of positions in the string to highlight:
	  //   e.g [{startIndex: 0, endIndex: 1, match: 'The'}]
	  highlightMatches: function highlightMatches(element, matches) {
	    if (!matches || matches.length === 0) {
	      return;
	    }
	
	    var iterator = new _nodeIterator2.default(element);
	    var currentMatchIndex = 0;
	    var totalOffset = 0;
	    var currentMatch = matches[currentMatchIndex];
	    var portions = [];
	    var next = void 0;
	    var wordId = void 0;
	    while (next = iterator.getNext()) {
	      // Account for <br> elements
	      if (next.nodeType === nodeType.textNode && next.data !== '') {
	        var textNode = next;
	      } else if (next.nodeType === nodeType.elementNode && next.nodeName === 'BR') {
	        totalOffset += 1;
	        continue;
	      } else {
	        continue;
	      }
	
	      var nodeText = textNode.data;
	      var nodeEndOffset = totalOffset + nodeText.length;
	      if (currentMatch.startIndex < nodeEndOffset && totalOffset < currentMatch.endIndex) {
	        // get portion position (fist, last or in the middle)
	        var isFirstPortion = totalOffset <= currentMatch.startIndex;
	        var isLastPortion = nodeEndOffset >= currentMatch.endIndex;
	
	        if (isFirstPortion) {
	          wordId = currentMatch.id || currentMatch.startIndex;
	        }
	
	        // calculate offset and length
	        var offset = void 0;
	        if (isFirstPortion) {
	          offset = currentMatch.startIndex - totalOffset;
	        } else {
	          offset = 0;
	        }
	
	        var length = void 0;
	        if (isLastPortion) {
	          length = currentMatch.endIndex - totalOffset - offset;
	        } else {
	          length = nodeText.length - offset;
	        }
	
	        // create portion object
	        var portion = {
	          element: textNode,
	          text: nodeText.substring(offset, offset + length),
	          offset: offset,
	          length: length,
	          isLastPortion: isLastPortion,
	          wordId: wordId
	        };
	
	        portions.push(portion);
	
	        if (isLastPortion) {
	          var lastNode = this.wrapMatch(portions, currentMatch.marker, currentMatch.title);
	          iterator.replaceCurrent(lastNode);
	
	          // recalculate nodeEndOffset if we have to replace the current node.
	          nodeEndOffset = totalOffset + portion.length + portion.offset;
	
	          portions = [];
	          currentMatchIndex += 1;
	          if (currentMatchIndex < matches.length) {
	            currentMatch = matches[currentMatchIndex];
	          }
	        }
	      }
	
	      totalOffset = nodeEndOffset;
	    }
	  },
	
	
	  // @return the last wrapped element
	  wrapMatch: function wrapMatch(portions, stencilElement, title) {
	    var _this = this;
	
	    return portions.map(function (portion) {
	      return _this.wrapPortion(portion, stencilElement, title);
	    }).pop();
	  },
	  wrapPortion: function wrapPortion(portion, stencilElement, title) {
	    var range = _rangy2.default.createRange();
	    range.setStart(portion.element, portion.offset);
	    range.setEnd(portion.element, portion.offset + portion.length);
	    var node = stencilElement.cloneNode(true);
	    node.setAttribute('data-word-id', portion.wordId);
	    if (title) node.setAttribute('title', title);
	    range.surroundContents(node);
	
	    // Fix a weird behaviour where an empty text node is inserted after the range
	    if (node.nextSibling) {
	      var next = node.nextSibling;
	      if (next.nodeType === nodeType.textNode && next.data === '') {
	        next.parentNode.removeChild(next);
	      }
	    }
	
	    return node;
	  }
	};
	
	// Extract the text of an element.
	// This has two notable behaviours:
	// - It uses a NodeIterator which will skip elements
	//   with data-editable="remove"
	// - It returns a space for <br> elements
	//   (The only block level element allowed inside of editables)
	
	function getText(element, callback) {
	  var iterator = new _nodeIterator2.default(element);
	  var next = void 0;
	  while (next = iterator.getNext()) {
	    if (next.nodeType === nodeType.textNode && next.data !== '') {
	      callback(next.data);
	    } else if (next.nodeType === nodeType.elementNode && next.nodeName === 'BR') {
	      callback(' '); // eslint-disable-line standard/no-callback-literal
	    }
	  }
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.default = error;
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Allows for safe error logging
	// Falls back to console.log if console.error is not available
	function error() {
	  if (config.logErrors === false) return;
	
	  var args = arguments.length === 1 ? arguments[0] : (0, _from2.default)(arguments);
	
	  if (!global.console) return;
	
	  if (typeof console.error === 'function') return console.error(args);
	
	  console.log(args);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 33 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(97);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 35 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(17);
	var dPs = __webpack_require__(112);
	var enumBugKeys = __webpack_require__(36);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(55)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(103).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 38 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(11).f;
	var has = __webpack_require__(14);
	var TAG = __webpack_require__(5)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(41)('keys');
	var uid = __webpack_require__(29);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(4);
	var global = __webpack_require__(10);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(27) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(19);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(10);
	var core = __webpack_require__(4);
	var LIBRARY = __webpack_require__(27);
	var wksExt = __webpack_require__(45);
	var defineProperty = __webpack_require__(11).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(5);


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.previous = exports.next = undefined;
	exports.init = init;
	exports.disable = disable;
	exports.setBlockId = setBlockId;
	exports.getState = getState;
	exports.setState = setState;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nextBlockId = 1;
	var state = {};
	
	var next = exports.next = getSibling('nextElementSibling');
	var previous = exports.previous = getSibling('previousElementSibling');
	
	function init(elem, _ref) {
	  var normalize = _ref.normalize,
	      shouldSpellcheck = _ref.shouldSpellcheck;
	
	  setBlockId(elem);
	
	  elem.setAttribute('contenteditable', true);
	  elem.setAttribute('spellcheck', Boolean(shouldSpellcheck));
	
	  (0, _jquery2.default)(elem).removeClass(config.editableDisabledClass).addClass(config.editableClass);
	
	  if (normalize) content.tidyHtml(elem);
	}
	
	function disable(elem) {
	  elem.removeAttribute('contenteditable');
	  elem.removeAttribute('spellcheck');
	
	  setState(elem, undefined);
	
	  (0, _jquery2.default)(elem).removeClass(config.editableClass).addClass(config.editableDisabledClass);
	}
	
	function setBlockId(elem) {
	  if (!elem.hasAttribute('data-editable')) {
	    elem.setAttribute('data-editable', 'id-' + nextBlockId);
	    nextBlockId += 1;
	  }
	}
	
	function getState(elem) {
	  if (elem.hasAttribute('data-editable')) {
	    var id = elem.getAttribute('data-editable');
	    return state[id];
	  }
	}
	
	function setState(elem, data) {
	  if (elem.hasAttribute('data-editable')) {
	    var id = elem.getAttribute('data-editable');
	    state[id] = data;
	  }
	}
	
	// Helpers
	// -------
	
	function getSibling(type) {
	  return function (element) {
	    var sibling = element[type];
	    return sibling && sibling.getAttribute('contenteditable') ? sibling : null;
	  };
	}

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.updateConfig = updateConfig;
	exports.paste = paste;
	exports.injectPasteholder = injectPasteholder;
	exports.parseContent = parseContent;
	exports.filterHtmlElements = filterHtmlElements;
	exports.conditionalNodeWrap = conditionalNodeWrap;
	exports.filterAttributes = filterAttributes;
	exports.transformNodeName = transformNodeName;
	exports.hasRequiredAttributes = hasRequiredAttributes;
	exports.shouldKeepNode = shouldKeepNode;
	exports.cleanWhitespace = cleanWhitespace;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	var _string = __webpack_require__(26);
	
	var string = _interopRequireWildcard(_string);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var allowedElements = void 0,
	    requiredAttributes = void 0,
	    transformElements = void 0,
	    blockLevelElements = void 0;
	var splitIntoBlocks = void 0,
	    blacklistedElements = void 0;
	var whitespaceOnly = /^\s*$/;
	var blockPlaceholder = '<!-- BLOCK -->';
	var keepInternalRelativeLinks = void 0;
	
	updateConfig(config);
	function updateConfig(config) {
	  var rules = config.pastedHtmlRules;
	  allowedElements = rules.allowedElements || {};
	  requiredAttributes = rules.requiredAttributes || {};
	  transformElements = rules.transformElements || {};
	  blacklistedElements = rules.blacklistedElements || [];
	  keepInternalRelativeLinks = rules.keepInternalRelativeLinks || false;
	
	  blockLevelElements = {};
	  rules.blockLevelElements.forEach(function (name) {
	    blockLevelElements[name] = true;
	  });
	  splitIntoBlocks = {};
	  rules.splitIntoBlocks.forEach(function (name) {
	    splitIntoBlocks[name] = true;
	  });
	}
	
	function paste(element, cursor, callback) {
	  var document = element.ownerDocument;
	  element.setAttribute(config.pastingAttribute, true);
	
	  if (cursor.isSelection) cursor = cursor.deleteContent();
	
	  // Create a placeholder and set the focus to the pasteholder
	  // to redirect the browser pasting into the pasteholder.
	  cursor.save();
	  var pasteHolder = injectPasteholder(document);
	  pasteHolder.focus();
	
	  // Use a timeout to give the browser some time to paste the content.
	  // After that grab the pasted content, filter it and restore the focus.
	  setTimeout(function () {
	    var blocks = parseContent(pasteHolder);
	    (0, _jquery2.default)(pasteHolder).remove();
	    element.removeAttribute(config.pastingAttribute);
	    cursor.restore();
	    callback(blocks, cursor);
	  }, 0);
	}
	
	function injectPasteholder(document) {
	  var pasteHolder = (0, _jquery2.default)('<div>').attr('contenteditable', true).css({
	    position: 'fixed',
	    right: '5px',
	    top: '50%',
	    width: '1px',
	    height: '1px',
	    overflow: 'hidden',
	    outline: 'none'
	  });
	
	  (0, _jquery2.default)(document.body).append(pasteHolder);
	  return pasteHolder.get(0);
	}
	
	/**
	 * - Parse pasted content
	 * - Split it up into blocks
	 * - clean and normalize every block
	 * - optionally strip the host location an anchorTag-href
	 *   www.livindocs.io/internalLink -> /internalLink
	 *
	 * @param {DOM node} A container where the pasted content is located.
	 * @returns {Array of Strings} An array of cleaned innerHTML like strings.
	 */
	function parseContent(element) {
	  // Filter pasted content
	  return filterHtmlElements(element)
	  // Handle Blocks
	  .split(blockPlaceholder).map(function (entry) {
	    return string.trim(cleanWhitespace(entry));
	  }).filter(function (entry) {
	    return !whitespaceOnly.test(entry);
	  });
	}
	
	function filterHtmlElements(elem) {
	  return (0, _from2.default)(elem.childNodes).reduce(function (content, child) {
	    if (blacklistedElements.indexOf(child.nodeName.toLowerCase()) !== -1) {
	      return '';
	    }
	
	    // Keep internal relative links relative (on paste).
	    if (keepInternalRelativeLinks && child.nodeName === 'A' && child.href) {
	      var stripInternalHost = child.getAttribute('href').replace(window.location.origin, '');
	      child.setAttribute('href', stripInternalHost);
	    }
	
	    if (child.nodeType === nodeType.elementNode) {
	      var childContent = filterHtmlElements(child);
	      return content + conditionalNodeWrap(child, childContent);
	    }
	
	    // Escape HTML characters <, > and &
	    if (child.nodeType === nodeType.textNode) return content + string.escapeHtml(child.nodeValue);
	    return content;
	  }, '');
	}
	
	function conditionalNodeWrap(child, content) {
	  var nodeName = child.nodeName.toLowerCase();
	  nodeName = transformNodeName(nodeName);
	
	  if (shouldKeepNode(nodeName, child)) {
	    var attributes = filterAttributes(nodeName, child);
	
	    if (nodeName === 'br') return '<' + (nodeName + attributes) + '>';
	
	    if (!whitespaceOnly.test(content)) {
	      return '<' + (nodeName + attributes) + '>' + content + '</' + nodeName + '>';
	    }
	
	    return content;
	  }
	
	  if (splitIntoBlocks[nodeName]) {
	    return blockPlaceholder + content + blockPlaceholder;
	  }
	
	  // prevent missing whitespace between text when block-level
	  // elements are removed.
	  if (blockLevelElements[nodeName]) return content + ' ';
	
	  return content;
	}
	
	// returns string of concatenated attributes e.g. 'target="_blank" rel="nofollow" href="/test.com"'
	function filterAttributes(nodeName, node) {
	  return (0, _from2.default)(node.attributes).reduce(function (attributes, _ref) {
	    var name = _ref.name,
	        value = _ref.value;
	
	    if (allowedElements[nodeName][name] && value) {
	      return attributes + ' ' + name + '="' + value + '"';
	    }
	    return attributes;
	  }, '');
	}
	
	function transformNodeName(nodeName) {
	  return transformElements[nodeName] || nodeName;
	}
	
	function hasRequiredAttributes(nodeName, node) {
	  var requiredAttrs = requiredAttributes[nodeName];
	  if (!requiredAttrs) return true;
	
	  return !requiredAttrs.some(function (name) {
	    return !node.getAttribute(name);
	  });
	}
	
	function shouldKeepNode(nodeName, node) {
	  return allowedElements[nodeName] && hasRequiredAttributes(nodeName, node);
	}
	
	function cleanWhitespace(str) {
	  return str.replace(/\n/g, ' ').replace(/ {2,}/g, ' ').replace(/(.)\u00A0/g, function (match, group) {
	    return group + (/[\u0020]/.test(group) ? '\xA0' : ' ');
	  });
	}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.default = eventable;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Eventable Mixin.
	//
	// Simple mixin to add event emitter methods to an object (Publish/Subscribe).
	//
	// Add on, off and notify methods to an object:
	// eventable(obj)
	//
	// publish an event:
	// obj.notify(context, 'action', param1, param2)
	//
	// Optionally pass a context that will be applied to every event:
	// eventable(obj, context)
	//
	// With this publishing can omit the context argument:
	// obj.notify('action', param1, param2)
	//
	// Subscribe to a 'channel'
	// obj.on('action', funtion(param1, param2){ ... })
	//
	// Unsubscribe an individual listener:
	// obj.off('action', method)
	//
	// Unsubscribe all listeners of a channel:
	// obj.off('action')
	//
	// Unsubscribe all listeners of all channels:
	// obj.off()
	
	function eventable(obj, notifyContext) {
	  _jquery2.default.extend(obj, getEventableModule(notifyContext));
	}
	
	function getEventableModule(notifyContext) {
	  var listeners = {};
	
	  function addListener(events, listener) {
	    events.split(' ').forEach(function (event) {
	      listeners[event] = listeners[event] || [];
	      listeners[event].unshift(listener);
	    });
	  }
	
	  function removeListener(event, listener) {
	    var eventListeners = listeners[event];
	    if (!eventListeners) return;
	
	    var index = eventListeners.indexOf(listener);
	    if (index < 0) return;
	
	    eventListeners.splice(index, 1);
	  }
	
	  // Public Methods
	  return {
	    on: function on(event, listener) {
	      if (arguments.length === 2) {
	        addListener(event, listener);
	      } else if (arguments.length === 1) {
	        for (var eventType in event) {
	          addListener(eventType, event[eventType]);
	        }
	      }
	      return this;
	    },
	    off: function off(event, listener) {
	      if (arguments.length === 2) {
	        removeListener(event, listener);
	      } else if (arguments.length === 1) {
	        listeners[event] = [];
	      } else {
	        listeners = {};
	      }
	    },
	    notify: function notify(context, event) {
	      var args = (0, _from2.default)(arguments);
	
	      if (notifyContext) {
	        event = context;
	        context = notifyContext;
	        args.splice(0, 1);
	      } else {
	        args.splice(0, 2);
	      }
	
	      var eventListeners = listeners[event];
	      if (!eventListeners) return;
	
	      // Execute the newest listeners first.
	      // Stop if a listener returns false.
	      eventListeners.every(function (listener) {
	        return listener.apply(context, args) !== false;
	      });
	    }
	  };
	}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.contenteditableSpanBug = exports.selectionchange = exports.contenteditable = undefined;
	
	var _bowser = __webpack_require__(54);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* Check for contenteditable support
	*
	* (from Modernizr)
	* this is known to false positive in some mobile browsers
	* here is a whitelist of verified working browsers:
	* https://github.com/NielsLeenheer/html5test/blob/549f6eac866aa861d9649a0707ff2c0157895706/scripts/engine.js#L2083
	*/
	var contenteditable = exports.contenteditable = typeof document.documentElement.contentEditable !== 'undefined';
	
	var parser = _bowser2.default.getParser(window.navigator.userAgent);
	var browserName = parser.getBrowser();
	var browserEngine = parser.getEngineName();
	var webKit = browserEngine === 'WebKit';
	
	/**
	 * Check selectionchange event (currently supported in IE, Chrome and Safari)
	 *
	 * To handle selectionchange in firefox see CKEditor selection object
	 * https://github.com/ckeditor/ckeditor-dev/blob/master/core/selection.js#L388
	 */
	// not exactly feature detection... is it?
	var selectionchange = exports.selectionchange = !(browserEngine === 'Gecko' || browserName === 'Opera');
	
	// See Keyboard.prototype.preventContenteditableBug for more information.
	var contenteditableSpanBug = exports.contenteditableSpanBug = !!webKit;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var WordHighlighting = function () {
	
	  // @param markerNode {DOM Node}
	  // @param matchMode {String} either 'word' or 'text'
	  function WordHighlighting(markerNode) {
	    var matchMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'word';
	    (0, _classCallCheck3.default)(this, WordHighlighting);
	
	    this.marker = markerNode;
	    this.matchMode = matchMode;
	  }
	
	  (0, _createClass3.default)(WordHighlighting, [{
	    key: 'findMatches',
	    value: function findMatches(text, highlights) {
	      if (!text) return;
	
	      if (highlights && highlights.length > 0) {
	        return this.searchMatches(text, highlights);
	      }
	    }
	  }, {
	    key: 'searchMatches',
	    value: function searchMatches(text, highlights) {
	      var _this = this;
	
	      var createRegex = this.matchMode === 'word' ? createWordRegex : createHighlightRegex;
	
	      var regex = createRegex(highlights);
	      var matches = [];
	      var match = void 0;
	      while (match = regex.exec(text)) {
	        matches.push(match);
	      }
	
	      return matches.map(function (entry) {
	        return _this.prepareMatch(entry);
	      });
	    }
	  }, {
	    key: 'prepareMatch',
	    value: function prepareMatch(match) {
	      var startIndex = void 0;
	      var matchedText = void 0;
	      if (this.matchMode === 'word') {
	        startIndex = match.index + match[1].length;
	        matchedText = match[2];
	      } else {
	        startIndex = match.index;
	        matchedText = match[0];
	      }
	
	      return {
	        startIndex: startIndex,
	        endIndex: startIndex + matchedText.length,
	        match: matchedText,
	        marker: this.marker
	      };
	    }
	  }]);
	  return WordHighlighting;
	}();
	
	exports.default = WordHighlighting;
	
	
	function createHighlightRegex(words) {
	  var escapedWords = _jquery2.default.map(words, function (word) {
	    return escapeRegEx(word);
	  });
	
	  var regex = '(' + escapedWords.join('|') + ')';
	  return new RegExp(regex, 'g');
	}
	
	// Regex to find whole words within a string
	//
	// Unicode character blocks for letters.
	// See: http://jrgraphix.net/research/unicode_blocks.php
	//
	// \\u0041-\\u005A    A-Z (Basic Latin)
	// \\u0061-\\u007A    a-z (Basic Latin)
	// \\u0030-\\u0039    0-9 (Basic Latin)
	// \\u00AA            ª   (Latin-1 Supplement)
	// \\u00B5            µ   (Latin-1 Supplement)
	// \\u00BA            º   (Latin-1 Supplement)
	// \\u00C0-\\u00D6    À-Ö (Latin-1 Supplement)
	// \\u00D8-\\u00F6    Ø-ö (Latin-1 Supplement)
	// \\u00F8-\\u00FF    ø-ÿ (Latin-1 Supplement)
	// \\u0100-\\u017F    Ā-ſ (Latin Extended-A)
	// \\u0180-\\u024F    ƀ-ɏ (Latin Extended-B)
	var letterChars = '\\u0041-\\u005A\\u0061-\\u007A\\u0030-\\u0039\\u00AA\\u00B5\\u00BA\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u00FF\\u0100-\\u017F\\u0180-\\u024F';
	
	function createWordRegex(words) {
	  var escapedWords = _jquery2.default.map(words, function (word) {
	    return escapeRegEx(word);
	  });
	
	  // (notLetter|^)(words)(?=notLetter|$)
	  var regex = '([^' + letterChars + ']|^)' + ('(' + escapedWords.join('|') + ')') + ('(?=[^' + letterChars + ']|$)');
	
	  return new RegExp(regex, 'g');
	}
	
	function escapeRegEx(s) {
	  return String(s).replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
	}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insertRangeBoundaryMarker = insertRangeBoundaryMarker;
	exports.setRangeBoundary = setRangeBoundary;
	exports.save = save;
	exports.restore = restore;
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _error = __webpack_require__(32);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Inspired by the Selection save and restore module for Rangy by Tim Down
	 * Saves and restores ranges using invisible marker elements in the DOM.
	 */
	var boundaryMarkerId = 0;
	
	// (U+FEFF) zero width no-break space
	var markerTextChar = '\uFEFF';
	
	function insertRangeBoundaryMarker(range, atStart) {
	  var container = range.commonAncestorContainer;
	  // If ownerDocument is null the commonAncestorContainer is window.document
	  if (container.ownerDocument === null || container.ownerDocument === undefined) {
	    (0, _error2.default)('Cannot save range: range is emtpy');
	  }
	
	  // Clone the Range and collapse to the appropriate boundary point
	  var boundaryRange = range.cloneRange();
	  boundaryRange.collapse(atStart);
	
	  // Create the marker element containing a single invisible character using DOM methods and insert it
	  var doc = container.ownerDocument.defaultView.document;
	  var markerEl = doc.createElement('span');
	  markerEl.id = 'editable-range-boundary-' + ++boundaryMarkerId;
	  markerEl.setAttribute('data-editable', 'remove');
	  markerEl.style.lineHeight = '0';
	  markerEl.style.display = 'none';
	  markerEl.appendChild(doc.createTextNode(markerTextChar));
	
	  boundaryRange.insertNode(markerEl);
	  return markerEl;
	}
	
	function setRangeBoundary(host, range, markerId, atStart) {
	  var markerEl = getMarker(host, markerId);
	  if (!markerEl) return console.log('Marker element has been removed. Cannot restore selection.');
	  range[atStart ? 'setStartBefore' : 'setEndBefore'](markerEl);
	  markerEl.parentNode.removeChild(markerEl);
	}
	
	function save(range) {
	  var rangeInfo = void 0,
	      startEl = void 0,
	      endEl = void 0;
	
	  // insert markers
	  if (range.collapsed) {
	    endEl = insertRangeBoundaryMarker(range, false);
	    rangeInfo = {
	      markerId: endEl.id,
	      collapsed: true
	    };
	  } else {
	    endEl = insertRangeBoundaryMarker(range, false);
	    startEl = insertRangeBoundaryMarker(range, true);
	
	    rangeInfo = {
	      startMarkerId: startEl.id,
	      endMarkerId: endEl.id,
	      collapsed: false
	    };
	  }
	
	  // Adjust each range's boundaries to lie between its markers
	  if (range.collapsed) {
	    range.collapseBefore(endEl);
	  } else {
	    range.setEndBefore(endEl);
	    range.setStartAfter(startEl);
	  }
	
	  return rangeInfo;
	}
	
	function restore(host, rangeInfo) {
	  if (rangeInfo.restored) return;
	
	  var range = _rangy2.default.createRange();
	  if (rangeInfo.collapsed) {
	    var markerEl = getMarker(host, rangeInfo.markerId);
	    if (markerEl) {
	      markerEl.style.display = 'inline';
	      var previousNode = markerEl.previousSibling;
	
	      // Workaround for rangy issue 17
	      if (previousNode && previousNode.nodeType === nodeType.textNode) {
	        markerEl.parentNode.removeChild(markerEl);
	        range.collapseToPoint(previousNode, previousNode.length);
	      } else {
	        range.collapseBefore(markerEl);
	        markerEl.parentNode.removeChild(markerEl);
	      }
	    } else {
	      console.log('Marker element has been removed. Cannot restore selection.');
	    }
	  } else {
	    this.setRangeBoundary(host, range, rangeInfo.startMarkerId, true);
	    this.setRangeBoundary(host, range, rangeInfo.endMarkerId, false);
	  }
	
	  range.normalizeBoundaries();
	  return range;
	}
	
	function getMarker(host, id) {
	  return host.querySelector('#' + id);
	}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(82);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(88);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(87);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	__webpack_require__(130);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _cursor = __webpack_require__(25);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	var _highlightSupport = __webpack_require__(30);
	
	var _highlightSupport2 = _interopRequireDefault(_highlightSupport);
	
	var _highlightText = __webpack_require__(31);
	
	var _highlightText2 = _interopRequireDefault(_highlightText);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The Selection module provides a cross-browser abstraction layer for range
	 * and selection.
	 *
	 * @module core
	 * @submodule selection
	 */
	/**
	 * Class that represents a selection and provides functionality to access or
	 * modify the selection.
	 *
	 * @class Selection
	 * @constructor
	 */
	
	var Selection = function (_Cursor) {
	  (0, _inherits3.default)(Selection, _Cursor);
	
	  function Selection() {
	    (0, _classCallCheck3.default)(this, Selection);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Selection.__proto__ || (0, _getPrototypeOf2.default)(Selection)).apply(this, arguments));
	
	    delete _this.isCursor;
	    _this.isSelection = true;
	    return _this;
	  }
	
	  // Get the text inside the selection.
	
	
	  (0, _createClass3.default)(Selection, [{
	    key: 'text',
	    value: function text() {
	      return this.range.toString();
	    }
	
	    // Get the html inside the selection.
	
	  }, {
	    key: 'html',
	    value: function html() {
	      return this.range.toHtml();
	    }
	  }, {
	    key: 'isAllSelected',
	    value: function isAllSelected() {
	      return parser.isBeginningOfHost(this.host, this.range.startContainer, this.range.startOffset) && parser.isTextEndOfHost(this.host, this.range.endContainer, this.range.endOffset);
	    }
	  }, {
	    key: 'getTextRange',
	    value: function getTextRange() {
	      return this.range.toCharacterRange(this.host);
	    }
	
	    // Get the ClientRects of this selection.
	    // Use this if you want more precision than getBoundingClientRect can give.
	
	  }, {
	    key: 'getRects',
	    value: function getRects() {
	      // consider: translate into absolute positions
	      // just like Cursor#getCoordinates()
	      return this.range.nativeRange.getClientRects();
	    }
	  }, {
	    key: 'link',
	    value: function link(href) {
	      var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var $link = (0, _jquery2.default)(this.createElement(config.linkMarkup.name, config.linkMarkup.attribs));
	      if (href) attrs.href = href;
	      $link.attr(attrs);
	      this.forceWrap($link[0]);
	    }
	  }, {
	    key: 'unlink',
	    value: function unlink() {
	      this.removeFormatting(config.linkMarkup.name);
	    }
	  }, {
	    key: 'toggleLink',
	    value: function toggleLink(href, attrs) {
	      var links = this.getTagsByName(config.linkMarkup.name);
	      if (links.length >= 1) {
	        var firstLink = links[0];
	        if (this.isExactSelection(firstLink, 'visible')) {
	          this.unlink();
	        } else {
	          this.expandTo(firstLink);
	        }
	      } else {
	        this.link(href, attrs);
	      }
	    }
	
	    // Manually add a highlight
	    // Note: the current code does not work with newlines (LP)
	
	  }, {
	    key: 'highlight',
	    value: function highlight(_ref) {
	      var highlightId = _ref.highlightId;
	
	      var textBefore = this.textBefore();
	      var currentTextContent = this.text();
	
	      var marker = '<span class="highlight-comment"></span>';
	      var markerNode = _highlightSupport2.default.createMarkerNode(marker, this.win);
	
	      markerNode.setAttribute('data-match', currentTextContent);
	
	      var match = {
	        startIndex: textBefore.length,
	        endIndex: textBefore.length + currentTextContent.length,
	        match: currentTextContent,
	        marker: markerNode
	
	        // Note: highlighting won't retain the selection
	      };_highlightText2.default.highlightMatches(this.host, [match]);
	    }
	
	    // toggle('<em>')
	
	  }, {
	    key: 'toggle',
	    value: function toggle(elem) {
	      elem = this.adoptElement(elem);
	      this.range = content.toggleTag(this.host, this.range, elem);
	      this.setSelection();
	    }
	  }, {
	    key: 'toggleCustom',
	    value: function toggleCustom(_ref2) {
	      var tagName = _ref2.tagName,
	          attributes = _ref2.attributes;
	
	      var customElem = this.createElement(tagName, attributes);
	      this.toggle(customElem);
	    }
	  }, {
	    key: 'makeCustom',
	    value: function makeCustom(_ref3) {
	      var tagName = _ref3.tagName,
	          attributes = _ref3.attributes;
	
	      var customElem = this.createElement(tagName, attributes);
	      this.forceWrap(customElem);
	    }
	  }, {
	    key: 'makeBold',
	    value: function makeBold() {
	      var bold = this.createElement(config.boldMarkup.name, config.boldMarkup.attribs);
	      this.forceWrap(bold);
	    }
	  }, {
	    key: 'toggleBold',
	    value: function toggleBold() {
	      var bold = this.createElement(config.boldMarkup.name, config.boldMarkup.attribs);
	      this.toggle(bold);
	    }
	  }, {
	    key: 'giveEmphasis',
	    value: function giveEmphasis() {
	      var em = this.createElement(config.italicMarkup.name, config.italicMarkup.attribs);
	      this.forceWrap(em);
	    }
	  }, {
	    key: 'toggleEmphasis',
	    value: function toggleEmphasis() {
	      var em = this.createElement(config.italicMarkup.name, config.italicMarkup.attribs);
	      this.toggle(em);
	    }
	  }, {
	    key: 'makeUnderline',
	    value: function makeUnderline() {
	      var u = this.createElement(config.underlineMarkup.name, config.underlineMarkup.attribs);
	      this.forceWrap(u);
	    }
	  }, {
	    key: 'toggleUnderline',
	    value: function toggleUnderline() {
	      var u = this.createElement(config.underlineMarkup.name, config.underlineMarkup.attribs);
	      this.toggle(u);
	    }
	  }, {
	    key: 'insertCharacter',
	    value: function insertCharacter(character) {
	      var cursor = this.deleteContent();
	      var textNode = cursor.createTextNode(character);
	      cursor.insertBefore(textNode);
	      cursor.setSelection();
	      return cursor;
	    }
	
	    // Surround the selection with characters like quotes.
	    //
	    // @param {String} E.g. '«'
	    // @param {String} E.g. '»'
	
	  }, {
	    key: 'surround',
	    value: function surround(startCharacter, endCharacter) {
	      this.range = content.surround(this.host, this.range, startCharacter, endCharacter);
	      this.setSelection();
	    }
	  }, {
	    key: 'removeSurround',
	    value: function removeSurround(startCharacter, endCharacter) {
	      this.range = content.deleteCharacter(this.host, this.range, startCharacter);
	      this.range = content.deleteCharacter(this.host, this.range, endCharacter);
	      this.setSelection();
	    }
	  }, {
	    key: 'toggleSurround',
	    value: function toggleSurround(startCharacter, endCharacter) {
	      if (this.containsString(startCharacter) && this.containsString(endCharacter)) {
	        this.removeSurround(startCharacter, endCharacter);
	      } else {
	        this.surround(startCharacter, endCharacter);
	      }
	    }
	
	    // @param {String} tagName. E.g. 'a' to remove all links.
	
	  }, {
	    key: 'removeFormatting',
	    value: function removeFormatting(tagName) {
	      this.range = content.removeFormatting(this.host, this.range, tagName);
	      this.setSelection();
	    }
	
	    // Delete the contents inside the range. After that the selection will be a
	    // cursor.
	    //
	    // @return Cursor instance
	
	  }, {
	    key: 'deleteContent',
	    value: function deleteContent() {
	      this.range.deleteContents();
	      return new _cursor2.default(this.host, this.range);
	    }
	
	    // Expand the current selection.
	    //
	    // @param {DOM Node}
	
	  }, {
	    key: 'expandTo',
	    value: function expandTo(elem) {
	      this.range = content.expandTo(this.host, this.range, elem);
	      this.setSelection();
	    }
	
	    //  Collapse the selection at the beginning of the selection
	    //
	    //  @return Cursor instance
	
	  }, {
	    key: 'collapseAtBeginning',
	    value: function collapseAtBeginning(elem) {
	      this.range.collapse(true);
	      this.setSelection();
	      return new _cursor2.default(this.host, this.range);
	    }
	
	    //  Collapse the selection at the end of the selection
	    //
	    //  @return Cursor instance
	
	  }, {
	    key: 'collapseAtEnd',
	    value: function collapseAtEnd(elem) {
	      this.range.collapse(false);
	      this.setSelection();
	      return new _cursor2.default(this.host, this.range);
	    }
	
	    // Wrap the selection with the specified tag. If any other tag with
	    // the same tagName is affecting the selection this tag will be
	    // remove first.
	
	  }, {
	    key: 'forceWrap',
	    value: function forceWrap(elem) {
	      elem = this.adoptElement(elem);
	      this.range = content.forceWrap(this.host, this.range, elem);
	      this.setSelection();
	    }
	
	    // Get all tags that affect the current selection. Optionally pass a
	    // method to filter the returned elements.
	    //
	    // @param {Function filter(node)} [Optional] Method to filter the returned
	    //   DOM Nodes.
	    // @return {Array of DOM Nodes}
	
	  }, {
	    key: 'getTags',
	    value: function getTags(filterFunc) {
	      return content.getTags(this.host, this.range, filterFunc);
	    }
	
	    // Get all tags of the specified type that affect the current selection.
	    //
	    // @method getTagsByName
	    // @param {String} tagName. E.g. 'a' to get all links.
	    // @return {Array of DOM Nodes}
	
	  }, {
	    key: 'getTagsByName',
	    value: function getTagsByName(tagName) {
	      return content.getTagsByName(this.host, this.range, tagName);
	    }
	
	    // Check if the selection is the same as the elements contents.
	    //
	    // @method isExactSelection
	    // @param {DOM Node}
	    // @param {flag:  undefined or 'visible'} if 'visible' is passed
	    //   whitespaces at the beginning or end of the selection will
	    //   be ignored.
	    // @return {Boolean}
	
	  }, {
	    key: 'isExactSelection',
	    value: function isExactSelection(elem, onlyVisible) {
	      return content.isExactSelection(this.range, elem, onlyVisible);
	    }
	
	    // Check if the selection contains the passed string.
	    //
	    // @method containsString
	    // @return {Boolean}
	
	  }, {
	    key: 'containsString',
	    value: function containsString(str) {
	      return content.containsString(this.range, str);
	    }
	
	    // Delete all occurences of the specified character from the
	    // selection.
	
	  }, {
	    key: 'deleteCharacter',
	    value: function deleteCharacter(character) {
	      this.range = content.deleteCharacter(this.host, this.range, character);
	      this.setSelection();
	    }
	  }]);
	  return Selection;
	}(_cursor2.default);
	
	exports.default = Selection;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(86);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(85);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(i){if(t[i])return t[i].exports;var n=t[i]={i:i,l:!1,exports:{}};return e[i].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=e,r.c=t,r.d=function(e,t,i){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(r.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)r.d(i,n,function(t){return e[t]}.bind(null,n));return i},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i=r(18),n=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,i){void 0===i&&(i=!1);var n=e.getVersionPrecision(t),s=e.getVersionPrecision(r),o=Math.max(n,s),a=0,u=e.map([t,r],(function(t){var r=o-e.getVersionPrecision(t),i=t+new Array(r+1).join(".0");return e.map(i.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(i&&(a=o-Math.min(n,s)),o-=1;o>=a;){if(u[0][o]>u[1][o])return 1;if(u[0][o]===u[1][o]){if(o===a)return 0;o-=1}else if(u[0][o]<u[1][o])return-1}},e.map=function(e,t){var r,i=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)i.push(t(e[r]));return i},e.getBrowserAlias=function(e){return i.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return i.BROWSER_MAP[e]||""},e}();t.default=n,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(91))&&i.__esModule?i:{default:i},s=r(18);function o(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}var a=function(){function e(){}var t,r,i;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new n.default(e,t)},e.parse=function(e){return new n.default(e).getResult()},t=e,i=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&o(t.prototype,r),i&&o(t,i),e}();t.default=a,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i=u(r(92)),n=u(r(93)),s=u(r(94)),o=u(r(95)),a=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=i.default.find((function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=n.default.find((function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=s.default.find((function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find((function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return Object.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},i=0,n={},s=0;if(Object.keys(e).forEach((function(t){var o=e[t];"string"==typeof o?(n[t]=o,s+=1):"object"==typeof o&&(r[t]=o,i+=1)})),i>0){var o=Object.keys(r),a=o.find((function(e){return t.isOS(e)}));if(a){var u=this.satisfies(r[a]);if(void 0!==u)return u}var d=o.find((function(e){return t.isPlatform(e)}));if(d){var c=this.satisfies(r[d]);if(void 0!==c)return c}}if(s>0){var f=Object.keys(n).find((function(e){return t.isBrowser(e,!0)}));if(void 0!==f)return this.compareVersion(n[f])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),i=e.toLowerCase(),n=a.default.getBrowserTypeByAlias(i);return t&&n&&(i=n.toLowerCase()),i===r},t.compareVersion=function(e){var t=[0],r=e,i=!1,n=this.getBrowserVersion();if("string"==typeof n)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(i=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(i=!0,r=e.substr(1)),t.indexOf(a.default.compareVersions(n,r,i))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e){return this.isBrowser(e)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i};var s=/version\/(\d+(\.?_?\d+)+)/i,o=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=n.default.getFirstMatch(s,e)||n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=n.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:n.default.getFirstMatch(t,e),version:n.default.getSecondMatch(t,e)}}}];t.default=o,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},s=r(18);var o=[{test:[/Roku\/DVP/],describe:function(e){var t=n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows/i],describe:function(e){var t=n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=n.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/macintosh/i],describe:function(e){var t=n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=n.default.getMacOSVersionName(t),i={name:s.OS_MAP.MacOS,version:t};return r&&(i.versionName=r),i}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=n.default.getAndroidVersionName(t),i={name:s.OS_MAP.Android,version:t};return r&&(i.versionName=r),i}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||n.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=o,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},s=r(18);var o=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=n.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=n.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=o,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},s=r(18);var o=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=o,e.exports=t.default}})}));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(19);
	var document = __webpack_require__(10).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(12) && !__webpack_require__(21)(function () {
	  return Object.defineProperty(__webpack_require__(55)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(27);
	var $export = __webpack_require__(13);
	var redefine = __webpack_require__(64);
	var hide = __webpack_require__(18);
	var Iterators = __webpack_require__(22);
	var $iterCreate = __webpack_require__(108);
	var setToStringTag = __webpack_require__(39);
	var getPrototypeOf = __webpack_require__(61);
	var ITERATOR = __webpack_require__(5)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(38);
	var createDesc = __webpack_require__(23);
	var toIObject = __webpack_require__(20);
	var toPrimitive = __webpack_require__(43);
	var has = __webpack_require__(14);
	var IE8_DOM_DEFINE = __webpack_require__(56);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(12) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(62);
	var hiddenKeys = __webpack_require__(36).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(14);
	var toObject = __webpack_require__(24);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(14);
	var toIObject = __webpack_require__(20);
	var arrayIndexOf = __webpack_require__(99)(false);
	var IE_PROTO = __webpack_require__(40)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(13);
	var core = __webpack_require__(4);
	var fails = __webpack_require__(21);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(18);


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(42);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(115)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(57)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDefaultBehavior;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _log = __webpack_require__(78);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _block = __webpack_require__(46);
	
	var block = _interopRequireWildcard(_block);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The Behavior module defines the behavior triggered in response to the Editable.JS
	 * events (see {{#crossLink "Editable"}}{{/crossLink}}).
	 * The behavior can be overwritten by a user with Editable.init() or on
	 * Editable.add() per element.
	 *
	 * @module core
	 * @submodule behavior
	 */
	
	function createDefaultBehavior(editable) {
	  var document = editable.win.document;
	  /**
	  * Factory for the default behavior.
	  * Provides default behavior of the Editable.JS API.
	  *
	  * @static
	  */
	
	  return {
	    focus: function focus(element) {
	      // Add a <br> element if the editable is empty to force it to have height
	      // E.g. Firefox does not render empty block elements and most browsers do
	      // not render  empty inline elements.
	      if (!parser.isVoid(element)) return;
	      var br = document.createElement('br');
	      br.setAttribute('data-editable', 'remove');
	      element.appendChild(br);
	    },
	    blur: function blur(element) {
	      content.cleanInternals(element);
	    },
	    selection: function selection(element, _selection) {
	      (0, _log2.default)(_selection ? 'Default selection behavior' : 'Default selection empty behavior');
	    },
	    cursor: function cursor(element, _cursor) {
	      (0, _log2.default)(_cursor ? 'Default cursor behavior' : 'Default cursor empty behavior');
	    },
	    newline: function newline(element, cursor) {
	
	      if (cursor.isAtTextEnd()) {
	        var trailingBr = document.createElement('br');
	        trailingBr.setAttribute('data-editable', 'remove');
	        cursor.insertBefore(trailingBr);
	      } else {
	        cursor.insertBefore(document.createElement('br'));
	      }
	
	      cursor.setVisibleSelection();
	    },
	    insert: function insert(element, direction, cursor) {
	      var parent = element.parentNode;
	      var newElement = element.cloneNode(false);
	      if (newElement.id) newElement.removeAttribute('id');
	
	      switch (direction) {
	        case 'before':
	          parent.insertBefore(newElement, element);
	          element.focus();
	          break;
	        case 'after':
	          parent.insertBefore(newElement, element.nextSibling);
	          newElement.focus();
	          break;
	      }
	    },
	    split: function split(element, before, after, cursor) {
	      var newNode = element.cloneNode(false);
	      newNode.appendChild(before);
	
	      var parent = element.parentNode;
	      parent.insertBefore(newNode, element);
	
	      while (element.firstChild) {
	        element.removeChild(element.firstChild);
	      }element.appendChild(after);
	      content.tidyHtml(newNode);
	      content.tidyHtml(element);
	      element.focus();
	    },
	    merge: function merge(element, direction, cursor) {
	      var container = void 0,
	          merger = void 0;
	
	      switch (direction) {
	        case 'before':
	          container = block.previous(element);
	          merger = element;
	          break;
	        case 'after':
	          container = element;
	          merger = block.next(element);
	          break;
	      }
	
	      if (!(container && merger)) return;
	
	      cursor = container.childNodes.length > 0 ? editable.appendTo(container, merger.innerHTML) : editable.prependTo(container, merger.innerHTML);
	
	      // remove merged node
	      merger.parentNode.removeChild(merger);
	
	      cursor.save();
	      content.tidyHtml(container);
	      cursor.restore();
	      cursor.setVisibleSelection();
	    },
	    empty: function empty(element) {
	      (0, _log2.default)('Default empty behavior');
	    },
	    switch: function _switch(element, direction, cursor) {
	      switch (direction) {
	        case 'before':
	          var previous = block.previous(element);
	          if (previous) {
	            cursor.moveAtTextEnd(previous);
	            cursor.setVisibleSelection();
	          }
	          break;
	        case 'after':
	          var next = block.next(element);
	          if (next) {
	            cursor.moveAtBeginning(next);
	            cursor.setVisibleSelection();
	          }
	          break;
	      }
	    },
	    move: function move(element, selection, direction) {
	      (0, _log2.default)('Default move behavior');
	    },
	    paste: function paste(element, blocks, cursor) {
	      if (blocks.length === 0) return;
	
	      cursor.insertBefore(blocks.shift());
	      if (blocks.length === 0) return cursor.setVisibleSelection();
	
	      var parent = element.parentNode;
	      var currentElement = element;
	
	      blocks.forEach(function (block) {
	        var newElement = element.cloneNode(false);
	        if (newElement.id) newElement.removeAttribute('id');
	        var fragment = content.createFragmentFromString(block);
	        (0, _jquery2.default)(newElement).append(fragment);
	        parent.insertBefore(newElement, currentElement.nextSibling);
	        currentElement = newElement;
	      });
	
	      // focus last element
	      editable.createCursorAtEnd(currentElement).setVisibleSelection();
	    },
	    clipboard: function clipboard(element, action, cursor) {
	      (0, _log2.default)('Default clipboard behavior');
	    }
	  };
	}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createDefaultEvents;
	
	var _createDefaultBehavior = __webpack_require__(67);
	
	var _createDefaultBehavior2 = _interopRequireDefault(_createDefaultBehavior);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createDefaultEvents(editable) {
	  var behavior = (0, _createDefaultBehavior2.default)(editable);
	
	  return {
	    /**
	     * The focus event is triggered when an element gains focus.
	     * The default behavior is to... TODO
	     *
	     * @event focus
	     * @param {HTMLElement} element The element triggering the event.
	     */
	    focus: function focus(element) {
	      behavior.focus(element);
	    },
	
	
	    /**
	     * The blur event is triggered when an element looses focus.
	     * The default behavior is to... TODO
	     *
	     * @event blur
	     * @param {HTMLElement} element The element triggering the event.
	     */
	    blur: function blur(element) {
	      behavior.blur(element);
	    },
	
	
	    /**
	     * The flow event is triggered when the user starts typing or pause typing.
	     * The default behavior is to... TODO
	     *
	     * @event flow
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} action The flow action: "start" or "pause".
	     */
	    flow: function flow(element, action) {
	      behavior.flow(element, action);
	    },
	
	
	    /**
	     * The selection event is triggered after the user has selected some
	     * content.
	     * The default behavior is to... TODO
	     *
	     * @event selection
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {Selection} selection The actual Selection object.
	     */
	    selection: function selection(element, _selection) {
	      behavior.selection(element, _selection);
	    },
	
	
	    /**
	     * The cursor event is triggered after cursor position has changed.
	     * The default behavior is to... TODO
	     *
	     * @event cursor
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {Cursor} cursor The actual Cursor object.
	     */
	    cursor: function cursor(element, _cursor) {
	      behavior.cursor(element, _cursor);
	    },
	
	
	    /**
	     * The newline event is triggered when a newline should be inserted. This
	     * happens when SHIFT+ENTER key is pressed.
	     * The default behavior is to add a <br />
	     *
	     * @event newline
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {Cursor} cursor The actual cursor object.
	     */
	    newline: function newline(element, cursor) {
	      behavior.newline(element, cursor);
	    },
	
	
	    /**
	     * The split event is triggered when a block should be splitted into two
	     * blocks. This happens when ENTER is pressed within a non-empty block.
	     * The default behavior is to... TODO
	     *
	     * @event split
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} before The HTML string before the split.
	     * @param {String} after The HTML string after the split.
	     * @param {Cursor} cursor The actual cursor object.
	     */
	    split: function split(element, before, after, cursor) {
	      behavior.split(element, before, after, cursor);
	    },
	
	
	    /**
	     * The insert event is triggered when a new block should be inserted. This
	     * happens when ENTER key is pressed at the beginning of a block (should
	     * insert before) or at the end of a block (should insert after).
	     * The default behavior is to... TODO
	     *
	     * @event insert
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} direction The insert direction: "before" or "after".
	     * @param {Cursor} cursor The actual cursor object.
	     */
	    insert: function insert(element, direction, cursor) {
	      behavior.insert(element, direction, cursor);
	    },
	
	
	    /**
	     * The merge event is triggered when two needs to be merged. This happens
	     * when BACKSPACE is pressed at the beginning of a block (should merge with
	     * the preceeding block) or DEL is pressed at the end of a block (should
	     * merge with the following block).
	     * The default behavior is to... TODO
	     *
	     * @event merge
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} direction The merge direction: "before" or "after".
	     * @param {Cursor} cursor The actual cursor object.
	     */
	    merge: function merge(element, direction, cursor) {
	      behavior.merge(element, direction, cursor);
	    },
	
	
	    /**
	     * The empty event is triggered when a block is emptied.
	     * The default behavior is to... TODO
	     *
	     * @event empty
	     * @param {HTMLElement} element The element triggering the event.
	     */
	    empty: function empty(element) {
	      behavior.empty(element);
	    },
	
	
	    /**
	     * The switch event is triggered when the user switches to another block.
	     * This happens when an ARROW key is pressed near the boundaries of a block.
	     * The default behavior is to... TODO
	     *
	     * @event switch
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} direction The switch direction: "before" or "after".
	     * @param {Cursor} cursor The actual cursor object.*
	     */
	    switch: function _switch(element, direction, cursor) {
	      behavior.switch(element, direction, cursor);
	    },
	
	
	    /**
	     * The move event is triggered when the user moves a selection in a block.
	     * This happens when the user selects some (or all) content in a block and
	     * an ARROW key is pressed (up: drag before, down: drag after).
	     * The default behavior is to... TODO
	     *
	     * @event move
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {Selection} selection The actual Selection object.
	     * @param {String} direction The move direction: "before" or "after".
	     */
	    move: function move(element, selection, direction) {
	      behavior.move(element, selection, direction);
	    },
	
	
	    /**
	     * The clipboard event is triggered when the user copies or cuts
	     * a selection within a block.
	     *
	     * @event clipboard
	     * @param {HTMLElement} element The element triggering the event.
	     * @param {String} action The clipboard action: "copy" or "cut".
	     * @param {Selection} selection A selection object around the copied content.
	     */
	    clipboard: function clipboard(element, action, selection) {
	      behavior.clipboard(element, action, selection);
	    },
	
	
	    /**
	     * The paste event is triggered when the user pastes text
	     *
	     * @event paste
	     * @param {HTMLElement} The element triggering the event.
	     * @param {Array of String} The pasted blocks
	     * @param {Cursor} The cursor object.
	     */
	    paste: function paste(element, blocks, cursor) {
	      behavior.paste(element, blocks, cursor);
	    }
	  };
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _featureDetection = __webpack_require__(49);
	
	var _clipboard = __webpack_require__(47);
	
	var clipboard = _interopRequireWildcard(_clipboard);
	
	var _eventable = __webpack_require__(48);
	
	var _eventable2 = _interopRequireDefault(_eventable);
	
	var _selectionWatcher = __webpack_require__(77);
	
	var _selectionWatcher2 = _interopRequireDefault(_selectionWatcher);
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	var _keyboard = __webpack_require__(71);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// This will be set to true once we detect the input event is working.
	// Input event description on MDN:
	// https://developer.mozilla.org/en-US/docs/Web/Reference/Events/input
	var isInputEventSupported = false;
	
	/**
	 * The Dispatcher module is responsible for dealing with events and their handlers.
	 *
	 * @module core
	 * @submodule dispatcher
	 */
	
	var Dispatcher = function () {
	  function Dispatcher(editable) {
	    (0, _classCallCheck3.default)(this, Dispatcher);
	
	    var win = editable.win;
	    (0, _eventable2.default)(this, editable);
	    this.supportsInputEvent = false;
	    this.$document = (0, _jquery2.default)(win.document);
	    this.config = editable.config;
	    this.editable = editable;
	    this.editableSelector = editable.editableSelector;
	    this.selectionWatcher = new _selectionWatcher2.default(this, win);
	    this.keyboard = new _keyboard2.default(this.selectionWatcher);
	    this.setup();
	  }
	
	  /**
	  * Sets up all events that Editable.JS is catching.
	  *
	  * @method setup
	  */
	
	
	  (0, _createClass3.default)(Dispatcher, [{
	    key: 'setup',
	    value: function setup() {
	      // setup all events listeners and keyboard handlers
	      this.setupKeyboardEvents();
	      this.setupEventListeners();
	    }
	  }, {
	    key: 'unload',
	    value: function unload() {
	      this.off();
	      this.$document.off('.editable');
	    }
	  }, {
	    key: 'suspend',
	    value: function suspend() {
	      if (this.suspended) return;
	      this.suspended = true;
	      this.$document.off('.editable');
	    }
	  }, {
	    key: 'continue',
	    value: function _continue() {
	      if (!this.suspended) return;
	      this.suspended = false;
	      this.setupEventListeners();
	    }
	  }, {
	    key: 'setupEventListeners',
	    value: function setupEventListeners() {
	      this.setupElementListeners();
	      this.setupKeydownListener();
	
	      if (_featureDetection.selectionchange) {
	        this.setupSelectionChangeListeners();
	      } else {
	        this.setupSelectionChangeFallbackListeners();
	      }
	    }
	
	    /**
	    * Sets up events that are triggered on modifying an element.
	    *
	    * @method setupElementListeners
	    */
	
	  }, {
	    key: 'setupElementListeners',
	    value: function setupElementListeners() {
	      var self = this;
	      var selector = this.editableSelector;
	
	      this.$document.on('focus.editable', selector, function (event) {
	        if (this.getAttribute(config.pastingAttribute)) return;
	        self.selectionWatcher.syncSelection();
	        self.notify('focus', this);
	      }).on('blur.editable', selector, function (event) {
	        if (this.getAttribute(config.pastingAttribute)) return;
	        self.notify('blur', this);
	      }).on('copy.editable', selector, function (event) {
	        var selection = self.selectionWatcher.getFreshSelection();
	        if (selection.isSelection) {
	          self.notify('clipboard', this, 'copy', selection);
	        }
	      }).on('cut.editable', selector, function (event) {
	        var selection = self.selectionWatcher.getFreshSelection();
	        if (selection.isSelection) {
	          self.notify('clipboard', this, 'cut', selection);
	          self.triggerChangeEvent(this);
	        }
	      }).on('paste.editable', selector, function (event) {
	        var element = this;
	
	        function afterPaste(blocks, cursor) {
	          if (blocks.length) {
	            self.notify('paste', element, blocks, cursor);
	
	            // The input event does not fire when we process the content manually
	            // and insert it via script
	            self.notify('change', element);
	          } else {
	            cursor.setVisibleSelection();
	          }
	        }
	
	        var cursor = self.selectionWatcher.getFreshSelection();
	        clipboard.paste(this, cursor, afterPaste);
	      }).on('input.editable', selector, function (event) {
	        if (isInputEventSupported) {
	          self.notify('change', this);
	        } else {
	          // Most likely the event was already handled manually by
	          // triggerChangeEvent so the first time we just switch the
	          // isInputEventSupported flag without notifiying the change event.
	          isInputEventSupported = true;
	        }
	      }).on('formatEditable.editable', selector, function (event) {
	        self.notify('change', this);
	      });
	    }
	
	    /**
	    * Trigger a change event
	    *
	    * This should be done in these cases:
	    * - typing a letter
	    * - delete (backspace and delete keys)
	    * - cut
	    * - paste
	    * - copy and paste (not easily possible manually as far as I know)
	    *
	    * Preferrably this is done using the input event. But the input event is not
	    * supported on all browsers for contenteditable elements.
	    * To make things worse it is not detectable either. So instead of detecting
	    * we set 'isInputEventSupported' when the input event fires the first time.
	    */
	
	  }, {
	    key: 'triggerChangeEvent',
	    value: function triggerChangeEvent(target) {
	      if (isInputEventSupported) return;
	      this.notify('change', target);
	    }
	  }, {
	    key: 'dispatchSwitchEvent',
	    value: function dispatchSwitchEvent(event, element, direction) {
	      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
	
	      var cursor = this.selectionWatcher.getSelection();
	      if (!cursor || cursor.isSelection) return;
	
	      if (direction === 'up' && cursor.isAtFirstLine()) {
	        event.preventDefault();
	        event.stopPropagation();
	        this.notify('switch', element, direction, cursor);
	      }
	
	      if (direction === 'down' && cursor.isAtLastLine()) {
	        event.preventDefault();
	        event.stopPropagation();
	        this.notify('switch', element, direction, cursor);
	      }
	    }
	
	    /**
	    * Sets up listener for keydown event which forwards events to
	    * the Keyboard instance.
	    *
	    * @method setupKeydownListener
	    */
	
	  }, {
	    key: 'setupKeydownListener',
	    value: function setupKeydownListener() {
	      var self = this;
	
	      this.$document.on('keydown.editable', this.editableSelector, function (event) {
	        var notifyCharacterEvent = !isInputEventSupported;
	        self.keyboard.dispatchKeyEvent(event, this, notifyCharacterEvent);
	      });
	    }
	
	    /**
	    * Sets up handlers for the keyboard events.
	    * Keyboard definitions are in {{#crossLink "Keyboard"}}{{/crossLink}}.
	    *
	    * @method setupKeyboardEvents
	    */
	
	  }, {
	    key: 'setupKeyboardEvents',
	    value: function setupKeyboardEvents() {
	      var self = this;
	
	      this.keyboard.on('up', function (event) {
	        self.dispatchSwitchEvent(event, this, 'up');
	      }).on('down', function (event) {
	        self.dispatchSwitchEvent(event, this, 'down');
	      }).on('backspace', function (event) {
	        var range = self.selectionWatcher.getFreshRange();
	        if (!range.isCursor) return self.triggerChangeEvent(this);
	
	        var cursor = range.getCursor();
	        if (!cursor.isAtBeginning()) return self.triggerChangeEvent(this);
	
	        event.preventDefault();
	        event.stopPropagation();
	        self.notify('merge', this, 'before', cursor);
	      }).on('delete', function (event) {
	        var range = self.selectionWatcher.getFreshRange();
	        if (!range.isCursor) return self.triggerChangeEvent(this);
	
	        var cursor = range.getCursor();
	        if (!cursor.isAtTextEnd()) return self.triggerChangeEvent(this);
	
	        event.preventDefault();
	        event.stopPropagation();
	        self.notify('merge', this, 'after', cursor);
	      }).on('enter', function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	        var range = self.selectionWatcher.getFreshRange();
	        var cursor = range.forceCursor();
	
	        if (cursor.isAtTextEnd()) {
	          self.notify('insert', this, 'after', cursor);
	        } else if (cursor.isAtBeginning()) {
	          self.notify('insert', this, 'before', cursor);
	        } else {
	          self.notify('split', this, cursor.before(), cursor.after(), cursor);
	        }
	      }).on('shiftEnter', function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	        var cursor = self.selectionWatcher.forceCursor();
	        self.notify('newline', this, cursor);
	      }).on('character', function (event) {
	        self.notify('change', this);
	      });
	    }
	
	    /**
	    * Sets up events that are triggered on a selection change.
	    *
	    * @method setupSelectionChangeListeners
	    * @param {HTMLElement} $document: The document element.
	    * @param {Function} notifier: The callback to be triggered when the event is caught.
	    */
	
	  }, {
	    key: 'setupSelectionChangeListeners',
	    value: function setupSelectionChangeListeners() {
	      var _this = this;
	
	      var selectionDirty = false;
	      var suppressSelectionChanges = false;
	      var $document = this.$document;
	      var selectionWatcher = this.selectionWatcher;
	
	      // fires on mousemove (thats probably a bit too much)
	      // catches changes like 'select all' from context menu
	      $document.on('selectionchange.editable', function (event) {
	        if (suppressSelectionChanges) {
	          selectionDirty = true;
	        } else {
	          selectionWatcher.selectionChanged();
	        }
	      });
	
	      // listen for selection changes by mouse so we can
	      // suppress the selectionchange event and only fire the
	      // change event on mouseup
	      $document.on('mousedown.editable', this.editableSelector, function (event) {
	        if (_this.config.mouseMoveSelectionChanges === false) {
	          suppressSelectionChanges = true;
	
	          // Without this timeout the previous selection is active
	          // until the mouseup event (no. not good).
	          setTimeout(_jquery2.default.proxy(selectionWatcher, 'selectionChanged'), 0);
	        }
	
	        $document.on('mouseup.editableSelection', function (event) {
	          $document.off('.editableSelection');
	          suppressSelectionChanges = false;
	
	          if (selectionDirty) {
	            selectionDirty = false;
	            selectionWatcher.selectionChanged();
	          }
	        });
	      });
	    }
	
	    /**
	    * Fallback solution to support selection change events on browsers that don't
	    * support selectionChange.
	    *
	    * @method setupSelectionChangeFallbackListeners
	    */
	
	  }, {
	    key: 'setupSelectionChangeFallbackListeners',
	    value: function setupSelectionChangeFallbackListeners() {
	      var $document = this.$document;
	      var selectionWatcher = this.selectionWatcher;
	
	      // listen for selection changes by mouse
	      $document.on('mouseup.editable', function (event) {
	        // In Opera when clicking outside of a block
	        // it does not update the selection as it should
	        // without the timeout
	        setTimeout(_jquery2.default.proxy(selectionWatcher, 'selectionChanged'), 0);
	      });
	
	      // listen for selection changes by keys
	      $document.on('keyup.editable', this.editableSelector, function (event) {
	        // when pressing Command + Shift + Left for example the keyup is only triggered
	        // after at least two keys are released. Strange. The culprit seems to be the
	        // Command key. Do we need a workaround?
	        selectionWatcher.selectionChanged();
	      });
	    }
	  }]);
	  return Dispatcher;
	}();
	
	exports.default = Dispatcher;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	var _highlightText = __webpack_require__(31);
	
	var _highlightText2 = _interopRequireDefault(_highlightText);
	
	var _spellcheckService = __webpack_require__(74);
	
	var _spellcheckService2 = _interopRequireDefault(_spellcheckService);
	
	var _whitespaceHighlighting = __webpack_require__(75);
	
	var _whitespaceHighlighting2 = _interopRequireDefault(_whitespaceHighlighting);
	
	var _textHighlighting = __webpack_require__(50);
	
	var _textHighlighting2 = _interopRequireDefault(_textHighlighting);
	
	var _matchCollection = __webpack_require__(73);
	
	var _matchCollection2 = _interopRequireDefault(_matchCollection);
	
	var _highlightSupport = __webpack_require__(30);
	
	var _highlightSupport2 = _interopRequireDefault(_highlightSupport);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Highlighting = function () {
	  function Highlighting(editable, configuration, spellcheckConfig) {
	    (0, _classCallCheck3.default)(this, Highlighting);
	
	    this.editable = editable;
	    this.win = editable.win;
	    this.focusedEditableHost = undefined;
	    this.currentlyCheckedEditableHost = undefined;
	    this.timeout = {};
	
	    var defaultConfig = {
	      checkOnInit: false,
	      checkOnFocus: false,
	      checkOnChange: true,
	      // unbounce rate in ms before calling the spellcheck service after changes
	      throttle: 1000,
	      // remove highlights after a change if the cursor is inside a highlight
	      removeOnCorrection: true,
	      spellcheck: {
	        marker: '<span class="highlight-spellcheck"></span>',
	        throttle: 1000,
	        spellcheckService: function spellcheckService() {}
	      },
	      whitespace: {
	        marker: '<span class="highlight-whitespace"></span>'
	      }
	    };
	
	    this.config = _jquery2.default.extend(true, defaultConfig, configuration);
	
	    var spellcheckService = this.config.spellcheck.spellcheckService;
	    var spellcheckMarker = this.config.spellcheck.marker;
	    var whitespaceMarker = this.config.whitespace.marker;
	    var spellcheckMarkerNode = _highlightSupport2.default.createMarkerNode(spellcheckMarker, 'spellcheck', this.win);
	    var whitespaceMarkerNode = _highlightSupport2.default.createMarkerNode(whitespaceMarker, 'spellcheck', this.win);
	
	    this.spellcheckService = new _spellcheckService2.default(spellcheckService);
	    this.spellcheck = new _textHighlighting2.default(spellcheckMarkerNode);
	    this.whitespace = new _whitespaceHighlighting2.default(whitespaceMarkerNode);
	
	    this.setupListeners();
	  }
	
	  // Events
	  // ------
	
	  (0, _createClass3.default)(Highlighting, [{
	    key: 'setupListeners',
	    value: function setupListeners() {
	      if (this.config.checkOnFocus) {
	        this.editable.on('focus', _jquery2.default.proxy(this, 'onFocus'));
	        this.editable.on('blur', _jquery2.default.proxy(this, 'onBlur'));
	      }
	      if (this.config.checkOnChange || this.config.removeOnCorrection) {
	        this.editable.on('change', _jquery2.default.proxy(this, 'onChange'));
	      }
	      if (this.config.checkOnInit) {
	        this.editable.on('init', _jquery2.default.proxy(this, 'onInit'));
	      }
	    }
	  }, {
	    key: 'onInit',
	    value: function onInit(editableHost) {
	      this.highlight(editableHost);
	    }
	  }, {
	    key: 'onFocus',
	    value: function onFocus(editableHost) {
	      if (this.focusedEditableHost !== editableHost) {
	        this.focusedEditableHost = editableHost;
	        this.editableHasChanged(editableHost);
	      }
	    }
	  }, {
	    key: 'onBlur',
	    value: function onBlur(editableHost) {
	      if (this.focusedEditableHost === editableHost) {
	        this.focusedEditableHost = undefined;
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(editableHost) {
	      if (this.config.checkOnChange) {
	        this.editableHasChanged(editableHost, this.config.throttle);
	      }
	      if (this.config.removeOnCorrection) {
	        this.removeHighlightsAtCursor(editableHost);
	      }
	    }
	
	    // Manage Highlights
	    // -----------------
	
	  }, {
	    key: 'editableHasChanged',
	    value: function editableHasChanged(editableHost, throttle) {
	      var _this = this;
	
	      if (this.timeout.id && this.timeout.editableHost === editableHost) {
	        clearTimeout(this.timeout.id);
	      }
	
	      var timeoutId = setTimeout(function () {
	        _this.highlight(editableHost);
	
	        _this.timeout = {};
	      }, throttle || 0);
	
	      this.timeout = {
	        id: timeoutId,
	        editableHost: editableHost
	      };
	    }
	  }, {
	    key: 'highlight',
	    value: function highlight(editableHost) {
	      var _this2 = this;
	
	      var text = _highlightText2.default.extractText(editableHost);
	
	      // getSpellcheck
	      this.spellcheckService.check(text, function (err, misspelledWords) {
	        if (err) {
	          return;
	        }
	
	        // refresh the text
	        text = _highlightText2.default.extractText(editableHost);
	
	        var matchCollection = new _matchCollection2.default();
	
	        var matches = _this2.spellcheck.findMatches(text, misspelledWords);
	        matchCollection.addMatches('spellcheck', matches);
	
	        matches = _this2.whitespace.findMatches(text);
	        matchCollection.addMatches('whitespace', matches);
	
	        _this2.safeHighlightMatches(editableHost, matchCollection.matches);
	      });
	    }
	
	    // Calls highlightMatches internally but ensures
	    // that the selection stays the same
	
	  }, {
	    key: 'safeHighlightMatches',
	    value: function safeHighlightMatches(editableHost, matches) {
	      var _this3 = this;
	
	      var selection = this.editable.getSelection(editableHost);
	      if (selection) {
	        selection.retainVisibleSelection(function () {
	          _this3.highlightMatches(editableHost, matches);
	        });
	      } else {
	        this.highlightMatches(editableHost, matches);
	      }
	    }
	  }, {
	    key: 'highlightMatches',
	    value: function highlightMatches(editableHost, matches) {
	      // Remove old highlights
	      this.removeHighlights(editableHost);
	
	      // Create new highlights
	      if (matches && matches.length > 0) {
	        // const span = this.createMarkerNode()
	        _highlightText2.default.highlightMatches(editableHost, matches);
	      }
	    }
	  }, {
	    key: 'removeHighlights',
	    value: function removeHighlights(editableHost) {
	      (0, _jquery2.default)(editableHost).find('[data-highlight="spellcheck"]').each(function (index, elem) {
	        content.unwrap(elem);
	      });
	    }
	  }, {
	    key: 'removeHighlightsAtCursor',
	    value: function removeHighlightsAtCursor(editableHost) {
	      var selection = this.editable.getSelection(editableHost);
	      if (selection && selection.isCursor) {
	        var elementAtCursor = selection.range.startContainer;
	        if (elementAtCursor.nodeType === nodeType.textNode) {
	          elementAtCursor = elementAtCursor.parentNode;
	        }
	
	        var wordId = void 0;
	        do {
	          if (elementAtCursor === editableHost) return;
	          var highlightType = elementAtCursor.getAttribute('data-highlight');
	          if (highlightType === 'spellcheck') {
	            wordId = elementAtCursor.getAttribute('data-word-id');
	            break;
	          }
	        } while (elementAtCursor = elementAtCursor.parentNode);
	
	        if (wordId) {
	          selection.retainVisibleSelection(function () {
	            (0, _jquery2.default)(editableHost).find('[data-word-id=' + wordId + ']').each(function (index, elem) {
	              content.unwrap(elem);
	            });
	          });
	        }
	      }
	    }
	  }]);
	  return Highlighting;
	}();
	
	exports.default = Highlighting;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _featureDetection = __webpack_require__(49);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	var _eventable = __webpack_require__(48);
	
	var _eventable2 = _interopRequireDefault(_eventable);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The Keyboard module defines an event API for key events.
	 */
	
	var Keyboard = function () {
	  function Keyboard(selectionWatcher) {
	    (0, _classCallCheck3.default)(this, Keyboard);
	
	    (0, _eventable2.default)(this);
	    this.selectionWatcher = selectionWatcher;
	  }
	
	  (0, _createClass3.default)(Keyboard, [{
	    key: 'dispatchKeyEvent',
	    value: function dispatchKeyEvent(event, target, notifyCharacterEvent) {
	      switch (event.keyCode) {
	        case this.key.left:
	          return this.notify(target, 'left', event);
	
	        case this.key.right:
	          return this.notify(target, 'right', event);
	
	        case this.key.up:
	          return this.notify(target, 'up', event);
	
	        case this.key.down:
	          return this.notify(target, 'down', event);
	
	        case this.key.tab:
	          if (event.shiftKey) return this.notify(target, 'shiftTab', event);
	          return this.notify(target, 'tab', event);
	
	        case this.key.esc:
	          return this.notify(target, 'esc', event);
	
	        case this.key.backspace:
	          this.preventContenteditableBug(target, event);
	          return this.notify(target, 'backspace', event);
	
	        case this.key.delete:
	          this.preventContenteditableBug(target, event);
	          return this.notify(target, 'delete', event);
	
	        case this.key.enter:
	          if (event.shiftKey) return this.notify(target, 'shiftEnter', event);
	          return this.notify(target, 'enter', event);
	        case this.key.ctrl:
	        case this.key.shift:
	        case this.key.alt:
	          return;
	        // Metakey
	        case 224: // Firefox: 224
	        case 17: // Opera: 17
	        case 91: // Chrome/Safari: 91 (Left)
	        case 93:
	          // Chrome/Safari: 93 (Right)
	          return;
	        default:
	          this.preventContenteditableBug(target, event);
	          if (!notifyCharacterEvent) return;
	          // Don't notify character events as long as either the ctrl or
	          // meta key are pressed.
	          // see: https://github.com/livingdocsIO/editable.js/pull/125
	          if (!event.ctrlKey && !event.metaKey) return this.notify(target, 'character', event);
	      }
	    }
	  }, {
	    key: 'preventContenteditableBug',
	    value: function preventContenteditableBug(target, event) {
	      if (!_featureDetection.contenteditableSpanBug) return;
	      if (event.ctrlKey || event.metaKey) return;
	
	      // This fixes a strange webkit bug that can be reproduced as follows:
	      //
	      // 1. A node used within a contenteditable has some style, e.g through the
	      //    following CSS:
	      //
	      //      strong {
	      //        color: red
	      //      }
	      //
	      // 2. A selection starts with the first character of a styled node and ends
	      //    outside of that node, e.g: "big beautiful" is selected in the folloing
	      //    html:
	      //
	      //      <p contenteditable="true">
	      //        Hello <strong>big</strong> beautiful world
	      //      </p>
	      //
	      // 3. The user types a letter character to replace "big beautiful", e.g. "x"
	      //
	      // Result: Webkits adds <font> and <b> tags:
	      //
	      //    <p contenteditable="true">
	      //      Hello
	      //      <font color="#ff0000">
	      //        <b>f</b>
	      //      </font>
	      //      world
	      //    </p>
	      //
	      // This bug ONLY happens, if the first character of the node is selected and
	      // the selection goes further than the node.
	      //
	      // Solution:
	      //
	      // Manually remove the element that would be removed anyway before inserting
	      // the new letter.
	      var rangyInstance = this.selectionWatcher.getFreshRange();
	      if (!rangyInstance.isSelection) return;
	
	      var nodeToRemove = Keyboard.getNodeToRemove(rangyInstance.range, target);
	      if (nodeToRemove) nodeToRemove.remove();
	    }
	  }], [{
	    key: 'getNodeToRemove',
	    value: function getNodeToRemove(selectionRange, target) {
	      // This function is only used by preventContenteditableBug. It is exposed on
	      // the Keyboard constructor for testing purpose only.
	
	      // Let's make sure we are in the edge-case, in which the bug happens.
	      // The selection does not start at the beginning of a node. We have
	      // nothing to do.
	      if (selectionRange.startOffset !== 0) return;
	
	      var startNodeElement = selectionRange.startContainer;
	
	      // If the node is a textNode, we select its parent.
	      if (startNodeElement.nodeType === nodeType.textNode) startNodeElement = startNodeElement.parentNode;
	
	      // The target is the contenteditable element, which we do not want to replace
	      if (startNodeElement === target) return;
	
	      // We get a range that contains everything within the sartNodeElement to test
	      // if the selectionRange is within the startNode, we have nothing to do.
	      var startNodeRange = _rangy2.default.createRange();
	      startNodeRange.setStartBefore(startNodeElement.firstChild);
	      startNodeRange.setEndAfter(startNodeElement.lastChild);
	      if (startNodeRange.containsRange(selectionRange)) return;
	
	      // If the selectionRange.startContainer was a textNode, we have to make sure
	      // that its parent's content starts with this node. Content is either a
	      // text node or an element. This is done to avoid false positives like the
	      // following one:
	      // <strong>foo<em>bar</em>|baz</strong>quux|
	      if (selectionRange.startContainer.nodeType === nodeType.textNode) {
	        var contentNodeTypes = [nodeType.textNode, nodeType.elementNode];
	        var firstContentNode = startNodeElement.firstChild;
	
	        do {
	          if (contentNodeTypes.indexOf(firstContentNode.nodeType) !== -1) break;
	        } while (firstContentNode = firstContentNode.nextSibling);
	
	        if (firstContentNode !== selectionRange.startContainer) return;
	      }
	
	      // Now we know, that we have to return at lease the startNodeElement for
	      // removal. But it could be, that we also need to remove its parent, e.g.
	      // we need to remove <strong> in the following example:
	      // <strong><em>|foo</em>bar</strong>baz|
	      var rangeStatingBeforeCurrentElement = selectionRange.cloneRange();
	      rangeStatingBeforeCurrentElement.setStartBefore(startNodeElement);
	
	      return Keyboard.getNodeToRemove(rangeStatingBeforeCurrentElement, target) || startNodeElement;
	    }
	  }]);
	  return Keyboard;
	}();
	
	exports.default = Keyboard;
	
	
	Keyboard.key = Keyboard.prototype.key = {
	  left: 37,
	  up: 38,
	  right: 39,
	  down: 40,
	  tab: 9,
	  esc: 27,
	  backspace: 8,
	  delete: 46,
	  enter: 13,
	  shift: 16,
	  ctrl: 17,
	  alt: 18
	};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _nodeType = __webpack_require__(6);
	
	var nodeType = _interopRequireWildcard(_nodeType);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// A DOM node iterator.
	//
	// Has the ability to replace nodes on the fly and continue
	// the iteration.
	var NodeIterator = function () {
	  function NodeIterator(root) {
	    (0, _classCallCheck3.default)(this, NodeIterator);
	
	    this.current = this.next = this.root = root;
	  }
	
	  (0, _createClass3.default)(NodeIterator, [{
	    key: 'getNextTextNode',
	    value: function getNextTextNode() {
	      var next = void 0;
	      while (next = this.getNext()) {
	        if (next.nodeType === nodeType.textNode && next.data !== '') return next;
	      }
	    }
	  }, {
	    key: 'getNext',
	    value: function getNext() {
	      var n = this.current = this.next;
	      var child = this.next = undefined;
	      if (this.current) {
	        child = n.firstChild;
	
	        // Skip the children of elements with the attribute data-editable="remove"
	        // This prevents text nodes that are not part of the content to be included.
	        if (child && n.getAttribute('data-editable') !== 'remove') {
	          this.next = child;
	        } else {
	          while (n !== this.root && !(this.next = n.nextSibling)) {
	            n = n.parentNode;
	          }
	        }
	      }
	      return this.current;
	    }
	  }, {
	    key: 'replaceCurrent',
	    value: function replaceCurrent(replacement) {
	      this.current = replacement;
	      this.next = undefined;
	      var n = this.current;
	      while (n !== this.root && !(this.next = n.nextSibling)) {
	        n = n.parentNode;
	      }
	    }
	  }]);
	  return NodeIterator;
	}();
	
	exports.default = NodeIterator;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MatchCollection = function () {
	  function MatchCollection() {
	    (0, _classCallCheck3.default)(this, MatchCollection);
	
	    this.matches = [];
	  }
	
	  (0, _createClass3.default)(MatchCollection, [{
	    key: "addMatches",
	    value: function addMatches(name, matches) {
	      if (!matches || !matches.length) return;
	
	      this.matches = mergeMatches(this.matches, matches);
	    }
	  }]);
	  return MatchCollection;
	}();
	
	// Private Helpers
	// ---------------
	
	exports.default = MatchCollection;
	function mergeMatches(matches1, matches2) {
	  var next = void 0;
	  var length1 = matches1.length;
	  var length2 = matches2.length;
	  var lastEndIndex = -1;
	  var output = [];
	
	  var state = {
	    a1: matches1,
	    i1: 0,
	    a2: matches2,
	    i2: 0
	  };
	
	  while (state.i1 < length1 || state.i2 < length2) {
	    next = pickNext(state);
	    if (next.startIndex >= lastEndIndex) {
	      output.push(next);
	    }
	    lastEndIndex = next.endIndex;
	  }
	
	  return output;
	}
	
	function pickNext(state) {
	  var i1 = state.i1;
	  var i2 = state.i2;
	  var item1 = state.a1[i1];
	  var item2 = state.a2[i2];
	
	  if (item1 && item2 && item1.startIndex < item2.startIndex) {
	    state.i1 = i1 + 1;
	    return item1;
	  } else if (item1 && item2) {
	    state.i2 = i2 + 1;
	    return item2;
	  } else if (item1) {
	    state.i1 = i1 + 1;
	    return item1;
	  } else if (item2) {
	    state.i2 = i2 + 1;
	    return item2;
	  } else {
	    return undefined;
	  }
	}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _content = __webpack_require__(9);
	
	var content = _interopRequireWildcard(_content);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	* Spellcheck class.
	*
	* @class Spellcheck
	* @constructor
	*/
	var SpellcheckService = function () {
	  function SpellcheckService(spellcheckService) {
	    (0, _classCallCheck3.default)(this, SpellcheckService);
	
	    this.spellcheckService = spellcheckService;
	  }
	
	  (0, _createClass3.default)(SpellcheckService, [{
	    key: 'check',
	    value: function check(text, callback) {
	      if (!text) return callback(null);
	
	      var condensedText = content.normalizeWhitespace(text);
	
	      this.spellcheckService(condensedText, function (misspelledWords) {
	        if (misspelledWords && misspelledWords.length > 0) {
	          callback(null, misspelledWords);
	        } else {
	          callback(null);
	        }
	      });
	    }
	  }]);
	  return SpellcheckService;
	}();
	
	exports.default = SpellcheckService;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// See: https://en.wikipedia.org/wiki/Whitespace_character
	
	var characters = {
	  'A0': 'no-break space', // \\u00A0
	  '2000': 'en quad', // \\u2000
	  '2001': 'em quad', // \\u2001
	  '2002': 'en space', // \\u2002
	  '2003': 'em space', // \\u2003
	  '2004': 'three-per-em space', // \\u2004
	  '2005': 'four-per-em space', // \\u2005
	  '2006': 'six-per-em space', // \\u2006
	  '2007': 'figure space', // \\u2007
	  '2008': 'punctuation space', // \\u2008
	  '2009': 'thin space', // \\u2009
	  '200A': 'hair space', // \\u200A
	  '202F': 'narrow no-break space', // \\u202F
	  '205F': 'medium mathematical space', // \\u205F
	  '3000': 'ideographic space' // \\u3000
	
	
	  // The no-break space is not highlighted as this can cause problems.
	  // Browser can insert no-break spaces when typing at the end of
	  // a paragraph and the highlighting prevents browsers from converting
	  // the no-break space back to a normal space when the user keeps typing.
	};var specialWhitespaceChars = '\\u2000-\\u200A\\u202F\\u205F\\u3000';
	
	var WhitespaceHighlighting = function () {
	  function WhitespaceHighlighting(markerNode) {
	    (0, _classCallCheck3.default)(this, WhitespaceHighlighting);
	
	    this.marker = markerNode;
	  }
	
	  (0, _createClass3.default)(WhitespaceHighlighting, [{
	    key: 'findMatches',
	    value: function findMatches(text) {
	      var _this = this;
	
	      if (!text) return;
	
	      var regex = '[' + specialWhitespaceChars + ']';
	      regex = new RegExp(regex, 'g');
	
	      var matches = [];
	      var match = void 0;
	      while (match = regex.exec(text)) {
	        matches.push(match);
	      }return matches.map(function (entry) {
	        return _this.prepareMatch(entry);
	      });
	    }
	  }, {
	    key: 'prepareMatch',
	    value: function prepareMatch(match) {
	      var startIndex = match.index;
	      var unicode = getUnicode(match[0]);
	      var description = characters[unicode];
	      return {
	        startIndex: startIndex,
	        endIndex: startIndex + match.length,
	        match: match[0],
	        title: description + ' (\\u' + unicode + ')',
	        marker: this.marker
	      };
	    }
	  }]);
	  return WhitespaceHighlighting;
	}();
	
	exports.default = WhitespaceHighlighting;
	
	
	function getUnicode(character) {
	  var code = character.charCodeAt(0);
	  return '' + code.toString(16).toUpperCase();
	}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _cursor = __webpack_require__(25);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _selection = __webpack_require__(52);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** RangeContainer
	 *
	 * primarily used to compare ranges
	 * its designed to work with undefined ranges as well
	 * so we can easily compare them without checking for undefined
	 * all the time
	 */
	
	var RangeContainer = function () {
	  function RangeContainer(editableHost, rangyRange) {
	    (0, _classCallCheck3.default)(this, RangeContainer);
	
	    this.host = editableHost && editableHost.jquery ? editableHost[0] : editableHost;
	    this.range = rangyRange;
	    this.isAnythingSelected = rangyRange !== undefined;
	    this.isCursor = this.isAnythingSelected && rangyRange.collapsed;
	    this.isSelection = this.isAnythingSelected && !this.isCursor;
	  }
	
	  (0, _createClass3.default)(RangeContainer, [{
	    key: 'getCursor',
	    value: function getCursor() {
	      if (this.isCursor) return new _cursor2.default(this.host, this.range);
	    }
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      if (this.isSelection) return new _selection2.default(this.host, this.range);
	    }
	  }, {
	    key: 'forceCursor',
	    value: function forceCursor() {
	      if (!this.isSelection) return this.getCursor();
	      return this.getSelection().deleteContent();
	    }
	  }, {
	    key: 'isDifferentFrom',
	    value: function isDifferentFrom() {
	      var otherRangeContainer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new RangeContainer();
	
	      var self = this.range;
	      var other = otherRangeContainer.range;
	      if (self && other) return !self.equals(other);
	      if (!self && !other) return false;
	      return true;
	    }
	  }]);
	  return RangeContainer;
	}();
	
	exports.default = RangeContainer;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(1);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(2);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _rangy = __webpack_require__(7);
	
	var _rangy2 = _interopRequireDefault(_rangy);
	
	var _parser = __webpack_require__(15);
	
	var parser = _interopRequireWildcard(_parser);
	
	var _rangeContainer = __webpack_require__(76);
	
	var _rangeContainer2 = _interopRequireDefault(_rangeContainer);
	
	var _cursor = __webpack_require__(25);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _selection = __webpack_require__(52);
	
	var _selection2 = _interopRequireDefault(_selection);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The SelectionWatcher module watches for selection changes inside
	 * of editable blocks.
	 *
	 * @module core
	 * @submodule selectionWatcher
	 */
	
	var SelectionWatcher = function () {
	  function SelectionWatcher(dispatcher, win) {
	    (0, _classCallCheck3.default)(this, SelectionWatcher);
	
	    this.dispatcher = dispatcher;
	    this.win = win || window;
	    this.rangySelection = undefined;
	    this.currentSelection = undefined;
	    this.currentRange = undefined;
	  }
	
	  /**
	   * Updates the internal selection pointer to the current rangy selection.
	   * Returns true if no exception occured.
	   */
	
	
	  (0, _createClass3.default)(SelectionWatcher, [{
	    key: 'syncSelection',
	    value: function syncSelection() {
	      // it is possible that rangy has a problem with the nativeSelection
	      try {
	        this.rangySelection = _rangy2.default.getSelection(this.win);
	      } catch (err) {
	        return false;
	      }
	
	      return true;
	    }
	
	    /**
	    * Return a RangeContainer if the current selection is within an editable
	    * otherwise return an empty RangeContainer
	    */
	
	  }, {
	    key: 'getRangeContainer',
	    value: function getRangeContainer() {
	      var successfulSync = this.syncSelection();
	
	      // rangeCount is 0 or 1 in all browsers except firefox
	      // firefox can work with multiple ranges
	      // (on a mac hold down the command key to select multiple ranges)
	      if (this.rangySelection.rangeCount && successfulSync) {
	        var range = this.rangySelection.getRangeAt(0);
	        var hostNode = parser.getHost(range.commonAncestorContainer);
	        if (hostNode) return new _rangeContainer2.default(hostNode, range);
	      }
	
	      // return an empty range container
	      return new _rangeContainer2.default();
	    }
	
	    /**
	    * Gets a fresh RangeContainer with the current selection or cursor.
	    *
	    * @return RangeContainer instance
	    */
	
	  }, {
	    key: 'getFreshRange',
	    value: function getFreshRange() {
	      return this.getRangeContainer();
	    }
	
	    /**
	    * Gets a fresh RangeContainer with the current selection or cursor.
	    *
	    * @return Either a Cursor or Selection instance or undefined if
	    * there is neither a selection or cursor.
	    */
	
	  }, {
	    key: 'getFreshSelection',
	    value: function getFreshSelection() {
	      var range = this.getRangeContainer();
	
	      return range.isCursor ? range.getCursor(this.win) : range.getSelection(this.win);
	    }
	
	    /**
	    * Get the selection set by the last selectionChanged event.
	    * Sometimes the event does not fire fast enough and the seleciton
	    * you get is not the one the user sees.
	    * In those cases use #getFreshSelection()
	    *
	    * @return Either a Cursor or Selection instance or undefined if
	    * there is neither a selection or cursor.
	    */
	
	  }, {
	    key: 'getSelection',
	    value: function getSelection() {
	      return this.currentSelection;
	    }
	  }, {
	    key: 'forceCursor',
	    value: function forceCursor() {
	      var range = this.getRangeContainer();
	      return range.forceCursor();
	    }
	  }, {
	    key: 'selectionChanged',
	    value: function selectionChanged() {
	      var newRange = this.getRangeContainer();
	      if (newRange.isDifferentFrom(this.currentRange)) {
	        var lastSelection = this.currentSelection;
	        this.currentRange = newRange;
	
	        // empty selection or cursor
	        if (lastSelection) {
	          if (lastSelection.isCursor && !this.currentRange.isCursor) {
	            this.dispatcher.notify('cursor', lastSelection.host);
	          } else if (lastSelection.isSelection && !this.currentRange.isSelection) {
	            this.dispatcher.notify('selection', lastSelection.host);
	          }
	        }
	
	        // set new selection or cursor and fire event
	        if (this.currentRange.isCursor) {
	          this.currentSelection = new _cursor2.default(this.currentRange.host, this.currentRange.range);
	          this.dispatcher.notify('cursor', this.currentSelection.host, this.currentSelection);
	        } else if (this.currentRange.isSelection) {
	          this.currentSelection = new _selection2.default(this.currentRange.host, this.currentRange.range);
	          this.dispatcher.notify('selection', this.currentSelection.host, this.currentSelection);
	        } else {
	          this.currentSelection = undefined;
	        }
	      }
	    }
	  }]);
	  return SelectionWatcher;
	}();
	
	exports.default = SelectionWatcher;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _from = __webpack_require__(16);
	
	var _from2 = _interopRequireDefault(_from);
	
	exports.default = log;
	
	var _config = __webpack_require__(8);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Allows for safe console logging
	// If the last param is the string "trace" console.trace will be called
	// configuration: disable with config.log = false
	function log() {
	  if (config.log === false) return;
	
	  if (!global.console) return;
	
	  var args = arguments.length === 1 ? arguments[0] : (0, _from2.default)(arguments);
	
	  if (arguments.length !== 1 && args[args.length - 1] === 'trace') {
	    args.pop();
	    if (console.trace) console.trace();
	  }
	
	  return console.log(args);
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// code from mdn: https://developer.mozilla.org/en-US/docs/Web/API/window.scrollX
	function getScrollPosition(win) {
	  var x = win.pageXOffset !== undefined ? win.pageXOffset : (win.document.documentElement || win.document.body.parentNode || win.document.body).scrollLeft;
	  var y = win.pageYOffset !== undefined ? win.pageYOffset : (win.document.documentElement || win.document.body.parentNode || win.document.body).scrollTop;
	  return { x: x, y: y };
	}
	
	exports.getScrollPosition = getScrollPosition;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(91), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(92), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(95), __esModule: true };

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(96), __esModule: true };

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(84);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(80);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(53);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66);
	__webpack_require__(118);
	module.exports = __webpack_require__(4).Array.from;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(120);
	var $Object = __webpack_require__(4).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(121);
	var $Object = __webpack_require__(4).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(122);
	module.exports = __webpack_require__(4).Object.getPrototypeOf;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(123);
	module.exports = __webpack_require__(4).Object.keys;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(124);
	module.exports = __webpack_require__(4).Object.setPrototypeOf;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(126);
	__webpack_require__(125);
	__webpack_require__(127);
	__webpack_require__(128);
	module.exports = __webpack_require__(4).Symbol;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66);
	__webpack_require__(129);
	module.exports = __webpack_require__(45).f('iterator');


/***/ }),
/* 97 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(20);
	var toLength = __webpack_require__(65);
	var toAbsoluteIndex = __webpack_require__(116);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(33);
	var TAG = __webpack_require__(5)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(11);
	var createDesc = __webpack_require__(23);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(28);
	var gOPS = __webpack_require__(60);
	var pIE = __webpack_require__(38);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(10).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(33);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(22);
	var ITERATOR = __webpack_require__(5)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(33);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(17);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(37);
	var descriptor = __webpack_require__(23);
	var setToStringTag = __webpack_require__(39);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(18)(IteratorPrototype, __webpack_require__(5)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(5)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(29)('meta');
	var isObject = __webpack_require__(19);
	var has = __webpack_require__(14);
	var setDesc = __webpack_require__(11).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(21)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(11);
	var anObject = __webpack_require__(17);
	var getKeys = __webpack_require__(28);
	
	module.exports = __webpack_require__(12) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(20);
	var gOPN = __webpack_require__(59).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(19);
	var anObject = __webpack_require__(17);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(34)(Function.call, __webpack_require__(58).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(42);
	var defined = __webpack_require__(35);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(42);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(100);
	var ITERATOR = __webpack_require__(5)('iterator');
	var Iterators = __webpack_require__(22);
	module.exports = __webpack_require__(4).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(34);
	var $export = __webpack_require__(13);
	var toObject = __webpack_require__(24);
	var call = __webpack_require__(107);
	var isArrayIter = __webpack_require__(105);
	var toLength = __webpack_require__(65);
	var createProperty = __webpack_require__(101);
	var getIterFn = __webpack_require__(117);
	
	$export($export.S + $export.F * !__webpack_require__(109)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(98);
	var step = __webpack_require__(110);
	var Iterators = __webpack_require__(22);
	var toIObject = __webpack_require__(20);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(57)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(13);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(37) });


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(13);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(12), 'Object', { defineProperty: __webpack_require__(11).f });


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(24);
	var $getPrototypeOf = __webpack_require__(61);
	
	__webpack_require__(63)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(24);
	var $keys = __webpack_require__(28);
	
	__webpack_require__(63)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(13);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(114).set });


/***/ }),
/* 125 */
/***/ (function(module, exports) {



/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(10);
	var has = __webpack_require__(14);
	var DESCRIPTORS = __webpack_require__(12);
	var $export = __webpack_require__(13);
	var redefine = __webpack_require__(64);
	var META = __webpack_require__(111).KEY;
	var $fails = __webpack_require__(21);
	var shared = __webpack_require__(41);
	var setToStringTag = __webpack_require__(39);
	var uid = __webpack_require__(29);
	var wks = __webpack_require__(5);
	var wksExt = __webpack_require__(45);
	var wksDefine = __webpack_require__(44);
	var enumKeys = __webpack_require__(102);
	var isArray = __webpack_require__(106);
	var anObject = __webpack_require__(17);
	var isObject = __webpack_require__(19);
	var toObject = __webpack_require__(24);
	var toIObject = __webpack_require__(20);
	var toPrimitive = __webpack_require__(43);
	var createDesc = __webpack_require__(23);
	var _create = __webpack_require__(37);
	var gOPNExt = __webpack_require__(113);
	var $GOPD = __webpack_require__(58);
	var $GOPS = __webpack_require__(60);
	var $DP = __webpack_require__(11);
	var $keys = __webpack_require__(28);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(59).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(38).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(27)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(18)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(44)('asyncIterator');


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(44)('observable');


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(119);
	var global = __webpack_require__(10);
	var hide = __webpack_require__(18);
	var Iterators = __webpack_require__(22);
	var TO_STRING_TAG = __webpack_require__(5)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Text range module for Rangy.
	 * Text-based manipulation and searching of ranges and selections.
	 *
	 * Features
	 *
	 * - Ability to move range boundaries by character or word offsets
	 * - Customizable word tokenizer
	 * - Ignores text nodes inside <script> or <style> elements or those hidden by CSS display and visibility properties
	 * - Range findText method to search for text or regex within the page or within a range. Flags for whole words and case
	 *   sensitivity
	 * - Selection and range save/restore as text offsets within a node
	 * - Methods to return visible text within a range or selection
	 * - innerText method for elements
	 *
	 * References
	 *
	 * https://www.w3.org/Bugs/Public/show_bug.cgi?id=13145
	 * http://aryeh.name/spec/innertext/innertext.html
	 * http://dvcs.w3.org/hg/editing/raw-file/tip/editing.html
	 *
	 * Part of Rangy, a cross-browser JavaScript range and selection library
	 * https://github.com/timdown/rangy
	 *
	 * Depends on Rangy core.
	 *
	 * Copyright 2015, Tim Down
	 * Licensed under the MIT license.
	 * Version: 1.3.0
	 * Build date: 10 May 2015
	 */
	
	/**
	 * Problem: handling of trailing spaces before line breaks is handled inconsistently between browsers.
	 *
	 * First, a <br>: this is relatively simple. For the following HTML:
	 *
	 * 1 <br>2
	 *
	 * - IE and WebKit render the space, include it in the selection (i.e. when the content is selected and pasted into a
	 *   textarea, the space is present) and allow the caret to be placed after it.
	 * - Firefox does not acknowledge the space in the selection but it is possible to place the caret after it.
	 * - Opera does not render the space but has two separate caret positions on either side of the space (left and right
	 *   arrow keys show this) and includes the space in the selection.
	 *
	 * The other case is the line break or breaks implied by block elements. For the following HTML:
	 *
	 * <p>1 </p><p>2<p>
	 *
	 * - WebKit does not acknowledge the space in any way
	 * - Firefox, IE and Opera as per <br>
	 *
	 * One more case is trailing spaces before line breaks in elements with white-space: pre-line. For the following HTML:
	 *
	 * <p style="white-space: pre-line">1
	 * 2</p>
	 *
	 * - Firefox and WebKit include the space in caret positions
	 * - IE does not support pre-line up to and including version 9
	 * - Opera ignores the space
	 * - Trailing space only renders if there is a non-collapsed character in the line
	 *
	 * Problem is whether Rangy should ever acknowledge the space and if so, when. Another problem is whether this can be
	 * feature-tested
	 */
	(function(factory, root) {
	    if (true) {
	        // AMD. Register as an anonymous module with a dependency on Rangy.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module != "undefined" && typeof exports == "object") {
	        // Node/CommonJS style
	        module.exports = factory( require("rangy") );
	    } else {
	        // No AMD or CommonJS support so we use the rangy property of root (probably the global variable)
	        factory(root.rangy);
	    }
	})(function(rangy) {
	    rangy.createModule("TextRange", ["WrappedSelection"], function(api, module) {
	        var UNDEF = "undefined";
	        var CHARACTER = "character", WORD = "word";
	        var dom = api.dom, util = api.util;
	        var extend = util.extend;
	        var createOptions = util.createOptions;
	        var getBody = dom.getBody;
	
	
	        var spacesRegex = /^[ \t\f\r\n]+$/;
	        var spacesMinusLineBreaksRegex = /^[ \t\f\r]+$/;
	        var allWhiteSpaceRegex = /^[\t-\r \u0085\u00A0\u1680\u180E\u2000-\u200B\u2028\u2029\u202F\u205F\u3000]+$/;
	        var nonLineBreakWhiteSpaceRegex = /^[\t \u00A0\u1680\u180E\u2000-\u200B\u202F\u205F\u3000]+$/;
	        var lineBreakRegex = /^[\n-\r\u0085\u2028\u2029]$/;
	
	        var defaultLanguage = "en";
	
	        var isDirectionBackward = api.Selection.isDirectionBackward;
	
	        // Properties representing whether trailing spaces inside blocks are completely collapsed (as they are in WebKit,
	        // but not other browsers). Also test whether trailing spaces before <br> elements are collapsed.
	        var trailingSpaceInBlockCollapses = false;
	        var trailingSpaceBeforeBrCollapses = false;
	        var trailingSpaceBeforeBlockCollapses = false;
	        var trailingSpaceBeforeLineBreakInPreLineCollapses = true;
	
	        (function() {
	            var el = dom.createTestElement(document, "<p>1 </p><p></p>", true);
	            var p = el.firstChild;
	            var sel = api.getSelection();
	            sel.collapse(p.lastChild, 2);
	            sel.setStart(p.firstChild, 0);
	            trailingSpaceInBlockCollapses = ("" + sel).length == 1;
	
	            el.innerHTML = "1 <br />";
	            sel.collapse(el, 2);
	            sel.setStart(el.firstChild, 0);
	            trailingSpaceBeforeBrCollapses = ("" + sel).length == 1;
	
	            el.innerHTML = "1 <p>1</p>";
	            sel.collapse(el, 2);
	            sel.setStart(el.firstChild, 0);
	            trailingSpaceBeforeBlockCollapses = ("" + sel).length == 1;
	
	            dom.removeNode(el);
	            sel.removeAllRanges();
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // This function must create word and non-word tokens for the whole of the text supplied to it
	        function defaultTokenizer(chars, wordOptions) {
	            var word = chars.join(""), result, tokenRanges = [];
	
	            function createTokenRange(start, end, isWord) {
	                tokenRanges.push( { start: start, end: end, isWord: isWord } );
	            }
	
	            // Match words and mark characters
	            var lastWordEnd = 0, wordStart, wordEnd;
	            while ( (result = wordOptions.wordRegex.exec(word)) ) {
	                wordStart = result.index;
	                wordEnd = wordStart + result[0].length;
	
	                // Create token for non-word characters preceding this word
	                if (wordStart > lastWordEnd) {
	                    createTokenRange(lastWordEnd, wordStart, false);
	                }
	
	                // Get trailing space characters for word
	                if (wordOptions.includeTrailingSpace) {
	                    while ( nonLineBreakWhiteSpaceRegex.test(chars[wordEnd]) ) {
	                        ++wordEnd;
	                    }
	                }
	                createTokenRange(wordStart, wordEnd, true);
	                lastWordEnd = wordEnd;
	            }
	
	            // Create token for trailing non-word characters, if any exist
	            if (lastWordEnd < chars.length) {
	                createTokenRange(lastWordEnd, chars.length, false);
	            }
	
	            return tokenRanges;
	        }
	
	        function convertCharRangeToToken(chars, tokenRange) {
	            var tokenChars = chars.slice(tokenRange.start, tokenRange.end);
	            var token = {
	                isWord: tokenRange.isWord,
	                chars: tokenChars,
	                toString: function() {
	                    return tokenChars.join("");
	                }
	            };
	            for (var i = 0, len = tokenChars.length; i < len; ++i) {
	                tokenChars[i].token = token;
	            }
	            return token;
	        }
	
	        function tokenize(chars, wordOptions, tokenizer) {
	            var tokenRanges = tokenizer(chars, wordOptions);
	            var tokens = [];
	            for (var i = 0, tokenRange; tokenRange = tokenRanges[i++]; ) {
	                tokens.push( convertCharRangeToToken(chars, tokenRange) );
	            }
	            return tokens;
	        }
	
	        var defaultCharacterOptions = {
	            includeBlockContentTrailingSpace: true,
	            includeSpaceBeforeBr: true,
	            includeSpaceBeforeBlock: true,
	            includePreLineTrailingSpace: true,
	            ignoreCharacters: ""
	        };
	
	        function normalizeIgnoredCharacters(ignoredCharacters) {
	            // Check if character is ignored
	            var ignoredChars = ignoredCharacters || "";
	
	            // Normalize ignored characters into a string consisting of characters in ascending order of character code
	            var ignoredCharsArray = (typeof ignoredChars == "string") ? ignoredChars.split("") : ignoredChars;
	            ignoredCharsArray.sort(function(char1, char2) {
	                return char1.charCodeAt(0) - char2.charCodeAt(0);
	            });
	
	            /// Convert back to a string and remove duplicates
	            return ignoredCharsArray.join("").replace(/(.)\1+/g, "$1");
	        }
	
	        var defaultCaretCharacterOptions = {
	            includeBlockContentTrailingSpace: !trailingSpaceBeforeLineBreakInPreLineCollapses,
	            includeSpaceBeforeBr: !trailingSpaceBeforeBrCollapses,
	            includeSpaceBeforeBlock: !trailingSpaceBeforeBlockCollapses,
	            includePreLineTrailingSpace: true
	        };
	
	        var defaultWordOptions = {
	            "en": {
	                wordRegex: /[a-z0-9]+('[a-z0-9]+)*/gi,
	                includeTrailingSpace: false,
	                tokenizer: defaultTokenizer
	            }
	        };
	
	        var defaultFindOptions = {
	            caseSensitive: false,
	            withinRange: null,
	            wholeWordsOnly: false,
	            wrap: false,
	            direction: "forward",
	            wordOptions: null,
	            characterOptions: null
	        };
	
	        var defaultMoveOptions = {
	            wordOptions: null,
	            characterOptions: null
	        };
	
	        var defaultExpandOptions = {
	            wordOptions: null,
	            characterOptions: null,
	            trim: false,
	            trimStart: true,
	            trimEnd: true
	        };
	
	        var defaultWordIteratorOptions = {
	            wordOptions: null,
	            characterOptions: null,
	            direction: "forward"
	        };
	
	        function createWordOptions(options) {
	            var lang, defaults;
	            if (!options) {
	                return defaultWordOptions[defaultLanguage];
	            } else {
	                lang = options.language || defaultLanguage;
	                defaults = {};
	                extend(defaults, defaultWordOptions[lang] || defaultWordOptions[defaultLanguage]);
	                extend(defaults, options);
	                return defaults;
	            }
	        }
	
	        function createNestedOptions(optionsParam, defaults) {
	            var options = createOptions(optionsParam, defaults);
	            if (defaults.hasOwnProperty("wordOptions")) {
	                options.wordOptions = createWordOptions(options.wordOptions);
	            }
	            if (defaults.hasOwnProperty("characterOptions")) {
	                options.characterOptions = createOptions(options.characterOptions, defaultCharacterOptions);
	            }
	            return options;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        /* DOM utility functions */
	        var getComputedStyleProperty = dom.getComputedStyleProperty;
	
	        // Create cachable versions of DOM functions
	
	        // Test for old IE's incorrect display properties
	        var tableCssDisplayBlock;
	        (function() {
	            var table = document.createElement("table");
	            var body = getBody(document);
	            body.appendChild(table);
	            tableCssDisplayBlock = (getComputedStyleProperty(table, "display") == "block");
	            body.removeChild(table);
	        })();
	
	        var defaultDisplayValueForTag = {
	            table: "table",
	            caption: "table-caption",
	            colgroup: "table-column-group",
	            col: "table-column",
	            thead: "table-header-group",
	            tbody: "table-row-group",
	            tfoot: "table-footer-group",
	            tr: "table-row",
	            td: "table-cell",
	            th: "table-cell"
	        };
	
	        // Corrects IE's "block" value for table-related elements
	        function getComputedDisplay(el, win) {
	            var display = getComputedStyleProperty(el, "display", win);
	            var tagName = el.tagName.toLowerCase();
	            return (display == "block" &&
	                    tableCssDisplayBlock &&
	                    defaultDisplayValueForTag.hasOwnProperty(tagName)) ?
	                defaultDisplayValueForTag[tagName] : display;
	        }
	
	        function isHidden(node) {
	            var ancestors = getAncestorsAndSelf(node);
	            for (var i = 0, len = ancestors.length; i < len; ++i) {
	                if (ancestors[i].nodeType == 1 && getComputedDisplay(ancestors[i]) == "none") {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	
	        function isVisibilityHiddenTextNode(textNode) {
	            var el;
	            return textNode.nodeType == 3 &&
	                (el = textNode.parentNode) &&
	                getComputedStyleProperty(el, "visibility") == "hidden";
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	    
	        // "A block node is either an Element whose "display" property does not have
	        // resolved value "inline" or "inline-block" or "inline-table" or "none", or a
	        // Document, or a DocumentFragment."
	        function isBlockNode(node) {
	            return node &&
	                ((node.nodeType == 1 && !/^(inline(-block|-table)?|none)$/.test(getComputedDisplay(node))) ||
	                node.nodeType == 9 || node.nodeType == 11);
	        }
	
	        function getLastDescendantOrSelf(node) {
	            var lastChild = node.lastChild;
	            return lastChild ? getLastDescendantOrSelf(lastChild) : node;
	        }
	
	        function containsPositions(node) {
	            return dom.isCharacterDataNode(node) ||
	                !/^(area|base|basefont|br|col|frame|hr|img|input|isindex|link|meta|param)$/i.test(node.nodeName);
	        }
	
	        function getAncestors(node) {
	            var ancestors = [];
	            while (node.parentNode) {
	                ancestors.unshift(node.parentNode);
	                node = node.parentNode;
	            }
	            return ancestors;
	        }
	
	        function getAncestorsAndSelf(node) {
	            return getAncestors(node).concat([node]);
	        }
	
	        function nextNodeDescendants(node) {
	            while (node && !node.nextSibling) {
	                node = node.parentNode;
	            }
	            if (!node) {
	                return null;
	            }
	            return node.nextSibling;
	        }
	
	        function nextNode(node, excludeChildren) {
	            if (!excludeChildren && node.hasChildNodes()) {
	                return node.firstChild;
	            }
	            return nextNodeDescendants(node);
	        }
	
	        function previousNode(node) {
	            var previous = node.previousSibling;
	            if (previous) {
	                node = previous;
	                while (node.hasChildNodes()) {
	                    node = node.lastChild;
	                }
	                return node;
	            }
	            var parent = node.parentNode;
	            if (parent && parent.nodeType == 1) {
	                return parent;
	            }
	            return null;
	        }
	
	        // Adpated from Aryeh's code.
	        // "A whitespace node is either a Text node whose data is the empty string; or
	        // a Text node whose data consists only of one or more tabs (0x0009), line
	        // feeds (0x000A), carriage returns (0x000D), and/or spaces (0x0020), and whose
	        // parent is an Element whose resolved value for "white-space" is "normal" or
	        // "nowrap"; or a Text node whose data consists only of one or more tabs
	        // (0x0009), carriage returns (0x000D), and/or spaces (0x0020), and whose
	        // parent is an Element whose resolved value for "white-space" is "pre-line"."
	        function isWhitespaceNode(node) {
	            if (!node || node.nodeType != 3) {
	                return false;
	            }
	            var text = node.data;
	            if (text === "") {
	                return true;
	            }
	            var parent = node.parentNode;
	            if (!parent || parent.nodeType != 1) {
	                return false;
	            }
	            var computedWhiteSpace = getComputedStyleProperty(node.parentNode, "whiteSpace");
	
	            return (/^[\t\n\r ]+$/.test(text) && /^(normal|nowrap)$/.test(computedWhiteSpace)) ||
	                (/^[\t\r ]+$/.test(text) && computedWhiteSpace == "pre-line");
	        }
	
	        // Adpated from Aryeh's code.
	        // "node is a collapsed whitespace node if the following algorithm returns
	        // true:"
	        function isCollapsedWhitespaceNode(node) {
	            // "If node's data is the empty string, return true."
	            if (node.data === "") {
	                return true;
	            }
	
	            // "If node is not a whitespace node, return false."
	            if (!isWhitespaceNode(node)) {
	                return false;
	            }
	
	            // "Let ancestor be node's parent."
	            var ancestor = node.parentNode;
	
	            // "If ancestor is null, return true."
	            if (!ancestor) {
	                return true;
	            }
	
	            // "If the "display" property of some ancestor of node has resolved value "none", return true."
	            if (isHidden(node)) {
	                return true;
	            }
	
	            return false;
	        }
	
	        function isCollapsedNode(node) {
	            var type = node.nodeType;
	            return type == 7 /* PROCESSING_INSTRUCTION */ ||
	                type == 8 /* COMMENT */ ||
	                isHidden(node) ||
	                /^(script|style)$/i.test(node.nodeName) ||
	                isVisibilityHiddenTextNode(node) ||
	                isCollapsedWhitespaceNode(node);
	        }
	
	        function isIgnoredNode(node, win) {
	            var type = node.nodeType;
	            return type == 7 /* PROCESSING_INSTRUCTION */ ||
	                type == 8 /* COMMENT */ ||
	                (type == 1 && getComputedDisplay(node, win) == "none");
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Possibly overengineered caching system to prevent repeated DOM calls slowing everything down
	
	        function Cache() {
	            this.store = {};
	        }
	
	        Cache.prototype = {
	            get: function(key) {
	                return this.store.hasOwnProperty(key) ? this.store[key] : null;
	            },
	
	            set: function(key, value) {
	                return this.store[key] = value;
	            }
	        };
	
	        var cachedCount = 0, uncachedCount = 0;
	
	        function createCachingGetter(methodName, func, objProperty) {
	            return function(args) {
	                var cache = this.cache;
	                if (cache.hasOwnProperty(methodName)) {
	                    cachedCount++;
	                    return cache[methodName];
	                } else {
	                    uncachedCount++;
	                    var value = func.call(this, objProperty ? this[objProperty] : this, args);
	                    cache[methodName] = value;
	                    return value;
	                }
	            };
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function NodeWrapper(node, session) {
	            this.node = node;
	            this.session = session;
	            this.cache = new Cache();
	            this.positions = new Cache();
	        }
	
	        var nodeProto = {
	            getPosition: function(offset) {
	                var positions = this.positions;
	                return positions.get(offset) || positions.set(offset, new Position(this, offset));
	            },
	
	            toString: function() {
	                return "[NodeWrapper(" + dom.inspectNode(this.node) + ")]";
	            }
	        };
	
	        NodeWrapper.prototype = nodeProto;
	
	        var EMPTY = "EMPTY",
	            NON_SPACE = "NON_SPACE",
	            UNCOLLAPSIBLE_SPACE = "UNCOLLAPSIBLE_SPACE",
	            COLLAPSIBLE_SPACE = "COLLAPSIBLE_SPACE",
	            TRAILING_SPACE_BEFORE_BLOCK = "TRAILING_SPACE_BEFORE_BLOCK",
	            TRAILING_SPACE_IN_BLOCK = "TRAILING_SPACE_IN_BLOCK",
	            TRAILING_SPACE_BEFORE_BR = "TRAILING_SPACE_BEFORE_BR",
	            PRE_LINE_TRAILING_SPACE_BEFORE_LINE_BREAK = "PRE_LINE_TRAILING_SPACE_BEFORE_LINE_BREAK",
	            TRAILING_LINE_BREAK_AFTER_BR = "TRAILING_LINE_BREAK_AFTER_BR",
	            INCLUDED_TRAILING_LINE_BREAK_AFTER_BR = "INCLUDED_TRAILING_LINE_BREAK_AFTER_BR";
	
	        extend(nodeProto, {
	            isCharacterDataNode: createCachingGetter("isCharacterDataNode", dom.isCharacterDataNode, "node"),
	            getNodeIndex: createCachingGetter("nodeIndex", dom.getNodeIndex, "node"),
	            getLength: createCachingGetter("nodeLength", dom.getNodeLength, "node"),
	            containsPositions: createCachingGetter("containsPositions", containsPositions, "node"),
	            isWhitespace: createCachingGetter("isWhitespace", isWhitespaceNode, "node"),
	            isCollapsedWhitespace: createCachingGetter("isCollapsedWhitespace", isCollapsedWhitespaceNode, "node"),
	            getComputedDisplay: createCachingGetter("computedDisplay", getComputedDisplay, "node"),
	            isCollapsed: createCachingGetter("collapsed", isCollapsedNode, "node"),
	            isIgnored: createCachingGetter("ignored", isIgnoredNode, "node"),
	            next: createCachingGetter("nextPos", nextNode, "node"),
	            previous: createCachingGetter("previous", previousNode, "node"),
	
	            getTextNodeInfo: createCachingGetter("textNodeInfo", function(textNode) {
	                var spaceRegex = null, collapseSpaces = false;
	                var cssWhitespace = getComputedStyleProperty(textNode.parentNode, "whiteSpace");
	                var preLine = (cssWhitespace == "pre-line");
	                if (preLine) {
	                    spaceRegex = spacesMinusLineBreaksRegex;
	                    collapseSpaces = true;
	                } else if (cssWhitespace == "normal" || cssWhitespace == "nowrap") {
	                    spaceRegex = spacesRegex;
	                    collapseSpaces = true;
	                }
	
	                return {
	                    node: textNode,
	                    text: textNode.data,
	                    spaceRegex: spaceRegex,
	                    collapseSpaces: collapseSpaces,
	                    preLine: preLine
	                };
	            }, "node"),
	
	            hasInnerText: createCachingGetter("hasInnerText", function(el, backward) {
	                var session = this.session;
	                var posAfterEl = session.getPosition(el.parentNode, this.getNodeIndex() + 1);
	                var firstPosInEl = session.getPosition(el, 0);
	
	                var pos = backward ? posAfterEl : firstPosInEl;
	                var endPos = backward ? firstPosInEl : posAfterEl;
	
	                /*
	                 <body><p>X  </p><p>Y</p></body>
	
	                 Positions:
	
	                 body:0:""
	                 p:0:""
	                 text:0:""
	                 text:1:"X"
	                 text:2:TRAILING_SPACE_IN_BLOCK
	                 text:3:COLLAPSED_SPACE
	                 p:1:""
	                 body:1:"\n"
	                 p:0:""
	                 text:0:""
	                 text:1:"Y"
	
	                 A character is a TRAILING_SPACE_IN_BLOCK iff:
	
	                 - There is no uncollapsed character after it within the visible containing block element
	
	                 A character is a TRAILING_SPACE_BEFORE_BR iff:
	
	                 - There is no uncollapsed character after it preceding a <br> element
	
	                 An element has inner text iff
	
	                 - It is not hidden
	                 - It contains an uncollapsed character
	
	                 All trailing spaces (pre-line, before <br>, end of block) require definite non-empty characters to render.
	                 */
	
	                while (pos !== endPos) {
	                    pos.prepopulateChar();
	                    if (pos.isDefinitelyNonEmpty()) {
	                        return true;
	                    }
	                    pos = backward ? pos.previousVisible() : pos.nextVisible();
	                }
	
	                return false;
	            }, "node"),
	
	            isRenderedBlock: createCachingGetter("isRenderedBlock", function(el) {
	                // Ensure that a block element containing a <br> is considered to have inner text
	                var brs = el.getElementsByTagName("br");
	                for (var i = 0, len = brs.length; i < len; ++i) {
	                    if (!isCollapsedNode(brs[i])) {
	                        return true;
	                    }
	                }
	                return this.hasInnerText();
	            }, "node"),
	
	            getTrailingSpace: createCachingGetter("trailingSpace", function(el) {
	                if (el.tagName.toLowerCase() == "br") {
	                    return "";
	                } else {
	                    switch (this.getComputedDisplay()) {
	                        case "inline":
	                            var child = el.lastChild;
	                            while (child) {
	                                if (!isIgnoredNode(child)) {
	                                    return (child.nodeType == 1) ? this.session.getNodeWrapper(child).getTrailingSpace() : "";
	                                }
	                                child = child.previousSibling;
	                            }
	                            break;
	                        case "inline-block":
	                        case "inline-table":
	                        case "none":
	                        case "table-column":
	                        case "table-column-group":
	                            break;
	                        case "table-cell":
	                            return "\t";
	                        default:
	                            return this.isRenderedBlock(true) ? "\n" : "";
	                    }
	                }
	                return "";
	            }, "node"),
	
	            getLeadingSpace: createCachingGetter("leadingSpace", function(el) {
	                switch (this.getComputedDisplay()) {
	                    case "inline":
	                    case "inline-block":
	                    case "inline-table":
	                    case "none":
	                    case "table-column":
	                    case "table-column-group":
	                    case "table-cell":
	                        break;
	                    default:
	                        return this.isRenderedBlock(false) ? "\n" : "";
	                }
	                return "";
	            }, "node")
	        });
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function Position(nodeWrapper, offset) {
	            this.offset = offset;
	            this.nodeWrapper = nodeWrapper;
	            this.node = nodeWrapper.node;
	            this.session = nodeWrapper.session;
	            this.cache = new Cache();
	        }
	
	        function inspectPosition() {
	            return "[Position(" + dom.inspectNode(this.node) + ":" + this.offset + ")]";
	        }
	
	        var positionProto = {
	            character: "",
	            characterType: EMPTY,
	            isBr: false,
	
	            /*
	            This method:
	            - Fully populates positions that have characters that can be determined independently of any other characters.
	            - Populates most types of space positions with a provisional character. The character is finalized later.
	             */
	            prepopulateChar: function() {
	                var pos = this;
	                if (!pos.prepopulatedChar) {
	                    var node = pos.node, offset = pos.offset;
	                    var visibleChar = "", charType = EMPTY;
	                    var finalizedChar = false;
	                    if (offset > 0) {
	                        if (node.nodeType == 3) {
	                            var text = node.data;
	                            var textChar = text.charAt(offset - 1);
	
	                            var nodeInfo = pos.nodeWrapper.getTextNodeInfo();
	                            var spaceRegex = nodeInfo.spaceRegex;
	                            if (nodeInfo.collapseSpaces) {
	                                if (spaceRegex.test(textChar)) {
	                                    // "If the character at position is from set, append a single space (U+0020) to newdata and advance
	                                    // position until the character at position is not from set."
	
	                                    // We also need to check for the case where we're in a pre-line and we have a space preceding a
	                                    // line break, because such spaces are collapsed in some browsers
	                                    if (offset > 1 && spaceRegex.test(text.charAt(offset - 2))) {
	                                    } else if (nodeInfo.preLine && text.charAt(offset) === "\n") {
	                                        visibleChar = " ";
	                                        charType = PRE_LINE_TRAILING_SPACE_BEFORE_LINE_BREAK;
	                                    } else {
	                                        visibleChar = " ";
	                                        //pos.checkForFollowingLineBreak = true;
	                                        charType = COLLAPSIBLE_SPACE;
	                                    }
	                                } else {
	                                    visibleChar = textChar;
	                                    charType = NON_SPACE;
	                                    finalizedChar = true;
	                                }
	                            } else {
	                                visibleChar = textChar;
	                                charType = UNCOLLAPSIBLE_SPACE;
	                                finalizedChar = true;
	                            }
	                        } else {
	                            var nodePassed = node.childNodes[offset - 1];
	                            if (nodePassed && nodePassed.nodeType == 1 && !isCollapsedNode(nodePassed)) {
	                                if (nodePassed.tagName.toLowerCase() == "br") {
	                                    visibleChar = "\n";
	                                    pos.isBr = true;
	                                    charType = COLLAPSIBLE_SPACE;
	                                    finalizedChar = false;
	                                } else {
	                                    pos.checkForTrailingSpace = true;
	                                }
	                            }
	
	                            // Check the leading space of the next node for the case when a block element follows an inline
	                            // element or text node. In that case, there is an implied line break between the two nodes.
	                            if (!visibleChar) {
	                                var nextNode = node.childNodes[offset];
	                                if (nextNode && nextNode.nodeType == 1 && !isCollapsedNode(nextNode)) {
	                                    pos.checkForLeadingSpace = true;
	                                }
	                            }
	                        }
	                    }
	
	                    pos.prepopulatedChar = true;
	                    pos.character = visibleChar;
	                    pos.characterType = charType;
	                    pos.isCharInvariant = finalizedChar;
	                }
	            },
	
	            isDefinitelyNonEmpty: function() {
	                var charType = this.characterType;
	                return charType == NON_SPACE || charType == UNCOLLAPSIBLE_SPACE;
	            },
	
	            // Resolve leading and trailing spaces, which may involve prepopulating other positions
	            resolveLeadingAndTrailingSpaces: function() {
	                if (!this.prepopulatedChar) {
	                    this.prepopulateChar();
	                }
	                if (this.checkForTrailingSpace) {
	                    var trailingSpace = this.session.getNodeWrapper(this.node.childNodes[this.offset - 1]).getTrailingSpace();
	                    if (trailingSpace) {
	                        this.isTrailingSpace = true;
	                        this.character = trailingSpace;
	                        this.characterType = COLLAPSIBLE_SPACE;
	                    }
	                    this.checkForTrailingSpace = false;
	                }
	                if (this.checkForLeadingSpace) {
	                    var leadingSpace = this.session.getNodeWrapper(this.node.childNodes[this.offset]).getLeadingSpace();
	                    if (leadingSpace) {
	                        this.isLeadingSpace = true;
	                        this.character = leadingSpace;
	                        this.characterType = COLLAPSIBLE_SPACE;
	                    }
	                    this.checkForLeadingSpace = false;
	                }
	            },
	
	            getPrecedingUncollapsedPosition: function(characterOptions) {
	                var pos = this, character;
	                while ( (pos = pos.previousVisible()) ) {
	                    character = pos.getCharacter(characterOptions);
	                    if (character !== "") {
	                        return pos;
	                    }
	                }
	
	                return null;
	            },
	
	            getCharacter: function(characterOptions) {
	                this.resolveLeadingAndTrailingSpaces();
	
	                var thisChar = this.character, returnChar;
	
	                // Check if character is ignored
	                var ignoredChars = normalizeIgnoredCharacters(characterOptions.ignoreCharacters);
	                var isIgnoredCharacter = (thisChar !== "" && ignoredChars.indexOf(thisChar) > -1);
	
	                // Check if this position's  character is invariant (i.e. not dependent on character options) and return it
	                // if so
	                if (this.isCharInvariant) {
	                    returnChar = isIgnoredCharacter ? "" : thisChar;
	                    return returnChar;
	                }
	
	                var cacheKey = ["character", characterOptions.includeSpaceBeforeBr, characterOptions.includeBlockContentTrailingSpace, characterOptions.includePreLineTrailingSpace, ignoredChars].join("_");
	                var cachedChar = this.cache.get(cacheKey);
	                if (cachedChar !== null) {
	                    return cachedChar;
	                }
	
	                // We need to actually get the character now
	                var character = "";
	                var collapsible = (this.characterType == COLLAPSIBLE_SPACE);
	
	                var nextPos, previousPos;
	                var gotPreviousPos = false;
	                var pos = this;
	
	                function getPreviousPos() {
	                    if (!gotPreviousPos) {
	                        previousPos = pos.getPrecedingUncollapsedPosition(characterOptions);
	                        gotPreviousPos = true;
	                    }
	                    return previousPos;
	                }
	
	                // Disallow a collapsible space that is followed by a line break or is the last character
	                if (collapsible) {
	                    // Allow a trailing space that we've previously determined should be included
	                    if (this.type == INCLUDED_TRAILING_LINE_BREAK_AFTER_BR) {
	                        character = "\n";
	                    }
	                    // Disallow a collapsible space that follows a trailing space or line break, or is the first character,
	                    // or follows a collapsible included space
	                    else if (thisChar == " " &&
	                            (!getPreviousPos() || previousPos.isTrailingSpace || previousPos.character == "\n" || (previousPos.character == " " && previousPos.characterType == COLLAPSIBLE_SPACE))) {
	                    }
	                    // Allow a leading line break unless it follows a line break
	                    else if (thisChar == "\n" && this.isLeadingSpace) {
	                        if (getPreviousPos() && previousPos.character != "\n") {
	                            character = "\n";
	                        } else {
	                        }
	                    } else {
	                        nextPos = this.nextUncollapsed();
	                        if (nextPos) {
	                            if (nextPos.isBr) {
	                                this.type = TRAILING_SPACE_BEFORE_BR;
	                            } else if (nextPos.isTrailingSpace && nextPos.character == "\n") {
	                                this.type = TRAILING_SPACE_IN_BLOCK;
	                            } else if (nextPos.isLeadingSpace && nextPos.character == "\n") {
	                                this.type = TRAILING_SPACE_BEFORE_BLOCK;
	                            }
	
	                            if (nextPos.character == "\n") {
	                                if (this.type == TRAILING_SPACE_BEFORE_BR && !characterOptions.includeSpaceBeforeBr) {
	                                } else if (this.type == TRAILING_SPACE_BEFORE_BLOCK && !characterOptions.includeSpaceBeforeBlock) {
	                                } else if (this.type == TRAILING_SPACE_IN_BLOCK && nextPos.isTrailingSpace && !characterOptions.includeBlockContentTrailingSpace) {
	                                } else if (this.type == PRE_LINE_TRAILING_SPACE_BEFORE_LINE_BREAK && nextPos.type == NON_SPACE && !characterOptions.includePreLineTrailingSpace) {
	                                } else if (thisChar == "\n") {
	                                    if (nextPos.isTrailingSpace) {
	                                        if (this.isTrailingSpace) {
	                                        } else if (this.isBr) {
	                                            nextPos.type = TRAILING_LINE_BREAK_AFTER_BR;
	
	                                            if (getPreviousPos() && previousPos.isLeadingSpace && !previousPos.isTrailingSpace && previousPos.character == "\n") {
	                                                nextPos.character = "";
	                                            } else {
	                                                nextPos.type = INCLUDED_TRAILING_LINE_BREAK_AFTER_BR;
	                                            }
	                                        }
	                                    } else {
	                                        character = "\n";
	                                    }
	                                } else if (thisChar == " ") {
	                                    character = " ";
	                                } else {
	                                }
	                            } else {
	                                character = thisChar;
	                            }
	                        } else {
	                        }
	                    }
	                }
	
	                if (ignoredChars.indexOf(character) > -1) {
	                    character = "";
	                }
	
	
	                this.cache.set(cacheKey, character);
	
	                return character;
	            },
	
	            equals: function(pos) {
	                return !!pos && this.node === pos.node && this.offset === pos.offset;
	            },
	
	            inspect: inspectPosition,
	
	            toString: function() {
	                return this.character;
	            }
	        };
	
	        Position.prototype = positionProto;
	
	        extend(positionProto, {
	            next: createCachingGetter("nextPos", function(pos) {
	                var nodeWrapper = pos.nodeWrapper, node = pos.node, offset = pos.offset, session = nodeWrapper.session;
	                if (!node) {
	                    return null;
	                }
	                var nextNode, nextOffset, child;
	                if (offset == nodeWrapper.getLength()) {
	                    // Move onto the next node
	                    nextNode = node.parentNode;
	                    nextOffset = nextNode ? nodeWrapper.getNodeIndex() + 1 : 0;
	                } else {
	                    if (nodeWrapper.isCharacterDataNode()) {
	                        nextNode = node;
	                        nextOffset = offset + 1;
	                    } else {
	                        child = node.childNodes[offset];
	                        // Go into the children next, if children there are
	                        if (session.getNodeWrapper(child).containsPositions()) {
	                            nextNode = child;
	                            nextOffset = 0;
	                        } else {
	                            nextNode = node;
	                            nextOffset = offset + 1;
	                        }
	                    }
	                }
	
	                return nextNode ? session.getPosition(nextNode, nextOffset) : null;
	            }),
	
	            previous: createCachingGetter("previous", function(pos) {
	                var nodeWrapper = pos.nodeWrapper, node = pos.node, offset = pos.offset, session = nodeWrapper.session;
	                var previousNode, previousOffset, child;
	                if (offset == 0) {
	                    previousNode = node.parentNode;
	                    previousOffset = previousNode ? nodeWrapper.getNodeIndex() : 0;
	                } else {
	                    if (nodeWrapper.isCharacterDataNode()) {
	                        previousNode = node;
	                        previousOffset = offset - 1;
	                    } else {
	                        child = node.childNodes[offset - 1];
	                        // Go into the children next, if children there are
	                        if (session.getNodeWrapper(child).containsPositions()) {
	                            previousNode = child;
	                            previousOffset = dom.getNodeLength(child);
	                        } else {
	                            previousNode = node;
	                            previousOffset = offset - 1;
	                        }
	                    }
	                }
	                return previousNode ? session.getPosition(previousNode, previousOffset) : null;
	            }),
	
	            /*
	             Next and previous position moving functions that filter out
	
	             - Hidden (CSS visibility/display) elements
	             - Script and style elements
	             */
	            nextVisible: createCachingGetter("nextVisible", function(pos) {
	                var next = pos.next();
	                if (!next) {
	                    return null;
	                }
	                var nodeWrapper = next.nodeWrapper, node = next.node;
	                var newPos = next;
	                if (nodeWrapper.isCollapsed()) {
	                    // We're skipping this node and all its descendants
	                    newPos = nodeWrapper.session.getPosition(node.parentNode, nodeWrapper.getNodeIndex() + 1);
	                }
	                return newPos;
	            }),
	
	            nextUncollapsed: createCachingGetter("nextUncollapsed", function(pos) {
	                var nextPos = pos;
	                while ( (nextPos = nextPos.nextVisible()) ) {
	                    nextPos.resolveLeadingAndTrailingSpaces();
	                    if (nextPos.character !== "") {
	                        return nextPos;
	                    }
	                }
	                return null;
	            }),
	
	            previousVisible: createCachingGetter("previousVisible", function(pos) {
	                var previous = pos.previous();
	                if (!previous) {
	                    return null;
	                }
	                var nodeWrapper = previous.nodeWrapper, node = previous.node;
	                var newPos = previous;
	                if (nodeWrapper.isCollapsed()) {
	                    // We're skipping this node and all its descendants
	                    newPos = nodeWrapper.session.getPosition(node.parentNode, nodeWrapper.getNodeIndex());
	                }
	                return newPos;
	            })
	        });
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        var currentSession = null;
	
	        var Session = (function() {
	            function createWrapperCache(nodeProperty) {
	                var cache = new Cache();
	
	                return {
	                    get: function(node) {
	                        var wrappersByProperty = cache.get(node[nodeProperty]);
	                        if (wrappersByProperty) {
	                            for (var i = 0, wrapper; wrapper = wrappersByProperty[i++]; ) {
	                                if (wrapper.node === node) {
	                                    return wrapper;
	                                }
	                            }
	                        }
	                        return null;
	                    },
	
	                    set: function(nodeWrapper) {
	                        var property = nodeWrapper.node[nodeProperty];
	                        var wrappersByProperty = cache.get(property) || cache.set(property, []);
	                        wrappersByProperty.push(nodeWrapper);
	                    }
	                };
	            }
	
	            var uniqueIDSupported = util.isHostProperty(document.documentElement, "uniqueID");
	
	            function Session() {
	                this.initCaches();
	            }
	
	            Session.prototype = {
	                initCaches: function() {
	                    this.elementCache = uniqueIDSupported ? (function() {
	                        var elementsCache = new Cache();
	
	                        return {
	                            get: function(el) {
	                                return elementsCache.get(el.uniqueID);
	                            },
	
	                            set: function(elWrapper) {
	                                elementsCache.set(elWrapper.node.uniqueID, elWrapper);
	                            }
	                        };
	                    })() : createWrapperCache("tagName");
	
	                    // Store text nodes keyed by data, although we may need to truncate this
	                    this.textNodeCache = createWrapperCache("data");
	                    this.otherNodeCache = createWrapperCache("nodeName");
	                },
	
	                getNodeWrapper: function(node) {
	                    var wrapperCache;
	                    switch (node.nodeType) {
	                        case 1:
	                            wrapperCache = this.elementCache;
	                            break;
	                        case 3:
	                            wrapperCache = this.textNodeCache;
	                            break;
	                        default:
	                            wrapperCache = this.otherNodeCache;
	                            break;
	                    }
	
	                    var wrapper = wrapperCache.get(node);
	                    if (!wrapper) {
	                        wrapper = new NodeWrapper(node, this);
	                        wrapperCache.set(wrapper);
	                    }
	                    return wrapper;
	                },
	
	                getPosition: function(node, offset) {
	                    return this.getNodeWrapper(node).getPosition(offset);
	                },
	
	                getRangeBoundaryPosition: function(range, isStart) {
	                    var prefix = isStart ? "start" : "end";
	                    return this.getPosition(range[prefix + "Container"], range[prefix + "Offset"]);
	                },
	
	                detach: function() {
	                    this.elementCache = this.textNodeCache = this.otherNodeCache = null;
	                }
	            };
	
	            return Session;
	        })();
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function startSession() {
	            endSession();
	            return (currentSession = new Session());
	        }
	
	        function getSession() {
	            return currentSession || startSession();
	        }
	
	        function endSession() {
	            if (currentSession) {
	                currentSession.detach();
	            }
	            currentSession = null;
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Extensions to the rangy.dom utility object
	
	        extend(dom, {
	            nextNode: nextNode,
	            previousNode: previousNode
	        });
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        function createCharacterIterator(startPos, backward, endPos, characterOptions) {
	
	            // Adjust the end position to ensure that it is actually reached
	            if (endPos) {
	                if (backward) {
	                    if (isCollapsedNode(endPos.node)) {
	                        endPos = startPos.previousVisible();
	                    }
	                } else {
	                    if (isCollapsedNode(endPos.node)) {
	                        endPos = endPos.nextVisible();
	                    }
	                }
	            }
	
	            var pos = startPos, finished = false;
	
	            function next() {
	                var charPos = null;
	                if (backward) {
	                    charPos = pos;
	                    if (!finished) {
	                        pos = pos.previousVisible();
	                        finished = !pos || (endPos && pos.equals(endPos));
	                    }
	                } else {
	                    if (!finished) {
	                        charPos = pos = pos.nextVisible();
	                        finished = !pos || (endPos && pos.equals(endPos));
	                    }
	                }
	                if (finished) {
	                    pos = null;
	                }
	                return charPos;
	            }
	
	            var previousTextPos, returnPreviousTextPos = false;
	
	            return {
	                next: function() {
	                    if (returnPreviousTextPos) {
	                        returnPreviousTextPos = false;
	                        return previousTextPos;
	                    } else {
	                        var pos, character;
	                        while ( (pos = next()) ) {
	                            character = pos.getCharacter(characterOptions);
	                            if (character) {
	                                previousTextPos = pos;
	                                return pos;
	                            }
	                        }
	                        return null;
	                    }
	                },
	
	                rewind: function() {
	                    if (previousTextPos) {
	                        returnPreviousTextPos = true;
	                    } else {
	                        throw module.createError("createCharacterIterator: cannot rewind. Only one position can be rewound.");
	                    }
	                },
	
	                dispose: function() {
	                    startPos = endPos = null;
	                }
	            };
	        }
	
	        var arrayIndexOf = Array.prototype.indexOf ?
	            function(arr, val) {
	                return arr.indexOf(val);
	            } :
	            function(arr, val) {
	                for (var i = 0, len = arr.length; i < len; ++i) {
	                    if (arr[i] === val) {
	                        return i;
	                    }
	                }
	                return -1;
	            };
	
	        // Provides a pair of iterators over text positions, tokenized. Transparently requests more text when next()
	        // is called and there is no more tokenized text
	        function createTokenizedTextProvider(pos, characterOptions, wordOptions) {
	            var forwardIterator = createCharacterIterator(pos, false, null, characterOptions);
	            var backwardIterator = createCharacterIterator(pos, true, null, characterOptions);
	            var tokenizer = wordOptions.tokenizer;
	
	            // Consumes a word and the whitespace beyond it
	            function consumeWord(forward) {
	                var pos, textChar;
	                var newChars = [], it = forward ? forwardIterator : backwardIterator;
	
	                var passedWordBoundary = false, insideWord = false;
	
	                while ( (pos = it.next()) ) {
	                    textChar = pos.character;
	
	
	                    if (allWhiteSpaceRegex.test(textChar)) {
	                        if (insideWord) {
	                            insideWord = false;
	                            passedWordBoundary = true;
	                        }
	                    } else {
	                        if (passedWordBoundary) {
	                            it.rewind();
	                            break;
	                        } else {
	                            insideWord = true;
	                        }
	                    }
	                    newChars.push(pos);
	                }
	
	
	                return newChars;
	            }
	
	            // Get initial word surrounding initial position and tokenize it
	            var forwardChars = consumeWord(true);
	            var backwardChars = consumeWord(false).reverse();
	            var tokens = tokenize(backwardChars.concat(forwardChars), wordOptions, tokenizer);
	
	            // Create initial token buffers
	            var forwardTokensBuffer = forwardChars.length ?
	                tokens.slice(arrayIndexOf(tokens, forwardChars[0].token)) : [];
	
	            var backwardTokensBuffer = backwardChars.length ?
	                tokens.slice(0, arrayIndexOf(tokens, backwardChars.pop().token) + 1) : [];
	
	            function inspectBuffer(buffer) {
	                var textPositions = ["[" + buffer.length + "]"];
	                for (var i = 0; i < buffer.length; ++i) {
	                    textPositions.push("(word: " + buffer[i] + ", is word: " + buffer[i].isWord + ")");
	                }
	                return textPositions;
	            }
	
	
	            return {
	                nextEndToken: function() {
	                    var lastToken, forwardChars;
	
	                    // If we're down to the last token, consume character chunks until we have a word or run out of
	                    // characters to consume
	                    while ( forwardTokensBuffer.length == 1 &&
	                        !(lastToken = forwardTokensBuffer[0]).isWord &&
	                        (forwardChars = consumeWord(true)).length > 0) {
	
	                        // Merge trailing non-word into next word and tokenize
	                        forwardTokensBuffer = tokenize(lastToken.chars.concat(forwardChars), wordOptions, tokenizer);
	                    }
	
	                    return forwardTokensBuffer.shift();
	                },
	
	                previousStartToken: function() {
	                    var lastToken, backwardChars;
	
	                    // If we're down to the last token, consume character chunks until we have a word or run out of
	                    // characters to consume
	                    while ( backwardTokensBuffer.length == 1 &&
	                        !(lastToken = backwardTokensBuffer[0]).isWord &&
	                        (backwardChars = consumeWord(false)).length > 0) {
	
	                        // Merge leading non-word into next word and tokenize
	                        backwardTokensBuffer = tokenize(backwardChars.reverse().concat(lastToken.chars), wordOptions, tokenizer);
	                    }
	
	                    return backwardTokensBuffer.pop();
	                },
	
	                dispose: function() {
	                    forwardIterator.dispose();
	                    backwardIterator.dispose();
	                    forwardTokensBuffer = backwardTokensBuffer = null;
	                }
	            };
	        }
	
	        function movePositionBy(pos, unit, count, characterOptions, wordOptions) {
	            var unitsMoved = 0, currentPos, newPos = pos, charIterator, nextPos, absCount = Math.abs(count), token;
	            if (count !== 0) {
	                var backward = (count < 0);
	
	                switch (unit) {
	                    case CHARACTER:
	                        charIterator = createCharacterIterator(pos, backward, null, characterOptions);
	                        while ( (currentPos = charIterator.next()) && unitsMoved < absCount ) {
	                            ++unitsMoved;
	                            newPos = currentPos;
	                        }
	                        nextPos = currentPos;
	                        charIterator.dispose();
	                        break;
	                    case WORD:
	                        var tokenizedTextProvider = createTokenizedTextProvider(pos, characterOptions, wordOptions);
	                        var next = backward ? tokenizedTextProvider.previousStartToken : tokenizedTextProvider.nextEndToken;
	
	                        while ( (token = next()) && unitsMoved < absCount ) {
	                            if (token.isWord) {
	                                ++unitsMoved;
	                                newPos = backward ? token.chars[0] : token.chars[token.chars.length - 1];
	                            }
	                        }
	                        break;
	                    default:
	                        throw new Error("movePositionBy: unit '" + unit + "' not implemented");
	                }
	
	                // Perform any necessary position tweaks
	                if (backward) {
	                    newPos = newPos.previousVisible();
	                    unitsMoved = -unitsMoved;
	                } else if (newPos && newPos.isLeadingSpace && !newPos.isTrailingSpace) {
	                    // Tweak the position for the case of a leading space. The problem is that an uncollapsed leading space
	                    // before a block element (for example, the line break between "1" and "2" in the following HTML:
	                    // "1<p>2</p>") is considered to be attached to the position immediately before the block element, which
	                    // corresponds with a different selection position in most browsers from the one we want (i.e. at the
	                    // start of the contents of the block element). We get round this by advancing the position returned to
	                    // the last possible equivalent visible position.
	                    if (unit == WORD) {
	                        charIterator = createCharacterIterator(pos, false, null, characterOptions);
	                        nextPos = charIterator.next();
	                        charIterator.dispose();
	                    }
	                    if (nextPos) {
	                        newPos = nextPos.previousVisible();
	                    }
	                }
	            }
	
	
	            return {
	                position: newPos,
	                unitsMoved: unitsMoved
	            };
	        }
	
	        function createRangeCharacterIterator(session, range, characterOptions, backward) {
	            var rangeStart = session.getRangeBoundaryPosition(range, true);
	            var rangeEnd = session.getRangeBoundaryPosition(range, false);
	            var itStart = backward ? rangeEnd : rangeStart;
	            var itEnd = backward ? rangeStart : rangeEnd;
	
	            return createCharacterIterator(itStart, !!backward, itEnd, characterOptions);
	        }
	
	        function getRangeCharacters(session, range, characterOptions) {
	
	            var chars = [], it = createRangeCharacterIterator(session, range, characterOptions), pos;
	            while ( (pos = it.next()) ) {
	                chars.push(pos);
	            }
	
	            it.dispose();
	            return chars;
	        }
	
	        function isWholeWord(startPos, endPos, wordOptions) {
	            var range = api.createRange(startPos.node);
	            range.setStartAndEnd(startPos.node, startPos.offset, endPos.node, endPos.offset);
	            return !range.expand("word", { wordOptions: wordOptions });
	        }
	
	        function findTextFromPosition(initialPos, searchTerm, isRegex, searchScopeRange, findOptions) {
	            var backward = isDirectionBackward(findOptions.direction);
	            var it = createCharacterIterator(
	                initialPos,
	                backward,
	                initialPos.session.getRangeBoundaryPosition(searchScopeRange, backward),
	                findOptions.characterOptions
	            );
	            var text = "", chars = [], pos, currentChar, matchStartIndex, matchEndIndex;
	            var result, insideRegexMatch;
	            var returnValue = null;
	
	            function handleMatch(startIndex, endIndex) {
	                var startPos = chars[startIndex].previousVisible();
	                var endPos = chars[endIndex - 1];
	                var valid = (!findOptions.wholeWordsOnly || isWholeWord(startPos, endPos, findOptions.wordOptions));
	
	                return {
	                    startPos: startPos,
	                    endPos: endPos,
	                    valid: valid
	                };
	            }
	
	            while ( (pos = it.next()) ) {
	                currentChar = pos.character;
	                if (!isRegex && !findOptions.caseSensitive) {
	                    currentChar = currentChar.toLowerCase();
	                }
	
	                if (backward) {
	                    chars.unshift(pos);
	                    text = currentChar + text;
	                } else {
	                    chars.push(pos);
	                    text += currentChar;
	                }
	
	                if (isRegex) {
	                    result = searchTerm.exec(text);
	                    if (result) {
	                        matchStartIndex = result.index;
	                        matchEndIndex = matchStartIndex + result[0].length;
	                        if (insideRegexMatch) {
	                            // Check whether the match is now over
	                            if ((!backward && matchEndIndex < text.length) || (backward && matchStartIndex > 0)) {
	                                returnValue = handleMatch(matchStartIndex, matchEndIndex);
	                                break;
	                            }
	                        } else {
	                            insideRegexMatch = true;
	                        }
	                    }
	                } else if ( (matchStartIndex = text.indexOf(searchTerm)) != -1 ) {
	                    returnValue = handleMatch(matchStartIndex, matchStartIndex + searchTerm.length);
	                    break;
	                }
	            }
	
	            // Check whether regex match extends to the end of the range
	            if (insideRegexMatch) {
	                returnValue = handleMatch(matchStartIndex, matchEndIndex);
	            }
	            it.dispose();
	
	            return returnValue;
	        }
	
	        function createEntryPointFunction(func) {
	            return function() {
	                var sessionRunning = !!currentSession;
	                var session = getSession();
	                var args = [session].concat( util.toArray(arguments) );
	                var returnValue = func.apply(this, args);
	                if (!sessionRunning) {
	                    endSession();
	                }
	                return returnValue;
	            };
	        }
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Extensions to the Rangy Range object
	
	        function createRangeBoundaryMover(isStart, collapse) {
	            /*
	             Unit can be "character" or "word"
	             Options:
	
	             - includeTrailingSpace
	             - wordRegex
	             - tokenizer
	             - collapseSpaceBeforeLineBreak
	             */
	            return createEntryPointFunction(
	                function(session, unit, count, moveOptions) {
	                    if (typeof count == UNDEF) {
	                        count = unit;
	                        unit = CHARACTER;
	                    }
	                    moveOptions = createNestedOptions(moveOptions, defaultMoveOptions);
	
	                    var boundaryIsStart = isStart;
	                    if (collapse) {
	                        boundaryIsStart = (count >= 0);
	                        this.collapse(!boundaryIsStart);
	                    }
	                    var moveResult = movePositionBy(session.getRangeBoundaryPosition(this, boundaryIsStart), unit, count, moveOptions.characterOptions, moveOptions.wordOptions);
	                    var newPos = moveResult.position;
	                    this[boundaryIsStart ? "setStart" : "setEnd"](newPos.node, newPos.offset);
	                    return moveResult.unitsMoved;
	                }
	            );
	        }
	
	        function createRangeTrimmer(isStart) {
	            return createEntryPointFunction(
	                function(session, characterOptions) {
	                    characterOptions = createOptions(characterOptions, defaultCharacterOptions);
	                    var pos;
	                    var it = createRangeCharacterIterator(session, this, characterOptions, !isStart);
	                    var trimCharCount = 0;
	                    while ( (pos = it.next()) && allWhiteSpaceRegex.test(pos.character) ) {
	                        ++trimCharCount;
	                    }
	                    it.dispose();
	                    var trimmed = (trimCharCount > 0);
	                    if (trimmed) {
	                        this[isStart ? "moveStart" : "moveEnd"](
	                            "character",
	                            isStart ? trimCharCount : -trimCharCount,
	                            { characterOptions: characterOptions }
	                        );
	                    }
	                    return trimmed;
	                }
	            );
	        }
	
	        extend(api.rangePrototype, {
	            moveStart: createRangeBoundaryMover(true, false),
	
	            moveEnd: createRangeBoundaryMover(false, false),
	
	            move: createRangeBoundaryMover(true, true),
	
	            trimStart: createRangeTrimmer(true),
	
	            trimEnd: createRangeTrimmer(false),
	
	            trim: createEntryPointFunction(
	                function(session, characterOptions) {
	                    var startTrimmed = this.trimStart(characterOptions), endTrimmed = this.trimEnd(characterOptions);
	                    return startTrimmed || endTrimmed;
	                }
	            ),
	
	            expand: createEntryPointFunction(
	                function(session, unit, expandOptions) {
	                    var moved = false;
	                    expandOptions = createNestedOptions(expandOptions, defaultExpandOptions);
	                    var characterOptions = expandOptions.characterOptions;
	                    if (!unit) {
	                        unit = CHARACTER;
	                    }
	                    if (unit == WORD) {
	                        var wordOptions = expandOptions.wordOptions;
	                        var startPos = session.getRangeBoundaryPosition(this, true);
	                        var endPos = session.getRangeBoundaryPosition(this, false);
	
	                        var startTokenizedTextProvider = createTokenizedTextProvider(startPos, characterOptions, wordOptions);
	                        var startToken = startTokenizedTextProvider.nextEndToken();
	                        var newStartPos = startToken.chars[0].previousVisible();
	                        var endToken, newEndPos;
	
	                        if (this.collapsed) {
	                            endToken = startToken;
	                        } else {
	                            var endTokenizedTextProvider = createTokenizedTextProvider(endPos, characterOptions, wordOptions);
	                            endToken = endTokenizedTextProvider.previousStartToken();
	                        }
	                        newEndPos = endToken.chars[endToken.chars.length - 1];
	
	                        if (!newStartPos.equals(startPos)) {
	                            this.setStart(newStartPos.node, newStartPos.offset);
	                            moved = true;
	                        }
	                        if (newEndPos && !newEndPos.equals(endPos)) {
	                            this.setEnd(newEndPos.node, newEndPos.offset);
	                            moved = true;
	                        }
	
	                        if (expandOptions.trim) {
	                            if (expandOptions.trimStart) {
	                                moved = this.trimStart(characterOptions) || moved;
	                            }
	                            if (expandOptions.trimEnd) {
	                                moved = this.trimEnd(characterOptions) || moved;
	                            }
	                        }
	
	                        return moved;
	                    } else {
	                        return this.moveEnd(CHARACTER, 1, expandOptions);
	                    }
	                }
	            ),
	
	            text: createEntryPointFunction(
	                function(session, characterOptions) {
	                    return this.collapsed ?
	                        "" : getRangeCharacters(session, this, createOptions(characterOptions, defaultCharacterOptions)).join("");
	                }
	            ),
	
	            selectCharacters: createEntryPointFunction(
	                function(session, containerNode, startIndex, endIndex, characterOptions) {
	                    var moveOptions = { characterOptions: characterOptions };
	                    if (!containerNode) {
	                        containerNode = getBody( this.getDocument() );
	                    }
	                    this.selectNodeContents(containerNode);
	                    this.collapse(true);
	                    this.moveStart("character", startIndex, moveOptions);
	                    this.collapse(true);
	                    this.moveEnd("character", endIndex - startIndex, moveOptions);
	                }
	            ),
	
	            // Character indexes are relative to the start of node
	            toCharacterRange: createEntryPointFunction(
	                function(session, containerNode, characterOptions) {
	                    if (!containerNode) {
	                        containerNode = getBody( this.getDocument() );
	                    }
	                    var parent = containerNode.parentNode, nodeIndex = dom.getNodeIndex(containerNode);
	                    var rangeStartsBeforeNode = (dom.comparePoints(this.startContainer, this.endContainer, parent, nodeIndex) == -1);
	                    var rangeBetween = this.cloneRange();
	                    var startIndex, endIndex;
	                    if (rangeStartsBeforeNode) {
	                        rangeBetween.setStartAndEnd(this.startContainer, this.startOffset, parent, nodeIndex);
	                        startIndex = -rangeBetween.text(characterOptions).length;
	                    } else {
	                        rangeBetween.setStartAndEnd(parent, nodeIndex, this.startContainer, this.startOffset);
	                        startIndex = rangeBetween.text(characterOptions).length;
	                    }
	                    endIndex = startIndex + this.text(characterOptions).length;
	
	                    return {
	                        start: startIndex,
	                        end: endIndex
	                    };
	                }
	            ),
	
	            findText: createEntryPointFunction(
	                function(session, searchTermParam, findOptions) {
	                    // Set up options
	                    findOptions = createNestedOptions(findOptions, defaultFindOptions);
	
	                    // Create word options if we're matching whole words only
	                    if (findOptions.wholeWordsOnly) {
	                        // We don't ever want trailing spaces for search results
	                        findOptions.wordOptions.includeTrailingSpace = false;
	                    }
	
	                    var backward = isDirectionBackward(findOptions.direction);
	
	                    // Create a range representing the search scope if none was provided
	                    var searchScopeRange = findOptions.withinRange;
	                    if (!searchScopeRange) {
	                        searchScopeRange = api.createRange();
	                        searchScopeRange.selectNodeContents(this.getDocument());
	                    }
	
	                    // Examine and prepare the search term
	                    var searchTerm = searchTermParam, isRegex = false;
	                    if (typeof searchTerm == "string") {
	                        if (!findOptions.caseSensitive) {
	                            searchTerm = searchTerm.toLowerCase();
	                        }
	                    } else {
	                        isRegex = true;
	                    }
	
	                    var initialPos = session.getRangeBoundaryPosition(this, !backward);
	
	                    // Adjust initial position if it lies outside the search scope
	                    var comparison = searchScopeRange.comparePoint(initialPos.node, initialPos.offset);
	
	                    if (comparison === -1) {
	                        initialPos = session.getRangeBoundaryPosition(searchScopeRange, true);
	                    } else if (comparison === 1) {
	                        initialPos = session.getRangeBoundaryPosition(searchScopeRange, false);
	                    }
	
	                    var pos = initialPos;
	                    var wrappedAround = false;
	
	                    // Try to find a match and ignore invalid ones
	                    var findResult;
	                    while (true) {
	                        findResult = findTextFromPosition(pos, searchTerm, isRegex, searchScopeRange, findOptions);
	
	                        if (findResult) {
	                            if (findResult.valid) {
	                                this.setStartAndEnd(findResult.startPos.node, findResult.startPos.offset, findResult.endPos.node, findResult.endPos.offset);
	                                return true;
	                            } else {
	                                // We've found a match that is not a whole word, so we carry on searching from the point immediately
	                                // after the match
	                                pos = backward ? findResult.startPos : findResult.endPos;
	                            }
	                        } else if (findOptions.wrap && !wrappedAround) {
	                            // No result found but we're wrapping around and limiting the scope to the unsearched part of the range
	                            searchScopeRange = searchScopeRange.cloneRange();
	                            pos = session.getRangeBoundaryPosition(searchScopeRange, !backward);
	                            searchScopeRange.setBoundary(initialPos.node, initialPos.offset, backward);
	                            wrappedAround = true;
	                        } else {
	                            // Nothing found and we can't wrap around, so we're done
	                            return false;
	                        }
	                    }
	                }
	            ),
	
	            pasteHtml: function(html) {
	                this.deleteContents();
	                if (html) {
	                    var frag = this.createContextualFragment(html);
	                    var lastChild = frag.lastChild;
	                    this.insertNode(frag);
	                    this.collapseAfter(lastChild);
	                }
	            }
	        });
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Extensions to the Rangy Selection object
	
	        function createSelectionTrimmer(methodName) {
	            return createEntryPointFunction(
	                function(session, characterOptions) {
	                    var trimmed = false;
	                    this.changeEachRange(function(range) {
	                        trimmed = range[methodName](characterOptions) || trimmed;
	                    });
	                    return trimmed;
	                }
	            );
	        }
	
	        extend(api.selectionPrototype, {
	            expand: createEntryPointFunction(
	                function(session, unit, expandOptions) {
	                    this.changeEachRange(function(range) {
	                        range.expand(unit, expandOptions);
	                    });
	                }
	            ),
	
	            move: createEntryPointFunction(
	                function(session, unit, count, options) {
	                    var unitsMoved = 0;
	                    if (this.focusNode) {
	                        this.collapse(this.focusNode, this.focusOffset);
	                        var range = this.getRangeAt(0);
	                        if (!options) {
	                            options = {};
	                        }
	                        options.characterOptions = createOptions(options.characterOptions, defaultCaretCharacterOptions);
	                        unitsMoved = range.move(unit, count, options);
	                        this.setSingleRange(range);
	                    }
	                    return unitsMoved;
	                }
	            ),
	
	            trimStart: createSelectionTrimmer("trimStart"),
	            trimEnd: createSelectionTrimmer("trimEnd"),
	            trim: createSelectionTrimmer("trim"),
	
	            selectCharacters: createEntryPointFunction(
	                function(session, containerNode, startIndex, endIndex, direction, characterOptions) {
	                    var range = api.createRange(containerNode);
	                    range.selectCharacters(containerNode, startIndex, endIndex, characterOptions);
	                    this.setSingleRange(range, direction);
	                }
	            ),
	
	            saveCharacterRanges: createEntryPointFunction(
	                function(session, containerNode, characterOptions) {
	                    var ranges = this.getAllRanges(), rangeCount = ranges.length;
	                    var rangeInfos = [];
	
	                    var backward = rangeCount == 1 && this.isBackward();
	
	                    for (var i = 0, len = ranges.length; i < len; ++i) {
	                        rangeInfos[i] = {
	                            characterRange: ranges[i].toCharacterRange(containerNode, characterOptions),
	                            backward: backward,
	                            characterOptions: characterOptions
	                        };
	                    }
	
	                    return rangeInfos;
	                }
	            ),
	
	            restoreCharacterRanges: createEntryPointFunction(
	                function(session, containerNode, saved) {
	                    this.removeAllRanges();
	                    for (var i = 0, len = saved.length, range, rangeInfo, characterRange; i < len; ++i) {
	                        rangeInfo = saved[i];
	                        characterRange = rangeInfo.characterRange;
	                        range = api.createRange(containerNode);
	                        range.selectCharacters(containerNode, characterRange.start, characterRange.end, rangeInfo.characterOptions);
	                        this.addRange(range, rangeInfo.backward);
	                    }
	                }
	            ),
	
	            text: createEntryPointFunction(
	                function(session, characterOptions) {
	                    var rangeTexts = [];
	                    for (var i = 0, len = this.rangeCount; i < len; ++i) {
	                        rangeTexts[i] = this.getRangeAt(i).text(characterOptions);
	                    }
	                    return rangeTexts.join("");
	                }
	            )
	        });
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        // Extensions to the core rangy object
	
	        api.innerText = function(el, characterOptions) {
	            var range = api.createRange(el);
	            range.selectNodeContents(el);
	            var text = range.text(characterOptions);
	            return text;
	        };
	
	        api.createWordIterator = function(startNode, startOffset, iteratorOptions) {
	            var session = getSession();
	            iteratorOptions = createNestedOptions(iteratorOptions, defaultWordIteratorOptions);
	            var startPos = session.getPosition(startNode, startOffset);
	            var tokenizedTextProvider = createTokenizedTextProvider(startPos, iteratorOptions.characterOptions, iteratorOptions.wordOptions);
	            var backward = isDirectionBackward(iteratorOptions.direction);
	
	            return {
	                next: function() {
	                    return backward ? tokenizedTextProvider.previousStartToken() : tokenizedTextProvider.nextEndToken();
	                },
	
	                dispose: function() {
	                    tokenizedTextProvider.dispose();
	                    this.next = function() {};
	                }
	            };
	        };
	
	        /*----------------------------------------------------------------------------------------------------------------*/
	
	        api.noMutation = function(func) {
	            var session = getSession();
	            func(session);
	            endSession();
	        };
	
	        api.noMutation.createEntryPointFunction = createEntryPointFunction;
	
	        api.textRange = {
	            isBlockNode: isBlockNode,
	            isCollapsedWhitespaceNode: isCollapsedWhitespaceNode,
	
	            createPosition: createEntryPointFunction(
	                function(session, node, offset) {
	                    return session.getPosition(node, offset);
	                }
	            )
	        };
	    });
	    
	    return rangy;
	}, this);

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// dist/editable.js